export const srdClasses = [
    {
        "slug": "barbarian",
        "name": "Barbarian",
        "hitDie": 12,
        "savingThrows": [
            "STR",
            "CON"
        ],
        "proficiencies": [
            "Light Armor",
            "Medium Armor",
            "Shields",
            "Simple Weapons",
            "Martial Weapons",
            "Saving Throw: STR",
            "Saving Throw: CON"
        ],
        "skillChoices": [
            {
                "choose": 2,
                "from": [
                    "Animal Handling",
                    "Athletics",
                    "Intimidation",
                    "Nature",
                    "Perception",
                    "Survival"
                ]
            }
        ],
        "subclass": {
            "name": "Berserker",
            "description": "For some barbarians, rage is a means to an end--that end being violence. The Path of the Berserker is a path of untrammeled fury, slick with blood. As you enter the berserker's rage, you thrill in the chaos of battle, heedless of your own health or well-being."
        },
        "features": [
            {
                "name": "Rage",
                "level": 1,
                "description": "In battle, you fight with primal ferocity. On your turn, you can enter a rage as a bonus action. While raging, you gain the following benefits if you aren't wearing heavy armor:\n- You have advantage on Strength checks and Strength saving throws.\n- When you make a melee weapon Attack using Strength, you gain a +2 bonus to the damage roll. This bonus increases as you level.\n- You have Resistance to bludgeoning, piercing, and slashing damage.\nIf you are able to cast Spells, you can't cast them or concentrate on them while raging.\nYour rage lasts for 1 minute. It ends early if you are knocked Unconscious or if Your Turn ends and you haven't attacked a hostile creature since your last turn or taken damage since then. You can also end your rage on Your Turn as a Bonus Action.\nOnce you have raged the maximum number of times for your barbarian level, you must finish a Long Rest before you can rage again. You may rage 2 times at 1st level, 3 at 3rd, 4 at 6th, 5 at 12th, and 6 at 17th."
            },
            {
                "name": "Unarmored Defense",
                "level": 1,
                "description": "While you are not wearing any armor, your Armor Class equals 10 + your Dexterity modifier + your Constitution modifier. You can use a shield and still gain this benefit."
            },
            {
                "name": "Reckless Attack",
                "level": 2,
                "description": "Starting at 2nd level, you can throw aside all concern for defense to attack with fierce desperation. When you make your first attack on your turn, you can decide to attack recklessly. Doing so gives you advantage on melee weapon attack rolls using Strength during this turn, but attack rolls against you have advantage until your next turn."
            },
            {
                "name": "Danger Sense",
                "level": 2,
                "description": "At 2nd level, you gain an uncanny sense of when things nearby aren't as they should be, giving you an edge when you dodge away from danger. You have advantage on Dexterity saving throws against effects that you can see, such as traps and spells. To gain this benefit, you can't be blinded, deafened, or incapacitated."
            },
            {
                "name": "Primal Path",
                "level": 3,
                "description": "At 3rd level, you choose a path that shapes the nature of your rage. Choose the Path of the Berserker or the Path of the Totem Warrior, both detailed at the end of the class description. Your choice grants you features at 3rd level and again at 6th, 10th, and 14th levels."
            },
            {
                "name": "Frenzy",
                "level": 3,
                "description": "Starting when you choose this path at 3rd level, you can go into a frenzy when you rage. If you do so, for the duration of your rage you can make a single melee weapon attack as a bonus action on each of your turns after this one. When your rage ends, you suffer one level of exhaustion (as described in appendix A).",
                "subclass": "Berserker"
            },
            {
                "name": "Ability Score Improvement",
                "level": 4,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Extra Attack",
                "level": 5,
                "description": "Beginning at 5th level, you can attack twice, instead of once, whenever you take the Attack action on your turn."
            },
            {
                "name": "Fast Movement",
                "level": 5,
                "description": "Starting at 5th level, your speed increases by 10 feet while you aren't wearing heavy armor."
            },
            {
                "name": "Mindless Rage",
                "level": 6,
                "description": "Beginning at 6th level, you can't be charmed or frightened while raging. If you are charmed or frightened when you enter your rage, the effect is suspended for the duration of the rage.",
                "subclass": "Berserker"
            },
            {
                "name": "Path feature",
                "level": 6,
                "description": "At 3rd level, you choose a path that shapes the nature of your rage. Choose the Path of the Berserker or the Path of the Totem Warrior, both detailed at the end of the class description. Your choice grants you features at 3rd level and again at 6th, 10th, and 14th levels."
            },
            {
                "name": "Feral Instinct",
                "level": 7,
                "description": "By 7th level, your instincts are so honed that you have advantage on initiative rolls.\nAdditionally, if you are surprised at the beginning of combat and aren't incapacitated, you can act normally on your first turn, but only if you enter your rage before doing anything else on that turn."
            },
            {
                "name": "Ability Score Improvement",
                "level": 8,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Brutal Critical (1 die)",
                "level": 9,
                "description": "Beginning at 9th level, you can roll one additional weapon damage die when determining the extra damage for a critical hit with a melee attack. This increases to two additional dice at 13th level and three additional dice at 17th level."
            },
            {
                "name": "Intimidating Presence",
                "level": 10,
                "description": "Beginning at 10th level, you can use your action to frighten someone with your menacing presence. When you do so, choose one creature that you can see within 30 feet of you. If the creature can see or hear you, it must succeed on a Wisdom saving throw (DC equal to 8 + your proficiency bonus + your Charisma modifier) or be frightened of you until the end of your next turn. On subsequent turns, you can use your action to extend the duration of this effect on the frightened creature until the end of your next turn. This effect ends if the creature ends its turn out of line of sight or more than 60 feet away from you.\n If the creature succeeds on its saving throw, you can't use this feature on that creature again for 24 hours.",
                "subclass": "Berserker"
            },
            {
                "name": "Path feature",
                "level": 10,
                "description": "At 3rd level, you choose a path that shapes the nature of your rage. Choose the Path of the Berserker or the Path of the Totem Warrior, both detailed at the end of the class description. Your choice grants you features at 3rd level and again at 6th, 10th, and 14th levels."
            },
            {
                "name": "Relentless Rage",
                "level": 11,
                "description": "Starting at 11th level, your rage can keep you fighting despite grievous wounds. If you drop to 0 hit points while you're raging and don't die outright, you can make a DC 10 Constitution saving throw. If you succeed, you drop to 1 hit point instead.\nEach time you use this feature after the first, the DC increases by 5. When you finish a short or long rest, the DC resets to 10."
            },
            {
                "name": "Ability Score Improvement",
                "level": 12,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Brutal Critical (2 dice)",
                "level": 13,
                "description": "Beginning at 9th level, you can roll one additional weapon damage die when determining the extra damage for a critical hit with a melee attack. This increases to two additional dice at 13th level and three additional dice at 17th level."
            },
            {
                "name": "Retaliation",
                "level": 14,
                "description": "Starting at 14th level, when you take damage from a creature that is within 5 feet of you, you can use your reaction to make a melee weapon Attack against that creature.",
                "subclass": "Berserker"
            },
            {
                "name": "Path feature",
                "level": 14,
                "description": "At 3rd level, you choose a path that shapes the nature of your rage. Choose the Path of the Berserker or the Path of the Totem Warrior, both detailed at the end of the class description. Your choice grants you features at 3rd level and again at 6th, 10th, and 14th levels."
            },
            {
                "name": "Persistent Rage",
                "level": 15,
                "description": "Beginning at 15th level, your rage is so fierce that it ends early only if you fall unconscious or if you choose to end it."
            },
            {
                "name": "Ability Score Improvement",
                "level": 16,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Brutal Critical (3 dice)",
                "level": 17,
                "description": "Beginning at 9th level, you can roll one additional weapon damage die when determining the extra damage for a critical hit with a melee attack. This increases to two additional dice at 13th level and three additional dice at 17th level."
            },
            {
                "name": "Indomitable Might",
                "level": 18,
                "description": "Beginning at 18th level, if your total for a Strength check is less than your Strength score, you can use that score in place of the total."
            },
            {
                "name": "Ability Score Improvement",
                "level": 19,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Primal Champion",
                "level": 20,
                "description": "At 20th level, you embody the power of the wilds. Your Strength and Constitution scores increase by 4. Your maximum for those scores is now 24."
            }
        ],
        "levels": [
            {
                "level": 1,
                "proficiencyBonus": 2,
                "classSpecific": {
                    "rage_count": 2,
                    "rage_damage_bonus": 2,
                    "brutal_critical_dice": 0
                }
            },
            {
                "level": 2,
                "proficiencyBonus": 2,
                "classSpecific": {
                    "rage_count": 2,
                    "rage_damage_bonus": 2,
                    "brutal_critical_dice": 0
                }
            },
            {
                "level": 3,
                "proficiencyBonus": 2,
                "classSpecific": {
                    "rage_count": 3,
                    "rage_damage_bonus": 2,
                    "brutal_critical_dice": 0
                }
            },
            {
                "level": 3
            },
            {
                "level": 4,
                "proficiencyBonus": 2,
                "classSpecific": {
                    "rage_count": 3,
                    "rage_damage_bonus": 2,
                    "brutal_critical_dice": 0
                }
            },
            {
                "level": 5,
                "proficiencyBonus": 3,
                "classSpecific": {
                    "rage_count": 3,
                    "rage_damage_bonus": 2,
                    "brutal_critical_dice": 0
                }
            },
            {
                "level": 6,
                "proficiencyBonus": 3,
                "classSpecific": {
                    "rage_count": 4,
                    "rage_damage_bonus": 2,
                    "brutal_critical_dice": 0
                }
            },
            {
                "level": 6
            },
            {
                "level": 7,
                "proficiencyBonus": 3,
                "classSpecific": {
                    "rage_count": 4,
                    "rage_damage_bonus": 2,
                    "brutal_critical_dice": 0
                }
            },
            {
                "level": 8,
                "proficiencyBonus": 3,
                "classSpecific": {
                    "rage_count": 4,
                    "rage_damage_bonus": 2,
                    "brutal_critical_dice": 0
                }
            },
            {
                "level": 9,
                "proficiencyBonus": 4,
                "classSpecific": {
                    "rage_count": 4,
                    "rage_damage_bonus": 3,
                    "brutal_critical_dice": 1
                }
            },
            {
                "level": 10,
                "proficiencyBonus": 4,
                "classSpecific": {
                    "rage_count": 4,
                    "rage_damage_bonus": 3,
                    "brutal_critical_dice": 1
                }
            },
            {
                "level": 10
            },
            {
                "level": 11,
                "proficiencyBonus": 4,
                "classSpecific": {
                    "rage_count": 4,
                    "rage_damage_bonus": 3,
                    "brutal_critical_dice": 1
                }
            },
            {
                "level": 12,
                "proficiencyBonus": 4,
                "classSpecific": {
                    "rage_count": 5,
                    "rage_damage_bonus": 3,
                    "brutal_critical_dice": 1
                }
            },
            {
                "level": 13,
                "proficiencyBonus": 5,
                "classSpecific": {
                    "rage_count": 5,
                    "rage_damage_bonus": 3,
                    "brutal_critical_dice": 2
                }
            },
            {
                "level": 14,
                "proficiencyBonus": 5,
                "classSpecific": {
                    "rage_count": 5,
                    "rage_damage_bonus": 3,
                    "brutal_critical_dice": 2
                }
            },
            {
                "level": 14
            },
            {
                "level": 15,
                "proficiencyBonus": 5,
                "classSpecific": {
                    "rage_count": 5,
                    "rage_damage_bonus": 3,
                    "brutal_critical_dice": 2
                }
            },
            {
                "level": 16,
                "proficiencyBonus": 5,
                "classSpecific": {
                    "rage_count": 5,
                    "rage_damage_bonus": 4,
                    "brutal_critical_dice": 2
                }
            },
            {
                "level": 17,
                "proficiencyBonus": 6,
                "classSpecific": {
                    "rage_count": 6,
                    "rage_damage_bonus": 4,
                    "brutal_critical_dice": 3
                }
            },
            {
                "level": 18,
                "proficiencyBonus": 6,
                "classSpecific": {
                    "rage_count": 6,
                    "rage_damage_bonus": 4,
                    "brutal_critical_dice": 3
                }
            },
            {
                "level": 19,
                "proficiencyBonus": 6,
                "classSpecific": {
                    "rage_count": 6,
                    "rage_damage_bonus": 4,
                    "brutal_critical_dice": 3
                }
            },
            {
                "level": 20,
                "proficiencyBonus": 6,
                "classSpecific": {
                    "rage_count": 9999,
                    "rage_damage_bonus": 4,
                    "brutal_critical_dice": 3
                }
            }
        ]
    },
    {
        "slug": "bard",
        "name": "Bard",
        "hitDie": 8,
        "savingThrows": [
            "DEX",
            "CHA"
        ],
        "proficiencies": [
            "Light Armor",
            "Simple Weapons",
            "Longswords",
            "Rapiers",
            "Shortswords",
            "Hand crossbows",
            "Saving Throw: DEX",
            "Saving Throw: CHA"
        ],
        "skillChoices": [
            {
                "choose": 3,
                "from": [
                    "Acrobatics",
                    "Animal Handling",
                    "Arcana",
                    "Athletics",
                    "Deception",
                    "History",
                    "Insight",
                    "Intimidation",
                    "Investigation",
                    "Medicine",
                    "Nature",
                    "Perception",
                    "Performance",
                    "Persuasion",
                    "Religion",
                    "Sleight of Hand",
                    "Stealth",
                    "Survival"
                ]
            }
        ],
        "subclass": {
            "name": "Lore",
            "description": "Bards of the College of Lore know something about most things, collecting bits of knowledge from sources as diverse as scholarly tomes and peasant tales. Whether singing folk ballads in taverns or elaborate compositions in royal courts, these bards use their gifts to hold audiences spellbound. When the applause dies down, the audience members might find themselves questioning everything they held to be true, from their faith in the priesthood of the local temple to their loyalty to the king. The loyalty of these bards lies in the pursuit of beauty and truth, not in fealty to a monarch or following the tenets of a deity. A noble who keeps such a bard as a herald or advisor knows that the bard would rather be honest than politic. The college's members gather in libraries and sometimes in actual colleges, complete with classrooms and dormitories, to share their lore with one another. They also meet at festivals or affairs of state, where they can expose corruption, unravel lies, and poke fun at self-important figures of authority."
        },
        "features": [
            {
                "name": "Spellcasting: Bard",
                "level": 1,
                "description": "You have learned to untangle and reshape the fabric of reality in harmony with your wishes and music. Your spells are part of your vast repertoire, magic that you can tune to different situations."
            },
            {
                "name": "Bardic Inspiration (d6)",
                "level": 1,
                "description": "You can inspire others through stirring words or music. To do so, you use a bonus action on your turn to choose one creature other than yourself within 60 feet of you who can hear you. That creature gains one Bardic Inspiration die, a d6. Once within the next 10 minutes, the creature can roll the die and add the number rolled to one ability check, attack roll, or saving throw it makes. The creature can wait until after it rolls the d20 before deciding to use the Bardic Inspiration die, but must decide before the GM says whether the roll succeeds or fails. Once the Bardic Inspiration die is rolled, it is lost. A creature can have only one Bardic Inspiration die at a time.\nYou can use this feature a number of times equal to your Charisma modifier (a minimum of once). You regain any expended uses when you finish a long rest. \nYour Bardic Inspiration die changes when you reach certain levels in this class. The die becomes a d8 at 5th level, a d10 at 10th level, and a d12 at 15th level."
            },
            {
                "name": "Jack of All Trades",
                "level": 2,
                "description": "Starting at 2nd level, you can add half your proficiency bonus, rounded down, to any ability check you make that doesn't already include your proficiency bonus."
            },
            {
                "name": "Song of Rest (d6)",
                "level": 2,
                "description": "Beginning at 2nd level, you can use soothing music or oration to help revitalize your wounded allies during a short rest. If you or any friendly creatures who can hear your performance regain hit points at the end of the short rest by spending one or more Hit Dice, each of those creatures regains an extra 1d6 hit points. \nThe extra hit points increase when you reach certain levels in this class: to 1d8 at 9th level, to 1d10 at 13th level, and to 1d12 at 17th level."
            },
            {
                "name": "Bard College",
                "level": 3,
                "description": "At 3rd level, you delve into the advanced techniques of a bard college of your choice, such as the College of Lore. Your choice grants you features at 3rd level and again at 6th and 14th level."
            },
            {
                "name": "Bonus Proficiencies",
                "level": 3,
                "description": "When you join the College of Lore at 3rd level, you gain proficiency with three skills of your choice.",
                "subclass": "Lore"
            },
            {
                "name": "Cutting Words",
                "level": 3,
                "description": "Also at 3rd level, you learn how to use your wit to distract, confuse, and otherwise sap the confidence and competence of others.\nWhen a creature that you can see within 60 feet of you makes an attack roll, an ability check, or a damage roll, you can use your reaction to expend one of your uses of Bardic Inspiration, rolling a Bardic Inspiration die and subtracting the number rolled from the creature's roll.\nYou can choose to use this feature after the creature makes its roll, but before the GM determines whether the attack roll or ability check succeeds or fails, or before the creature deals its damage. The creature is immune if it can't hear you or if it's immune to being charmed.",
                "subclass": "Lore"
            },
            {
                "name": "Expertise",
                "level": 3,
                "description": "At 3rd level, choose two of your skill proficiencies. Your proficiency bonus is doubled for any ability check you make that uses either of the chosen proficiencies. At 10th level, you can choose another two skill proficiencies to gain this benefit."
            },
            {
                "name": "Ability Score Improvement",
                "level": 4,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Bardic Inspiration (d8)",
                "level": 5,
                "description": "You can inspire others through stirring words or music. To do so, you use a bonus action on your turn to choose one creature other than yourself within 60 feet of you who can hear you. That creature gains one Bardic Inspiration die, a d6. Once within the next 10 minutes, the creature can roll the die and add the number rolled to one ability check, attack roll, or saving throw it makes. The creature can wait until after it rolls the d20 before deciding to use the Bardic Inspiration die, but must decide before the GM says whether the roll succeeds or fails. Once the Bardic Inspiration die is rolled, it is lost. A creature can have only one Bardic Inspiration die at a time.\nYou can use this feature a number of times equal to your Charisma modifier (a minimum of once). You regain any expended uses when you finish a long rest. \nYour Bardic Inspiration die changes when you reach certain levels in this class. The die becomes a d8 at 5th level, a d10 at 10th level, and a d12 at 15th level."
            },
            {
                "name": "Font of Inspiration",
                "level": 5,
                "description": "Beginning when you reach 5th level, you regain all of your expended uses of Bardic Inspiration when you finish a short or long rest."
            },
            {
                "name": "Countercharm",
                "level": 6,
                "description": "At 6th level, you gain the ability to use musical notes or words of power to disrupt mind-influencing effects. As an action, you can start a performance that lasts until the end of your next turn. During that time, you and any friendly creatures within 30 feet of you have advantage on saving throws against being frightened or charmed. A creature must be able to hear you to gain this benefit. The performance ends early if you are incapacitated or silenced or if you voluntarily end it (no action required)."
            },
            {
                "name": "Bard College feature",
                "level": 6,
                "description": "At 3rd level, you delve into the advanced techniques of a bard college of your choice, such as the College of Lore. Your choice grants you features at 3rd level and again at 6th and 14th level."
            },
            {
                "name": "Additional Magical Secrets",
                "level": 6,
                "description": "At 6th level, you learn two spells of your choice from any class. A spell you choose must be of a level you can cast, as shown on the Bard table, or a cantrip. The chosen spells count as bard spells for you but don't count against the number of bard spells you know.",
                "subclass": "Lore"
            },
            {
                "name": "Ability Score Improvement",
                "level": 8,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Song of Rest (d8)",
                "level": 9,
                "description": "Beginning at 2nd level, you can use soothing music or oration to help revitalize your wounded allies during a short rest. If you or any friendly creatures who can hear your performance regain hit points at the end of the short rest by spending one or more Hit Dice, each of those creatures regains an extra 1d6 hit points. \nThe extra hit points increase when you reach certain levels in this class: to 1d8 at 9th level, to 1d10 at 13th level, and to 1d12 at 17th level."
            },
            {
                "name": "Bardic Inspiration (d10)",
                "level": 10,
                "description": "You can inspire others through stirring words or music. To do so, you use a bonus action on your turn to choose one creature other than yourself within 60 feet of you who can hear you. That creature gains one Bardic Inspiration die, a d6. Once within the next 10 minutes, the creature can roll the die and add the number rolled to one ability check, attack roll, or saving throw it makes. The creature can wait until after it rolls the d20 before deciding to use the Bardic Inspiration die, but must decide before the GM says whether the roll succeeds or fails. Once the Bardic Inspiration die is rolled, it is lost. A creature can have only one Bardic Inspiration die at a time.\nYou can use this feature a number of times equal to your Charisma modifier (a minimum of once). You regain any expended uses when you finish a long rest. \nYour Bardic Inspiration die changes when you reach certain levels in this class. The die becomes a d8 at 5th level, a d10 at 10th level, and a d12 at 15th level."
            },
            {
                "name": "Expertise",
                "level": 10,
                "description": "At 3rd level, choose two of your skill proficiencies. Your proficiency bonus is doubled for any ability check you make that uses either of the chosen proficiencies. At 10th level, you can choose another two skill proficiencies to gain this benefit."
            },
            {
                "name": "Magical Secrets",
                "level": 10,
                "description": "By 10th level, you have plundered magical knowledge from a wide spectrum of disciplines. Choose two spells from any class, including this one. A spell you choose must be of a level you can cast, as shown on the Bard table, or a cantrip. \nThe chosen spells count as bard spells for you and are included in the number in the Spells Known column of the Bard table. \nYou learn two additional spells from any class at 14th level and again at 18th level."
            },
            {
                "name": "Ability Score Improvement",
                "level": 12,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Song of Rest (d10)",
                "level": 13,
                "description": "Beginning at 2nd level, you can use soothing music or oration to help revitalize your wounded allies during a short rest. If you or any friendly creatures who can hear your performance regain hit points at the end of the short rest by spending one or more Hit Dice, each of those creatures regains an extra 1d6 hit points. \nThe extra hit points increase when you reach certain levels in this class: to 1d8 at 9th level, to 1d10 at 13th level, and to 1d12 at 17th level."
            },
            {
                "name": "Magical Secrets",
                "level": 14,
                "description": "By 10th level, you have plundered magical knowledge from a wide spectrum of disciplines. Choose two spells from any class, including this one. A spell you choose must be of a level you can cast, as shown on the Bard table, or a cantrip. \nThe chosen spells count as bard spells for you and are included in the number in the Spells Known column of the Bard table. \nYou learn two additional spells from any class at 14th level and again at 18th level."
            },
            {
                "name": "Bard College feature",
                "level": 14,
                "description": "At 3rd level, you delve into the advanced techniques of a bard college of your choice, such as the College of Lore. Your choice grants you features at 3rd level and again at 6th and 14th level."
            },
            {
                "name": "Peerless Skill",
                "level": 14,
                "description": "Starting at 14th level, when you make an ability check, you can expend one use of Bardic Inspiration. Roll a Bardic Inspiration die and add the number rolled to your ability check. You can choose to do so after you roll the die for the ability check, but before the GM tells you whether you succeed or fail.",
                "subclass": "Lore"
            },
            {
                "name": "Bardic Inspiration (d12)",
                "level": 15,
                "description": "You can inspire others through stirring words or music. To do so, you use a bonus action on your turn to choose one creature other than yourself within 60 feet of you who can hear you. That creature gains one Bardic Inspiration die, a d6. Once within the next 10 minutes, the creature can roll the die and add the number rolled to one ability check, attack roll, or saving throw it makes. The creature can wait until after it rolls the d20 before deciding to use the Bardic Inspiration die, but must decide before the GM says whether the roll succeeds or fails. Once the Bardic Inspiration die is rolled, it is lost. A creature can have only one Bardic Inspiration die at a time.\nYou can use this feature a number of times equal to your Charisma modifier (a minimum of once). You regain any expended uses when you finish a long rest. \nYour Bardic Inspiration die changes when you reach certain levels in this class. The die becomes a d8 at 5th level, a d10 at 10th level, and a d12 at 15th level."
            },
            {
                "name": "Ability Score Improvement",
                "level": 16,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Song of Rest (d12)",
                "level": 17,
                "description": "Beginning at 2nd level, you can use soothing music or oration to help revitalize your wounded allies during a short rest. If you or any friendly creatures who can hear your performance regain hit points at the end of the short rest by spending one or more Hit Dice, each of those creatures regains an extra 1d6 hit points. \nThe extra hit points increase when you reach certain levels in this class: to 1d8 at 9th level, to 1d10 at 13th level, and to 1d12 at 17th level."
            },
            {
                "name": "Magical Secrets",
                "level": 18,
                "description": "By 10th level, you have plundered magical knowledge from a wide spectrum of disciplines. Choose two spells from any class, including this one. A spell you choose must be of a level you can cast, as shown on the Bard table, or a cantrip. \nThe chosen spells count as bard spells for you and are included in the number in the Spells Known column of the Bard table. \nYou learn two additional spells from any class at 14th level and again at 18th level."
            },
            {
                "name": "Ability Score Improvement",
                "level": 19,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Superior Inspiration",
                "level": 20,
                "description": "At 20th level, when you roll initiative and have no uses of Bardic Inspiration left, you regain one use."
            }
        ],
        "levels": [
            {
                "level": 1,
                "proficiencyBonus": 2,
                "spellcasting": {
                    "cantripsKnown": 2,
                    "spellsKnown": 4,
                    "slots": {
                        "1": 2
                    }
                },
                "classSpecific": {
                    "bardic_inspiration_die": 6,
                    "song_of_rest_die": 0,
                    "magical_secrets_max_5": 0,
                    "magical_secrets_max_7": 0,
                    "magical_secrets_max_9": 0
                }
            },
            {
                "level": 2,
                "proficiencyBonus": 2,
                "spellcasting": {
                    "cantripsKnown": 2,
                    "spellsKnown": 5,
                    "slots": {
                        "1": 3
                    }
                },
                "classSpecific": {
                    "bardic_inspiration_die": 6,
                    "song_of_rest_die": 6,
                    "magical_secrets_max_5": 0,
                    "magical_secrets_max_7": 0,
                    "magical_secrets_max_9": 0
                }
            },
            {
                "level": 3,
                "proficiencyBonus": 2,
                "spellcasting": {
                    "cantripsKnown": 2,
                    "spellsKnown": 6,
                    "slots": {
                        "1": 4,
                        "2": 2
                    }
                },
                "classSpecific": {
                    "bardic_inspiration_die": 6,
                    "song_of_rest_die": 6,
                    "magical_secrets_max_5": 0,
                    "magical_secrets_max_7": 0,
                    "magical_secrets_max_9": 0
                }
            },
            {
                "level": 3
            },
            {
                "level": 4,
                "proficiencyBonus": 2,
                "spellcasting": {
                    "cantripsKnown": 3,
                    "spellsKnown": 7,
                    "slots": {
                        "1": 4,
                        "2": 3
                    }
                },
                "classSpecific": {
                    "bardic_inspiration_die": 6,
                    "song_of_rest_die": 6,
                    "magical_secrets_max_5": 0,
                    "magical_secrets_max_7": 0,
                    "magical_secrets_max_9": 0
                }
            },
            {
                "level": 5,
                "proficiencyBonus": 3,
                "spellcasting": {
                    "cantripsKnown": 3,
                    "spellsKnown": 8,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 2
                    }
                },
                "classSpecific": {
                    "bardic_inspiration_die": 8,
                    "song_of_rest_die": 6,
                    "magical_secrets_max_5": 0,
                    "magical_secrets_max_7": 0,
                    "magical_secrets_max_9": 0
                }
            },
            {
                "level": 6,
                "proficiencyBonus": 3,
                "spellcasting": {
                    "cantripsKnown": 3,
                    "spellsKnown": 9,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3
                    }
                },
                "classSpecific": {
                    "bardic_inspiration_die": 8,
                    "song_of_rest_die": 6,
                    "magical_secrets_max_5": 0,
                    "magical_secrets_max_7": 0,
                    "magical_secrets_max_9": 0
                }
            },
            {
                "level": 6
            },
            {
                "level": 7,
                "proficiencyBonus": 3,
                "spellcasting": {
                    "cantripsKnown": 3,
                    "spellsKnown": 10,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 1
                    }
                },
                "classSpecific": {
                    "bardic_inspiration_die": 8,
                    "song_of_rest_die": 6,
                    "magical_secrets_max_5": 0,
                    "magical_secrets_max_7": 0,
                    "magical_secrets_max_9": 0
                }
            },
            {
                "level": 8,
                "proficiencyBonus": 3,
                "spellcasting": {
                    "cantripsKnown": 3,
                    "spellsKnown": 11,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 2
                    }
                },
                "classSpecific": {
                    "bardic_inspiration_die": 8,
                    "song_of_rest_die": 6,
                    "magical_secrets_max_5": 0,
                    "magical_secrets_max_7": 0,
                    "magical_secrets_max_9": 0
                }
            },
            {
                "level": 9,
                "proficiencyBonus": 4,
                "spellcasting": {
                    "cantripsKnown": 3,
                    "spellsKnown": 12,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 1
                    }
                },
                "classSpecific": {
                    "bardic_inspiration_die": 8,
                    "song_of_rest_die": 8,
                    "magical_secrets_max_5": 0,
                    "magical_secrets_max_7": 0,
                    "magical_secrets_max_9": 0
                }
            },
            {
                "level": 10,
                "proficiencyBonus": 4,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "spellsKnown": 14,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2
                    }
                },
                "classSpecific": {
                    "bardic_inspiration_die": 10,
                    "song_of_rest_die": 8,
                    "magical_secrets_max_5": 2,
                    "magical_secrets_max_7": 0,
                    "magical_secrets_max_9": 0
                }
            },
            {
                "level": 11,
                "proficiencyBonus": 4,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "spellsKnown": 15,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2,
                        "6": 1
                    }
                },
                "classSpecific": {
                    "bardic_inspiration_die": 10,
                    "song_of_rest_die": 8,
                    "magical_secrets_max_5": 2,
                    "magical_secrets_max_7": 0,
                    "magical_secrets_max_9": 0
                }
            },
            {
                "level": 12,
                "proficiencyBonus": 4,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "spellsKnown": 15,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2,
                        "6": 1
                    }
                },
                "classSpecific": {
                    "bardic_inspiration_die": 10,
                    "song_of_rest_die": 8,
                    "magical_secrets_max_5": 2,
                    "magical_secrets_max_7": 0,
                    "magical_secrets_max_9": 0
                }
            },
            {
                "level": 13,
                "proficiencyBonus": 5,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "spellsKnown": 16,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2,
                        "6": 1,
                        "7": 1
                    }
                },
                "classSpecific": {
                    "bardic_inspiration_die": 10,
                    "song_of_rest_die": 10,
                    "magical_secrets_max_5": 2,
                    "magical_secrets_max_7": 0,
                    "magical_secrets_max_9": 0
                }
            },
            {
                "level": 14,
                "proficiencyBonus": 5,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "spellsKnown": 18,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2,
                        "6": 1,
                        "7": 1
                    }
                },
                "classSpecific": {
                    "bardic_inspiration_die": 10,
                    "song_of_rest_die": 10,
                    "magical_secrets_max_5": 2,
                    "magical_secrets_max_7": 2,
                    "magical_secrets_max_9": 0
                }
            },
            {
                "level": 14
            },
            {
                "level": 15,
                "proficiencyBonus": 5,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "spellsKnown": 19,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2,
                        "6": 1,
                        "7": 1,
                        "8": 1
                    }
                },
                "classSpecific": {
                    "bardic_inspiration_die": 12,
                    "song_of_rest_die": 10,
                    "magical_secrets_max_5": 2,
                    "magical_secrets_max_7": 2,
                    "magical_secrets_max_9": 0
                }
            },
            {
                "level": 16,
                "proficiencyBonus": 5,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "spellsKnown": 19,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2,
                        "6": 1,
                        "7": 1,
                        "8": 1
                    }
                },
                "classSpecific": {
                    "bardic_inspiration_die": 12,
                    "song_of_rest_die": 10,
                    "magical_secrets_max_5": 2,
                    "magical_secrets_max_7": 2,
                    "magical_secrets_max_9": 0
                }
            },
            {
                "level": 17,
                "proficiencyBonus": 6,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "spellsKnown": 20,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2,
                        "6": 1,
                        "7": 1,
                        "8": 1,
                        "9": 1
                    }
                },
                "classSpecific": {
                    "bardic_inspiration_die": 12,
                    "song_of_rest_die": 12,
                    "magical_secrets_max_5": 2,
                    "magical_secrets_max_7": 2,
                    "magical_secrets_max_9": 0
                }
            },
            {
                "level": 18,
                "proficiencyBonus": 6,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "spellsKnown": 22,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 3,
                        "6": 1,
                        "7": 1,
                        "8": 1,
                        "9": 1
                    }
                },
                "classSpecific": {
                    "bardic_inspiration_die": 12,
                    "song_of_rest_die": 12,
                    "magical_secrets_max_5": 2,
                    "magical_secrets_max_7": 2,
                    "magical_secrets_max_9": 2
                }
            },
            {
                "level": 19,
                "proficiencyBonus": 6,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "spellsKnown": 22,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 3,
                        "6": 2,
                        "7": 1,
                        "8": 1,
                        "9": 1
                    }
                },
                "classSpecific": {
                    "bardic_inspiration_die": 12,
                    "song_of_rest_die": 12,
                    "magical_secrets_max_5": 2,
                    "magical_secrets_max_7": 2,
                    "magical_secrets_max_9": 2
                }
            },
            {
                "level": 20,
                "proficiencyBonus": 6,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "spellsKnown": 22,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 3,
                        "6": 2,
                        "7": 2,
                        "8": 1,
                        "9": 1
                    }
                },
                "classSpecific": {
                    "bardic_inspiration_die": 12,
                    "song_of_rest_die": 12,
                    "magical_secrets_max_5": 2,
                    "magical_secrets_max_7": 2,
                    "magical_secrets_max_9": 2
                }
            }
        ],
        "spellcastingAbility": "cha"
    },
    {
        "slug": "cleric",
        "name": "Cleric",
        "hitDie": 8,
        "savingThrows": [
            "WIS",
            "CHA"
        ],
        "proficiencies": [
            "Light Armor",
            "Medium Armor",
            "Shields",
            "Simple Weapons",
            "Saving Throw: WIS",
            "Saving Throw: CHA"
        ],
        "skillChoices": [
            {
                "choose": 2,
                "from": [
                    "History",
                    "Insight",
                    "Medicine",
                    "Persuasion",
                    "Religion"
                ]
            }
        ],
        "subclass": {
            "name": "Life",
            "description": "The Life domain focuses on the vibrant positive energy--one of the fundamental forces of the universe--that sustains all life. The gods of life promote vitality and health through healing the sick and wounded, caring for those in need, and driving away the forces of death and undeath. Almost any non-evil deity can claim influence over this domain, particularly agricultural deities, sun gods, gods of healing or endurance, and gods of home and community."
        },
        "features": [
            {
                "name": "Spellcasting: Cleric",
                "level": 1,
                "description": "As a conduit for divine power, you can cast cleric spells."
            },
            {
                "name": "Divine Domain",
                "level": 1,
                "description": "Choose one domain related to your deity, such as Knowledge, Life, Light, Nature, Tempest, Trickery, or War. Only the Life domain is detailed in the Open Game Licensed SRD. Additional Domains are described in the official rulebooks or products from other publishers.\nYour domain grants you domain spells and other features when you choose it at 1st level. It also grants you additional ways to use Channel Divinity when you gain that feature at 2nd level, and additional benefits at 6th, 8th, and 17th levels."
            },
            {
                "name": "Domain Spells",
                "level": 1,
                "description": "Each domain has a list of spells--its domain spells--that you gain at the cleric levels noted in the domain description. Once you gain a domain spell, you always have it prepared, and it doesn't count against the number of spells you can prepare each day.\nIf you have a domain spell that doesn't appear on the cleric spell list, the spell is nonetheless a cleric spell for you."
            },
            {
                "name": "Bonus Proficiency",
                "level": 1,
                "description": "When you choose this domain at 1st level, you gain proficiency with heavy armor.",
                "subclass": "Life"
            },
            {
                "name": "Disciple of Life",
                "level": 1,
                "description": "Also starting at 1st level, your healing spells are more effective. Whenever you use a spell of 1st level or higher to restore hit points to a creature, the creature regains additional hit points equal to 2 + the spell's level.",
                "subclass": "Life"
            },
            {
                "name": "Channel Divinity (1/rest)",
                "level": 2,
                "description": "At 2nd level, you gain the ability to channel divine energy directly from your deity, using that energy to fuel magical effects. You start with two such effects: Turn Undead and an effect determined by your domain. Some domains grant you additional effects as you advance in levels, as noted in the domain description.\nWhen you use your Channel Divinity, you choose which effect to create. You must then finish a short or long rest to use your Channel Divinity again.\nSome Channel Divinity effects require saving throws. When you use such an effect from this class, the DC equals your cleric spell save DC.\nBeginning at 6th level, you can use your Channel Divinity twice between rests, and beginning at 18th level, you can use it three times between rests. When you finish a short or long rest, you regain your expended uses."
            },
            {
                "name": "Channel Divinity: Turn Undead",
                "level": 2,
                "description": "As an action, you present your holy symbol and speak a prayer censuring the undead. Each undead that can see or hear you within 30 feet of you must make a Wisdom saving throw. If the creature fails its saving throw, it is turned for 1 minute or until it takes any damage.\nA turned creature must spend its turns trying to move as far away from you as it can, and it can't willingly move to a space within 30 feet of you. It also can't take reactions. For its action, it can use only the Dash action or try to escape from an effect that prevents it from moving. If there's nowhere to move, the creature can use the Dodge action."
            },
            {
                "name": "Divine Domain feature",
                "level": 2,
                "description": "Choose one domain related to your deity, such as Knowledge, Life, Light, Nature, Tempest, Trickery, or War. Only the Life domain is detailed in the Open Game Licensed SRD. Additional Domains are described in the official rulebooks or products from other publishers.\nYour domain grants you domain spells and other features when you choose it at 1st level. It also grants you additional ways to use Channel Divinity when you gain that feature at 2nd level, and additional benefits at 6th, 8th, and 17th levels."
            },
            {
                "name": "Channel Divinity: Preserve Life",
                "level": 2,
                "description": "Starting at 2nd level, you can use your Channel Divinity to heal the badly injured.\nAs an action, you present your holy symbol and evoke healing energy that can restore a number of hit points equal to five times your cleric level.\nChoose any creatures within 30 feet of you, and divide those hit points among them. This feature can restore a creature to no more than half of its hit point maximum. You can't use this feature on an undead or a construct.",
                "subclass": "Life"
            },
            {
                "name": "Domain Spells",
                "level": 3,
                "description": "Each domain has a list of spells--its domain spells--that you gain at the cleric levels noted in the domain description. Once you gain a domain spell, you always have it prepared, and it doesn't count against the number of spells you can prepare each day.\nIf you have a domain spell that doesn't appear on the cleric spell list, the spell is nonetheless a cleric spell for you."
            },
            {
                "name": "Ability Score Improvement",
                "level": 4,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Domain Spells",
                "level": 5,
                "description": "Each domain has a list of spells--its domain spells--that you gain at the cleric levels noted in the domain description. Once you gain a domain spell, you always have it prepared, and it doesn't count against the number of spells you can prepare each day.\nIf you have a domain spell that doesn't appear on the cleric spell list, the spell is nonetheless a cleric spell for you."
            },
            {
                "name": "Destroy Undead (CR 1/2 or below)",
                "level": 5,
                "description": "Starting at 5th level, when an undead fails its saving throw against your Turn Undead feature, the creature is instantly destroyed if its challenge rating is at or below a certain threshold."
            },
            {
                "name": "Channel Divinity (2/rest)",
                "level": 6,
                "description": "Beginning at 6th level, you can use your Channel Divinity twice between rests, and beginning at 18th level, you can use it three times between rests. When you finish a short or long rest, you regain your expended uses."
            },
            {
                "name": "Divine Domain feature",
                "level": 6,
                "description": "Choose one domain related to your deity, such as Knowledge, Life, Light, Nature, Tempest, Trickery, or War. Only the Life domain is detailed in the Open Game Licensed SRD. Additional Domains are described in the official rulebooks or products from other publishers.\nYour domain grants you domain spells and other features when you choose it at 1st level. It also grants you additional ways to use Channel Divinity when you gain that feature at 2nd level, and additional benefits at 6th, 8th, and 17th levels."
            },
            {
                "name": "Blessed Healer",
                "level": 6,
                "description": "Beginning at 6th level, the healing spells you cast on others heal you as well. When you cast a spell of 1st level or higher that restores hit points to a creature other than you, you regain hit points equal to 2 + the spell's level.",
                "subclass": "Life"
            },
            {
                "name": "Domain Spells",
                "level": 7,
                "description": "Each domain has a list of spells--its domain spells--that you gain at the cleric levels noted in the domain description. Once you gain a domain spell, you always have it prepared, and it doesn't count against the number of spells you can prepare each day.\nIf you have a domain spell that doesn't appear on the cleric spell list, the spell is nonetheless a cleric spell for you."
            },
            {
                "name": "Ability Score Improvement",
                "level": 8,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Destroy Undead (CR 1 or below)",
                "level": 8,
                "description": "Starting at 5th level, when an undead fails its saving throw against your Turn Undead feature, the creature is instantly destroyed if its challenge rating is at or below a certain threshold."
            },
            {
                "name": "Divine Domain feature",
                "level": 8,
                "description": "Choose one domain related to your deity, such as Knowledge, Life, Light, Nature, Tempest, Trickery, or War. Only the Life domain is detailed in the Open Game Licensed SRD. Additional Domains are described in the official rulebooks or products from other publishers.\nYour domain grants you domain spells and other features when you choose it at 1st level. It also grants you additional ways to use Channel Divinity when you gain that feature at 2nd level, and additional benefits at 6th, 8th, and 17th levels."
            },
            {
                "name": "Divine Strike",
                "level": 8,
                "description": "At 8th level, you gain the ability to infuse your weapon strikes with divine energy. Once on each of your turns when you hit a creature with a weapon attack, you can cause the attack to deal an extra 1d8 radiant damage to the target. When you reach 14th level, the extra damage increases to 2d8.",
                "subclass": "Life"
            },
            {
                "name": "Domain Spells",
                "level": 9,
                "description": "Each domain has a list of spells--its domain spells--that you gain at the cleric levels noted in the domain description. Once you gain a domain spell, you always have it prepared, and it doesn't count against the number of spells you can prepare each day.\nIf you have a domain spell that doesn't appear on the cleric spell list, the spell is nonetheless a cleric spell for you."
            },
            {
                "name": "Divine Intervention",
                "level": 10,
                "description": "Beginning at 10th level, you can call on your deity to intervene on your behalf when your need is great.\nImploring your deity's aid requires you to use your action. Describe the assistance you seek, and roll percentile dice. If you roll a number equal to or lower than your cleric level, your deity intervenes. The GM chooses the nature of the intervention; the effect of any cleric spell or cleric domain spell would be appropriate.\nIf your deity intervenes, you can't use this feature again for 7 days. Otherwise, you can use it again after you finish a long rest.\nAt 20th level, your call for intervention succeeds automatically, no roll required."
            },
            {
                "name": "Destroy Undead (CR 2 or below)",
                "level": 11,
                "description": "Starting at 5th level, when an undead fails its saving throw against your Turn Undead feature, the creature is instantly destroyed if its challenge rating is at or below a certain threshold."
            },
            {
                "name": "Ability Score Improvement",
                "level": 12,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Destroy Undead (CR 3 or below)",
                "level": 14,
                "description": "Starting at 5th level, when an undead fails its saving throw against your Turn Undead feature, the creature is instantly destroyed if its challenge rating is at or below a certain threshold."
            },
            {
                "name": "Ability Score Improvement",
                "level": 16,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Destroy Undead (CR 4 or below)",
                "level": 17,
                "description": "Starting at 5th level, when an undead fails its saving throw against your Turn Undead feature, the creature is instantly destroyed if its challenge rating is at or below a certain threshold."
            },
            {
                "name": "Divine Domain feature",
                "level": 17,
                "description": "Choose one domain related to your deity, such as Knowledge, Life, Light, Nature, Tempest, Trickery, or War. Only the Life domain is detailed in the Open Game Licensed SRD. Additional Domains are described in the official rulebooks or products from other publishers.\nYour domain grants you domain spells and other features when you choose it at 1st level. It also grants you additional ways to use Channel Divinity when you gain that feature at 2nd level, and additional benefits at 6th, 8th, and 17th levels."
            },
            {
                "name": "Supreme Healing",
                "level": 17,
                "description": "Starting at 17th level, when you would normally roll one or more dice to restore hit points with a spell, you instead use the highest number possible for each die. For example, instead of restoring 2d6 hit points to a creature, you restore 12."
            },
            {
                "name": "Channel Divinity (3/rest)",
                "level": 18,
                "description": "Beginning at 6th level, you can use your Channel Divinity twice between rests, and beginning at 18th level, you can use it three times between rests. When you finish a short or long rest, you regain your expended uses."
            },
            {
                "name": "Ability Score Improvement",
                "level": 19,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Divine Intervention Improvement",
                "level": 20,
                "description": "At 20th level, your call for intervention succeeds automatically, no roll required."
            }
        ],
        "levels": [
            {
                "level": 1,
                "proficiencyBonus": 2,
                "spellcasting": {
                    "cantripsKnown": 3,
                    "slots": {
                        "1": 2
                    }
                },
                "classSpecific": {
                    "channel_divinity_charges": 0,
                    "destroy_undead_cr": 0
                }
            },
            {
                "level": 1
            },
            {
                "level": 2,
                "proficiencyBonus": 2,
                "spellcasting": {
                    "cantripsKnown": 3,
                    "slots": {
                        "1": 3
                    }
                },
                "classSpecific": {
                    "channel_divinity_charges": 1,
                    "destroy_undead_cr": 0
                }
            },
            {
                "level": 2
            },
            {
                "level": 3,
                "proficiencyBonus": 2,
                "spellcasting": {
                    "cantripsKnown": 3,
                    "slots": {
                        "1": 4,
                        "2": 2
                    }
                },
                "classSpecific": {
                    "channel_divinity_charges": 1,
                    "destroy_undead_cr": 0
                }
            },
            {
                "level": 4,
                "proficiencyBonus": 2,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "slots": {
                        "1": 4,
                        "2": 3
                    }
                },
                "classSpecific": {
                    "channel_divinity_charges": 1,
                    "destroy_undead_cr": 0
                }
            },
            {
                "level": 5,
                "proficiencyBonus": 3,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 2
                    }
                },
                "classSpecific": {
                    "channel_divinity_charges": 1,
                    "destroy_undead_cr": 0.5
                }
            },
            {
                "level": 6,
                "proficiencyBonus": 3,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3
                    }
                },
                "classSpecific": {
                    "channel_divinity_charges": 2,
                    "destroy_undead_cr": 0.5
                }
            },
            {
                "level": 6
            },
            {
                "level": 7,
                "proficiencyBonus": 3,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 1
                    }
                },
                "classSpecific": {
                    "channel_divinity_charges": 2,
                    "destroy_undead_cr": 0.5
                }
            },
            {
                "level": 8,
                "proficiencyBonus": 3,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 2
                    }
                },
                "classSpecific": {
                    "channel_divinity_charges": 2,
                    "destroy_undead_cr": 1
                }
            },
            {
                "level": 8
            },
            {
                "level": 9,
                "proficiencyBonus": 4,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 1
                    }
                },
                "classSpecific": {
                    "channel_divinity_charges": 2,
                    "destroy_undead_cr": 1
                }
            },
            {
                "level": 10,
                "proficiencyBonus": 4,
                "spellcasting": {
                    "cantripsKnown": 5,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2
                    }
                },
                "classSpecific": {
                    "channel_divinity_charges": 2,
                    "destroy_undead_cr": 1
                }
            },
            {
                "level": 11,
                "proficiencyBonus": 4,
                "spellcasting": {
                    "cantripsKnown": 5,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2,
                        "6": 1
                    }
                },
                "classSpecific": {
                    "channel_divinity_charges": 2,
                    "destroy_undead_cr": 2
                }
            },
            {
                "level": 12,
                "proficiencyBonus": 4,
                "spellcasting": {
                    "cantripsKnown": 5,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2,
                        "6": 1
                    }
                },
                "classSpecific": {
                    "channel_divinity_charges": 2,
                    "destroy_undead_cr": 2
                }
            },
            {
                "level": 13,
                "proficiencyBonus": 5,
                "spellcasting": {
                    "cantripsKnown": 5,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2,
                        "6": 1,
                        "7": 1
                    }
                },
                "classSpecific": {
                    "channel_divinity_charges": 2,
                    "destroy_undead_cr": 2
                }
            },
            {
                "level": 14,
                "proficiencyBonus": 5,
                "spellcasting": {
                    "cantripsKnown": 5,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2,
                        "6": 1,
                        "7": 1
                    }
                },
                "classSpecific": {
                    "channel_divinity_charges": 2,
                    "destroy_undead_cr": 3
                }
            },
            {
                "level": 15,
                "proficiencyBonus": 5,
                "spellcasting": {
                    "cantripsKnown": 5,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2,
                        "6": 1,
                        "7": 1,
                        "8": 1
                    }
                },
                "classSpecific": {
                    "channel_divinity_charges": 2,
                    "destroy_undead_cr": 3
                }
            },
            {
                "level": 16,
                "proficiencyBonus": 5,
                "spellcasting": {
                    "cantripsKnown": 5,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2,
                        "6": 1,
                        "7": 1,
                        "8": 1
                    }
                },
                "classSpecific": {
                    "channel_divinity_charges": 2,
                    "destroy_undead_cr": 3
                }
            },
            {
                "level": 17,
                "proficiencyBonus": 6,
                "spellcasting": {
                    "cantripsKnown": 5,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2,
                        "6": 1,
                        "7": 1,
                        "8": 1,
                        "9": 1
                    }
                },
                "classSpecific": {
                    "channel_divinity_charges": 2,
                    "destroy_undead_cr": 4
                }
            },
            {
                "level": 17
            },
            {
                "level": 18,
                "proficiencyBonus": 6,
                "spellcasting": {
                    "cantripsKnown": 5,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 3,
                        "6": 1,
                        "7": 1,
                        "8": 1,
                        "9": 1
                    }
                },
                "classSpecific": {
                    "channel_divinity_charges": 3,
                    "destroy_undead_cr": 4
                }
            },
            {
                "level": 19,
                "proficiencyBonus": 6,
                "spellcasting": {
                    "cantripsKnown": 5,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 3,
                        "6": 2,
                        "7": 1,
                        "8": 1,
                        "9": 1
                    }
                },
                "classSpecific": {
                    "channel_divinity_charges": 3,
                    "destroy_undead_cr": 4
                }
            },
            {
                "level": 20,
                "proficiencyBonus": 6,
                "spellcasting": {
                    "cantripsKnown": 5,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 3,
                        "6": 2,
                        "7": 2,
                        "8": 1,
                        "9": 1
                    }
                },
                "classSpecific": {
                    "channel_divinity_charges": 3,
                    "destroy_undead_cr": 4
                }
            }
        ],
        "spellcastingAbility": "wis"
    },
    {
        "slug": "druid",
        "name": "Druid",
        "hitDie": 8,
        "savingThrows": [
            "INT",
            "WIS"
        ],
        "proficiencies": [
            "Light Armor",
            "Medium Armor",
            "Shields",
            "Clubs",
            "Daggers",
            "Javelins",
            "Maces",
            "Quarterstaffs",
            "Sickles",
            "Spears",
            "Darts",
            "Slings",
            "Scimitars",
            "Herbalism Kit",
            "Saving Throw: INT",
            "Saving Throw: WIS"
        ],
        "skillChoices": [
            {
                "choose": 2,
                "from": [
                    "Arcana",
                    "Animal Handling",
                    "Insight",
                    "Medicine",
                    "Nature",
                    "Perception",
                    "Religion",
                    "Survival"
                ]
            }
        ],
        "subclass": {
            "name": "Land",
            "description": "The Circle of the Land is made up of mystics and sages who safeguard ancient knowledge and rites through a vast oral tradition. These druids meet within sacred circles of trees or standing stones to whisper primal secrets in Druidic. The circle's wisest members preside as the chief priests of communities that hold to the Old Faith and serve as advisors to the rulers of those folk. As a member of this circle, your magic is influenced by the land where you were initiated into the circle's mysterious rites."
        },
        "features": [
            {
                "name": "Spellcasting: Druid",
                "level": 1,
                "description": "Drawing on the divine essence of nature itself, you can cast spells to shape that essence to your will."
            },
            {
                "name": "Druidic",
                "level": 1,
                "description": "You know Druidic, the secret language of druids. You can speak the language and use it to leave hidden messages. You and others who know this language automatically spot such a message. Others spot the message's presence with a successful DC 15 Wisdom (Perception) check but can't decipher it without magic."
            },
            {
                "name": "Wild Shape (CR 1/4 or below, no flying or swim speed)",
                "level": 2,
                "description": "Starting at 2nd level, you can use your action to magically assume the shape of a beast that you have seen before. You can use this feature twice. You regain expended uses when you finish a short or long rest.\nYour druid level determines the beasts you can transform into, as shown in the Beast Shapes table. At 2nd level, for example, you can transform into any beast that has a challenge rating of 1/4 or lower that doesn't have a flying or swimming speed.\nYou can stay in a beast shape for a number of hours equal to half your druid level (rounded down). You then revert to your normal form unless you expend another use of this feature. You can revert to your normal form earlier by using a bonus action on your turn. You automatically revert if you fall unconscious, drop to 0 hit points, or die.\nWhile you are transformed, the following rules apply:\n- Your game statistics are replaced by the statistics of the beast, but you retain your alignment, personality, and Intelligence, Wisdom, and Charisma scores. You also retain all of your skill and saving throw proficiencies, in addition to gaining those of the creature. If the creature has the same proficiency as you and the bonus in its stat block is higher than yours, use the creature's bonus instead of yours. If the creature has any legendary or lair actions, you can't use them.\n- When you transform, you assume the beast's hit points and Hit Dice. When you revert to your normal form, you return to the number of hit points you had before you transformed. However, if you revert as a result of dropping to 0 hit points, any excess damage carries over to your normal form. For example, if you take 10 damage in animal form and have only 1 hit point left, you revert and take 9 damage. As long as the excess damage doesn't reduce your normal form to 0 hit points, you aren't knocked unconscious.\n- You can't cast spells, and your ability to speak or take any action that requires hands is limited to the capabilities of your beast form. Transforming doesn't break your concentration on a spell you've already cast, however, or prevent you from taking actions that are part of a spell, such as call lightning, that you've already cast.\n- You retain the benefit of any features from your class, race, or other source and can use them if the new form is physically capable of doing so. However, you can't use any of your special senses, such as darkvision, unless your new form also has that sense.\n- You choose whether your equipment falls to the ground in your space, merges into your new form, or is worn by it. Worn equipment functions as normal, but the GM decides whether it is practical for the new form to wear a piece of equipment, based on the creature's shape and size. Your equipment doesn't change size or shape to match the new form, and any equipment that the new form can't wear must either fall to the ground or merge with it. Equipment that merges with the form has no effect until you leave the form."
            },
            {
                "name": "Druid Circle",
                "level": 2,
                "description": "At 2nd level, you choose to identify with a circle of druids, such as the Circle of the Land. Your choice grants you features at 2nd level and again at 6th, 10th, and 14th level."
            },
            {
                "name": "Circle of the Land",
                "level": 2,
                "description": "The Circle of the Land is made up of mystics and sages who safeguard ancient knowledge and rites through a vast oral tradition. These druids meet within sacred circles of trees or standing stones to whisper primal secrets in Druidic. The circle's wisest members preside as the chief priests of communities that hold to the Old Faith and serve as advisors to the rulers of those folk. As a member of this circle, your magic is influenced by the land where you were initiated into the circle's mysterious rites.",
                "subclass": "Land"
            },
            {
                "name": "Circle of the Land: Arctic",
                "level": 2,
                "description": "The Circle of the Land is made up of mystics and sages who safeguard ancient knowledge and rites through a vast oral tradition. These druids meet within sacred circles of trees or standing stones to whisper primal secrets in Druidic. The circle's wisest members preside as the chief priests of communities that hold to the Old Faith and serve as advisors to the rulers of those folk. As a member of this circle, your magic is influenced by the land where you were initiated into the circle's mysterious rites.",
                "subclass": "Land"
            },
            {
                "name": "Circle of the Land: Coast",
                "level": 2,
                "description": "The Circle of the Land is made up of mystics and sages who safeguard ancient knowledge and rites through a vast oral tradition. These druids meet within sacred circles of trees or standing stones to whisper primal secrets in Druidic. The circle's wisest members preside as the chief priests of communities that hold to the Old Faith and serve as advisors to the rulers of those folk. As a member of this circle, your magic is influenced by the land where you were initiated into the circle's mysterious rites.",
                "subclass": "Land"
            },
            {
                "name": "Circle of the Land: Desert",
                "level": 2,
                "description": "The Circle of the Land is made up of mystics and sages who safeguard ancient knowledge and rites through a vast oral tradition. These druids meet within sacred circles of trees or standing stones to whisper primal secrets in Druidic. The circle's wisest members preside as the chief priests of communities that hold to the Old Faith and serve as advisors to the rulers of those folk. As a member of this circle, your magic is influenced by the land where you were initiated into the circle's mysterious rites.",
                "subclass": "Land"
            },
            {
                "name": "Circle of the Land: Forest",
                "level": 2,
                "description": "The Circle of the Land is made up of mystics and sages who safeguard ancient knowledge and rites through a vast oral tradition. These druids meet within sacred circles of trees or standing stones to whisper primal secrets in Druidic. The circle's wisest members preside as the chief priests of communities that hold to the Old Faith and serve as advisors to the rulers of those folk. As a member of this circle, your magic is influenced by the land where you were initiated into the circle's mysterious rites.",
                "subclass": "Land"
            },
            {
                "name": "Circle of the Land: Grassland",
                "level": 2,
                "description": "The Circle of the Land is made up of mystics and sages who safeguard ancient knowledge and rites through a vast oral tradition. These druids meet within sacred circles of trees or standing stones to whisper primal secrets in Druidic. The circle's wisest members preside as the chief priests of communities that hold to the Old Faith and serve as advisors to the rulers of those folk. As a member of this circle, your magic is influenced by the land where you were initiated into the circle's mysterious rites.",
                "subclass": "Land"
            },
            {
                "name": "Circle of the Land: Mountain",
                "level": 2,
                "description": "The Circle of the Land is made up of mystics and sages who safeguard ancient knowledge and rites through a vast oral tradition. These druids meet within sacred circles of trees or standing stones to whisper primal secrets in Druidic. The circle's wisest members preside as the chief priests of communities that hold to the Old Faith and serve as advisors to the rulers of those folk. As a member of this circle, your magic is influenced by the land where you were initiated into the circle's mysterious rites.",
                "subclass": "Land"
            },
            {
                "name": "Circle of the Land: Swamp",
                "level": 2,
                "description": "The Circle of the Land is made up of mystics and sages who safeguard ancient knowledge and rites through a vast oral tradition. These druids meet within sacred circles of trees or standing stones to whisper primal secrets in Druidic. The circle's wisest members preside as the chief priests of communities that hold to the Old Faith and serve as advisors to the rulers of those folk. As a member of this circle, your magic is influenced by the land where you were initiated into the circle's mysterious rites.",
                "subclass": "Land"
            },
            {
                "name": "Bonus Cantrip",
                "level": 2,
                "description": "When you choose this circle at 2nd level, you learn one additional druid cantrip of your choice.",
                "subclass": "Land"
            },
            {
                "name": "Natural Recovery",
                "level": 2,
                "description": "Starting at 2nd level, you can regain some of your magical energy by sitting in meditation and communing with nature. During a short rest, you choose expended spell slots to recover. The spell slots can have a combined level that is equal to or less than half your druid level (rounded up), and none of the slots can be 6th level or higher. You can't use this feature again until you finish a long rest.\nFor example, when you are a 4th-level druid, you can recover up to two levels worth of spell slots. You can recover either a 2nd-level slot or two 1st-level slots.",
                "subclass": "Land"
            },
            {
                "name": "Circle Spells",
                "level": 3,
                "description": "Your mystical connection to the land infuses you with the ability to cast certain spells. At 3rd, 5th, 7th, and 9th level you gain access to circle spells connected to the land where you became a druid.\nChoose that land--arctic, coast, desert, forest, grassland, mountain, or swamp--and consult the associated list of spells.\nOnce you gain access to a circle spell, you always have it prepared, and it doesn't count against the number of spells you can prepare each day. If you gain access to a spell that doesn't appear on the druid spell list, the spell is nonetheless a druid spell for you.",
                "subclass": "Land"
            },
            {
                "name": "Wild Shape (CR 1/2 or below, no flying speed)",
                "level": 4,
                "description": "Starting at 2nd level, you can use your action to magically assume the shape of a beast that you have seen before. You can use this feature twice. You regain expended uses when you finish a short or long rest.\nYour druid level determines the beasts you can transform into, as shown in the Beast Shapes table. At 2nd level, for example, you can transform into any beast that has a challenge rating of 1/4 or lower that doesn't have a flying or swimming speed.\nYou can stay in a beast shape for a number of hours equal to half your druid level (rounded down). You then revert to your normal form unless you expend another use of this feature. You can revert to your normal form earlier by using a bonus action on your turn. You automatically revert if you fall unconscious, drop to 0 hit points, or die.\nWhile you are transformed, the following rules apply:\n- Your game statistics are replaced by the statistics of the beast, but you retain your alignment, personality, and Intelligence, Wisdom, and Charisma scores. You also retain all of your skill and saving throw proficiencies, in addition to gaining those of the creature. If the creature has the same proficiency as you and the bonus in its stat block is higher than yours, use the creature's bonus instead of yours. If the creature has any legendary or lair actions, you can't use them.\n- When you transform, you assume the beast's hit points and Hit Dice. When you revert to your normal form, you return to the number of hit points you had before you transformed. However, if you revert as a result of dropping to 0 hit points, any excess damage carries over to your normal form. For example, if you take 10 damage in animal form and have only 1 hit point left, you revert and take 9 damage. As long as the excess damage doesn't reduce your normal form to 0 hit points, you aren't knocked unconscious.\n- You can't cast spells, and your ability to speak or take any action that requires hands is limited to the capabilities of your beast form. Transforming doesn't break your concentration on a spell you've already cast, however, or prevent you from taking actions that are part of a spell, such as call lightning, that you've already cast.\n- You retain the benefit of any features from your class, race, or other source and can use them if the new form is physically capable of doing so. However, you can't use any of your special senses, such as darkvision, unless your new form also has that sense.\n- You choose whether your equipment falls to the ground in your space, merges into your new form, or is worn by it. Worn equipment functions as normal, but the GM decides whether it is practical for the new form to wear a piece of equipment, based on the creature's shape and size. Your equipment doesn't change size or shape to match the new form, and any equipment that the new form can't wear must either fall to the ground or merge with it. Equipment that merges with the form has no effect until you leave the form."
            },
            {
                "name": "Ability Score Improvement",
                "level": 4,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Circle Spells",
                "level": 5,
                "description": "Your mystical connection to the land infuses you with the ability to cast certain spells. At 3rd, 5th, 7th, and 9th level you gain access to circle spells connected to the land where you became a druid.\nChoose that land--arctic, coast, desert, forest, grassland, mountain, or swamp--and consult the associated list of spells.\nOnce you gain access to a circle spell, you always have it prepared, and it doesn't count against the number of spells you can prepare each day. If you gain access to a spell that doesn't appear on the druid spell list, the spell is nonetheless a druid spell for you.",
                "subclass": "Land"
            },
            {
                "name": "Druid Circle feature",
                "level": 6,
                "description": "At 2nd level, you choose to identify with a circle of druids, such as the Circle of the Land. Your choice grants you features at 2nd level and again at 6th, 10th, and 14th level."
            },
            {
                "name": "Land's Stride",
                "level": 6,
                "description": "Starting at 6th level, moving through nonmagical difficult terrain costs you no extra movement. You can also pass through nonmagical plants without being slowed by them and without taking damage from them if they have thorns, spines, or a similar hazard.\nIn addition, you have advantage on saving throws against plants that are magically created or manipulated to impede movement, such those created by the entangle spell.",
                "subclass": "Land"
            },
            {
                "name": "Circle Spells",
                "level": 7,
                "description": "Your mystical connection to the land infuses you with the ability to cast certain spells. At 3rd, 5th, 7th, and 9th level you gain access to circle spells connected to the land where you became a druid.\nChoose that land--arctic, coast, desert, forest, grassland, mountain, or swamp--and consult the associated list of spells.\nOnce you gain access to a circle spell, you always have it prepared, and it doesn't count against the number of spells you can prepare each day. If you gain access to a spell that doesn't appear on the druid spell list, the spell is nonetheless a druid spell for you.",
                "subclass": "Land"
            },
            {
                "name": "Wild Shape (CR 1 or below)",
                "level": 8,
                "description": "Starting at 2nd level, you can use your action to magically assume the shape of a beast that you have seen before. You can use this feature twice. You regain expended uses when you finish a short or long rest.\nYour druid level determines the beasts you can transform into, as shown in the Beast Shapes table. At 2nd level, for example, you can transform into any beast that has a challenge rating of 1/4 or lower that doesn't have a flying or swimming speed.\nYou can stay in a beast shape for a number of hours equal to half your druid level (rounded down). You then revert to your normal form unless you expend another use of this feature. You can revert to your normal form earlier by using a bonus action on your turn. You automatically revert if you fall unconscious, drop to 0 hit points, or die.\nWhile you are transformed, the following rules apply:\n- Your game statistics are replaced by the statistics of the beast, but you retain your alignment, personality, and Intelligence, Wisdom, and Charisma scores. You also retain all of your skill and saving throw proficiencies, in addition to gaining those of the creature. If the creature has the same proficiency as you and the bonus in its stat block is higher than yours, use the creature's bonus instead of yours. If the creature has any legendary or lair actions, you can't use them.\n- When you transform, you assume the beast's hit points and Hit Dice. When you revert to your normal form, you return to the number of hit points you had before you transformed. However, if you revert as a result of dropping to 0 hit points, any excess damage carries over to your normal form. For example, if you take 10 damage in animal form and have only 1 hit point left, you revert and take 9 damage. As long as the excess damage doesn't reduce your normal form to 0 hit points, you aren't knocked unconscious.\n- You can't cast spells, and your ability to speak or take any action that requires hands is limited to the capabilities of your beast form. Transforming doesn't break your concentration on a spell you've already cast, however, or prevent you from taking actions that are part of a spell, such as call lightning, that you've already cast.\n- You retain the benefit of any features from your class, race, or other source and can use them if the new form is physically capable of doing so. However, you can't use any of your special senses, such as darkvision, unless your new form also has that sense.\n- You choose whether your equipment falls to the ground in your space, merges into your new form, or is worn by it. Worn equipment functions as normal, but the GM decides whether it is practical for the new form to wear a piece of equipment, based on the creature's shape and size. Your equipment doesn't change size or shape to match the new form, and any equipment that the new form can't wear must either fall to the ground or merge with it. Equipment that merges with the form has no effect until you leave the form."
            },
            {
                "name": "Ability Score Improvement",
                "level": 8,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Circle Spells",
                "level": 9,
                "description": "Your mystical connection to the land infuses you with the ability to cast certain spells. At 3rd, 5th, 7th, and 9th level you gain access to circle spells connected to the land where you became a druid.\nChoose that land--arctic, coast, desert, forest, grassland, mountain, or swamp--and consult the associated list of spells.\nOnce you gain access to a circle spell, you always have it prepared, and it doesn't count against the number of spells you can prepare each day. If you gain access to a spell that doesn't appear on the druid spell list, the spell is nonetheless a druid spell for you.",
                "subclass": "Land"
            },
            {
                "name": "Druid Circle feature",
                "level": 10,
                "description": "At 2nd level, you choose to identify with a circle of druids, such as the Circle of the Land. Your choice grants you features at 2nd level and again at 6th, 10th, and 14th level."
            },
            {
                "name": "Nature's Ward",
                "level": 10,
                "description": "When you reach 10th level, you can't be charmed or frightened by elementals or fey, and you are immune to poison and disease.",
                "subclass": "Land"
            },
            {
                "name": "Ability Score Improvement",
                "level": 12,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Druid Circle feature",
                "level": 14,
                "description": "At 2nd level, you choose to identify with a circle of druids, such as the Circle of the Land. Your choice grants you features at 2nd level and again at 6th, 10th, and 14th level."
            },
            {
                "name": "Nature's Sanctuary",
                "level": 14,
                "description": "When you reach 14th level, creatures of the natural world sense your connection to nature and become hesitant to attack you. When a beast or plant creature attacks you, that creature must make a Wisdom saving throw against your druid spell save DC. On a failed save, the creature must choose a different target, or the attack automatically misses. On a successful save, the creature is immune to this effect for 24 hours. The creature is aware of this effect before it makes its attack against you.",
                "subclass": "Land"
            },
            {
                "name": "Ability Score Improvement",
                "level": 16,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Timeless Body",
                "level": 18,
                "description": "Starting at 18th level, the primal magic that you wield causes you to age more slowly. For every 10 years that pass, your body ages only 1 year."
            },
            {
                "name": "Beast Spells",
                "level": 18,
                "description": "Beginning at 18th level, you can cast many of your druid spells in any shape you assume using Wild Shape. You can perform the somatic and verbal components of a druid spell while in a beast shape, but you aren't able to provide material components."
            },
            {
                "name": "Ability Score Improvement",
                "level": 19,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Archdruid",
                "level": 20,
                "description": "At 20th level, you can use your Wild Shape an unlimited number of times.\nAdditionally, you can ignore the verbal and somatic components of your druid spells, as well as any material components that lack a cost and aren't consumed by a spell. You gain this benefit in both your normal shape and your beast shape from Wild Shape."
            }
        ],
        "levels": [
            {
                "level": 1,
                "proficiencyBonus": 2,
                "spellcasting": {
                    "cantripsKnown": 2,
                    "slots": {
                        "1": 2
                    }
                },
                "classSpecific": {
                    "wild_shape_max_cr": 0,
                    "wild_shape_swim": false,
                    "wild_shape_fly": false
                }
            },
            {
                "level": 2,
                "proficiencyBonus": 2,
                "spellcasting": {
                    "cantripsKnown": 2,
                    "slots": {
                        "1": 3
                    }
                },
                "classSpecific": {
                    "wild_shape_max_cr": 0.25,
                    "wild_shape_swim": false,
                    "wild_shape_fly": false
                }
            },
            {
                "level": 2
            },
            {
                "level": 3,
                "proficiencyBonus": 2,
                "spellcasting": {
                    "cantripsKnown": 2,
                    "slots": {
                        "1": 4,
                        "2": 2
                    }
                },
                "classSpecific": {
                    "wild_shape_max_cr": 0.25,
                    "wild_shape_swim": false,
                    "wild_shape_fly": false
                }
            },
            {
                "level": 4,
                "proficiencyBonus": 2,
                "spellcasting": {
                    "cantripsKnown": 3,
                    "slots": {
                        "1": 4,
                        "2": 3
                    }
                },
                "classSpecific": {
                    "wild_shape_max_cr": 0.5,
                    "wild_shape_swim": true,
                    "wild_shape_fly": false
                }
            },
            {
                "level": 5,
                "proficiencyBonus": 3,
                "spellcasting": {
                    "cantripsKnown": 3,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 2
                    }
                },
                "classSpecific": {
                    "wild_shape_max_cr": 0.5,
                    "wild_shape_swim": true,
                    "wild_shape_fly": false
                }
            },
            {
                "level": 6,
                "proficiencyBonus": 3,
                "spellcasting": {
                    "cantripsKnown": 3,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3
                    }
                },
                "classSpecific": {
                    "wild_shape_max_cr": 0.5,
                    "wild_shape_swim": true,
                    "wild_shape_fly": false
                }
            },
            {
                "level": 6
            },
            {
                "level": 7,
                "proficiencyBonus": 3,
                "spellcasting": {
                    "cantripsKnown": 3,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 1
                    }
                },
                "classSpecific": {
                    "wild_shape_max_cr": 1,
                    "wild_shape_swim": true,
                    "wild_shape_fly": false
                }
            },
            {
                "level": 8,
                "proficiencyBonus": 3,
                "spellcasting": {
                    "cantripsKnown": 3,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 2
                    }
                },
                "classSpecific": {
                    "wild_shape_max_cr": 1,
                    "wild_shape_swim": true,
                    "wild_shape_fly": true
                }
            },
            {
                "level": 9,
                "proficiencyBonus": 4,
                "spellcasting": {
                    "cantripsKnown": 3,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 1
                    }
                },
                "classSpecific": {
                    "wild_shape_max_cr": 1,
                    "wild_shape_swim": true,
                    "wild_shape_fly": true
                }
            },
            {
                "level": 10,
                "proficiencyBonus": 4,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2
                    }
                },
                "classSpecific": {
                    "wild_shape_max_cr": 1,
                    "wild_shape_swim": true,
                    "wild_shape_fly": true
                }
            },
            {
                "level": 10
            },
            {
                "level": 11,
                "proficiencyBonus": 4,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2,
                        "6": 1
                    }
                },
                "classSpecific": {
                    "wild_shape_max_cr": 1,
                    "wild_shape_swim": true,
                    "wild_shape_fly": true
                }
            },
            {
                "level": 12,
                "proficiencyBonus": 4,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2,
                        "6": 1
                    }
                },
                "classSpecific": {
                    "wild_shape_max_cr": 1,
                    "wild_shape_swim": true,
                    "wild_shape_fly": true
                }
            },
            {
                "level": 13,
                "proficiencyBonus": 5,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2,
                        "6": 1,
                        "7": 1
                    }
                },
                "classSpecific": {
                    "wild_shape_max_cr": 1,
                    "wild_shape_swim": true,
                    "wild_shape_fly": true
                }
            },
            {
                "level": 14,
                "proficiencyBonus": 5,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2,
                        "6": 1,
                        "7": 1
                    }
                },
                "classSpecific": {
                    "wild_shape_max_cr": 1,
                    "wild_shape_swim": true,
                    "wild_shape_fly": true
                }
            },
            {
                "level": 14
            },
            {
                "level": 15,
                "proficiencyBonus": 5,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2,
                        "6": 1,
                        "7": 1,
                        "8": 1
                    }
                },
                "classSpecific": {
                    "wild_shape_max_cr": 1,
                    "wild_shape_swim": true,
                    "wild_shape_fly": true
                }
            },
            {
                "level": 16,
                "proficiencyBonus": 5,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2,
                        "6": 1,
                        "7": 1,
                        "8": 1
                    }
                },
                "classSpecific": {
                    "wild_shape_max_cr": 1,
                    "wild_shape_swim": true,
                    "wild_shape_fly": true
                }
            },
            {
                "level": 17,
                "proficiencyBonus": 6,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2,
                        "6": 1,
                        "7": 1,
                        "8": 1,
                        "9": 1
                    }
                },
                "classSpecific": {
                    "wild_shape_max_cr": 1,
                    "wild_shape_swim": true,
                    "wild_shape_fly": true
                }
            },
            {
                "level": 18,
                "proficiencyBonus": 6,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 3,
                        "6": 1,
                        "7": 1,
                        "8": 1,
                        "9": 1
                    }
                },
                "classSpecific": {
                    "wild_shape_max_cr": 1,
                    "wild_shape_swim": true,
                    "wild_shape_fly": true
                }
            },
            {
                "level": 19,
                "proficiencyBonus": 6,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 3,
                        "6": 2,
                        "7": 1,
                        "8": 1,
                        "9": 1
                    }
                },
                "classSpecific": {
                    "wild_shape_max_cr": 1,
                    "wild_shape_swim": true,
                    "wild_shape_fly": true
                }
            },
            {
                "level": 20,
                "proficiencyBonus": 6,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 3,
                        "6": 2,
                        "7": 2,
                        "8": 1,
                        "9": 1
                    }
                },
                "classSpecific": {
                    "wild_shape_max_cr": 1,
                    "wild_shape_swim": true,
                    "wild_shape_fly": true
                }
            }
        ],
        "spellcastingAbility": "wis"
    },
    {
        "slug": "fighter",
        "name": "Fighter",
        "hitDie": 10,
        "savingThrows": [
            "STR",
            "CON"
        ],
        "proficiencies": [
            "All armor",
            "Shields",
            "Simple Weapons",
            "Martial Weapons",
            "Saving Throw: STR",
            "Saving Throw: CON"
        ],
        "skillChoices": [
            {
                "choose": 2,
                "from": [
                    "Acrobatics",
                    "Animal Handling",
                    "Athletics",
                    "History",
                    "Insight",
                    "Intimidation",
                    "Perception",
                    "Survival"
                ]
            }
        ],
        "subclass": {
            "name": "Champion",
            "description": "The archetypal Champion focuses on the development of raw physical power honed to deadly perfection. Those who model themselves on this archetype combine rigorous training with physical excellence to deal devastating blows."
        },
        "features": [
            {
                "name": "Fighting Style",
                "level": 1,
                "description": "You adopt a particular style of fighting as your specialty. Choose one of the following options. You can't take a Fighting Style option more than once, even if you later get to choose again."
            },
            {
                "name": "Fighting Style: Archery",
                "level": 1,
                "description": "You gain a +2 bonus to attack rolls you make with ranged weapons."
            },
            {
                "name": "Fighting Style: Defense",
                "level": 1,
                "description": "While you are wearing armor, you gain a +1 bonus to AC."
            },
            {
                "name": "Fighting Style: Dueling",
                "level": 1,
                "description": "When you are wielding a melee weapon in one hand and no other weapons, you gain a +2 bonus to damage rolls with that weapon."
            },
            {
                "name": "Fighting Style: Great Weapon Fighting",
                "level": 1,
                "description": "When you roll a 1 or 2 on a damage die for an attack you make with a melee weapon that you are wielding with two hands, you can reroll the die and must use the new roll, even if the new roll is a 1 or a 2. The weapon must have the two-handed or versatile property for you to gain this benefit."
            },
            {
                "name": "Fighting Style: Protection",
                "level": 1,
                "description": "When a creature you can see attacks a target other than you that is within 5 feet of you, you can use your reaction to impose disadvantage on the attack roll. You must be wielding a shield."
            },
            {
                "name": "Fighting Style: Two-Weapon Fighting",
                "level": 1,
                "description": "When you engage in two-weapon fighting, you can add your ability modifier to the damage of the second attack."
            },
            {
                "name": "Second Wind",
                "level": 1,
                "description": "You have a limited well of stamina that you can draw on to protect yourself from harm. On your turn, you can use a bonus action to regain hit points equal to 1d10 + your fighter level. Once you use this feature, you must finish a short or long rest before you can use it again."
            },
            {
                "name": "Action Surge (1 use)",
                "level": 2,
                "description": "Starting at 2nd level, you can push yourself beyond your normal limits for a moment. On your turn, you can take one additional action on top of your regular action and a possible bonus action.\nOnce you use this feature, you must finish a short or long rest before you can use it again. Starting at 17th level, you can use it twice before a rest, but only once on the same turn."
            },
            {
                "name": "Martial Archetype",
                "level": 3,
                "description": "At 3rd level, you choose an archetype that you strive to emulate in your combat styles and techniques, such as Champion. The archetype you choose grants you features at 3rd level and again at 7th, 10th, 15th, and 18th level."
            },
            {
                "name": "Improved Critical",
                "level": 3,
                "description": "Beginning when you choose this archetype at 3rd level, your weapon attacks score a critical hit on a roll of 19 or 20.",
                "subclass": "Champion"
            },
            {
                "name": "Ability Score Improvement",
                "level": 4,
                "description": "When you reach 4th level, and again at 6th, 8th, 12th, 14th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Extra Attack",
                "level": 5,
                "description": "Beginning at 5th level, you can attack twice, instead of once, whenever you take the Attack action on your turn. The number of attacks increases to three when you reach 11th level in this class and to four when you reach 20th level in this class."
            },
            {
                "name": "Ability Score Improvement",
                "level": 6,
                "description": "When you reach 4th level, and again at 6th, 8th, 12th, 14th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Remarkable Athlete",
                "level": 7,
                "description": "Starting at 7th level, you can add half your proficiency bonus (round up) to any Strength, Dexterity, or Constitution check you make that doesn't already use your proficiency bonus. In addition, when you make a running long jump, the distance you can cover increases by a number of feet equal to your Strength modifier.",
                "subclass": "Champion"
            },
            {
                "name": "Martial Archetype feature",
                "level": 7,
                "description": "At 3rd level, you choose an archetype that you strive to emulate in your combat styles and techniques, such as Champion. The archetype you choose grants you features at 3rd level and again at 7th, 10th, 15th, and 18th level."
            },
            {
                "name": "Ability Score Improvement",
                "level": 8,
                "description": "When you reach 4th level, and again at 6th, 8th, 12th, 14th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Indomitable (1 use)",
                "level": 9,
                "description": "Beginning at 9th level, you can reroll a saving throw that you fail. If you do so, you must use the new roll, and you can't use this feature again until you finish a long rest. You can use this feature twice between long rests starting at 13th level and three times between long rests starting at 17th level."
            },
            {
                "name": "Additional Fighting Style",
                "level": 10,
                "description": "At 10th level, you can choose a second option from the Fighting Style class feature.",
                "subclass": "Champion"
            },
            {
                "name": "Martial Archetype feature",
                "level": 10,
                "description": "At 3rd level, you choose an archetype that you strive to emulate in your combat styles and techniques, such as Champion. The archetype you choose grants you features at 3rd level and again at 7th, 10th, 15th, and 18th level."
            },
            {
                "name": "Extra Attack (2)",
                "level": 11,
                "description": "Beginning at 5th level, you can attack twice, instead of once, whenever you take the Attack action on your turn. The number of attacks increases to three when you reach 11th level in this class and to four when you reach 20th level in this class."
            },
            {
                "name": "Ability Score Improvement",
                "level": 12,
                "description": "When you reach 4th level, and again at 6th, 8th, 12th, 14th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Indomitable (2 uses)",
                "level": 13,
                "description": "Beginning at 9th level, you can reroll a saving throw that you fail. If you do so, you must use the new roll, and you can't use this feature again until you finish a long rest. You can use this feature twice between long rests starting at 13th level and three times between long rests starting at 17th level."
            },
            {
                "name": "Ability Score Improvement",
                "level": 14,
                "description": "When you reach 4th level, and again at 6th, 8th, 12th, 14th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Superior Critical",
                "level": 15,
                "description": "Starting at 15th level, your weapon attacks score a critical hit on a roll of 18-20.",
                "subclass": "Champion"
            },
            {
                "name": "Martial Archetype feature",
                "level": 15,
                "description": "At 3rd level, you choose an archetype that you strive to emulate in your combat styles and techniques, such as Champion. The archetype you choose grants you features at 3rd level and again at 7th, 10th, 15th, and 18th level."
            },
            {
                "name": "Ability Score Improvement",
                "level": 16,
                "description": "When you reach 4th level, and again at 6th, 8th, 12th, 14th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Action Surge (2 uses)",
                "level": 17,
                "description": "Starting at 2nd level, you can push yourself beyond your normal limits for a moment. On your turn, you can take one additional action on top of your regular action and a possible bonus action.\nOnce you use this feature, you must finish a short or long rest before you can use it again. Starting at 17th level, you can use it twice before a rest, but only once on the same turn."
            },
            {
                "name": "Indomitable (3 uses)",
                "level": 17,
                "description": "Beginning at 9th level, you can reroll a saving throw that you fail. If you do so, you must use the new roll, and you can't use this feature again until you finish a long rest. You can use this feature twice between long rests starting at 13th level and three times between long rests starting at 17th level."
            },
            {
                "name": "Martial Archetype feature",
                "level": 18,
                "description": "At 3rd level, you choose an archetype that you strive to emulate in your combat styles and techniques, such as Champion. The archetype you choose grants you features at 3rd level and again at 7th, 10th, 15th, and 18th level."
            },
            {
                "name": "Survivor",
                "level": 18,
                "description": "At 18th level, you attain the pinnacle of resilience in battle. At the start of each of your turns, you regain hit points equal to 5 + your Constitution modifier if you have no more than half of your hit points left. You don't gain this benefit if you have 0 hit points.",
                "subclass": "Champion"
            },
            {
                "name": "Ability Score Improvement",
                "level": 19,
                "description": "When you reach 4th level, and again at 6th, 8th, 12th, 14th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Extra Attack (3)",
                "level": 20,
                "description": "Beginning at 5th level, you can attack twice, instead of once, whenever you take the Attack action on your turn. The number of attacks increases to three when you reach 11th level in this class and to four when you reach 20th level in this class."
            }
        ],
        "levels": [
            {
                "level": 1,
                "proficiencyBonus": 2,
                "classSpecific": {
                    "action_surges": 0,
                    "indomitable_uses": 0,
                    "extra_attacks": 0
                }
            },
            {
                "level": 2,
                "proficiencyBonus": 2,
                "classSpecific": {
                    "action_surges": 1,
                    "indomitable_uses": 0,
                    "extra_attacks": 0
                }
            },
            {
                "level": 3,
                "proficiencyBonus": 2,
                "classSpecific": {
                    "action_surges": 1,
                    "indomitable_uses": 0,
                    "extra_attacks": 0
                }
            },
            {
                "level": 3
            },
            {
                "level": 4,
                "proficiencyBonus": 2,
                "classSpecific": {
                    "action_surges": 1,
                    "indomitable_uses": 0,
                    "extra_attacks": 0
                }
            },
            {
                "level": 5,
                "proficiencyBonus": 3,
                "classSpecific": {
                    "action_surges": 1,
                    "indomitable_uses": 0,
                    "extra_attacks": 1
                }
            },
            {
                "level": 6,
                "proficiencyBonus": 3,
                "classSpecific": {
                    "action_surges": 1,
                    "indomitable_uses": 0,
                    "extra_attacks": 1
                }
            },
            {
                "level": 7,
                "proficiencyBonus": 3,
                "classSpecific": {
                    "action_surges": 1,
                    "indomitable_uses": 0,
                    "extra_attacks": 1
                }
            },
            {
                "level": 7
            },
            {
                "level": 8,
                "proficiencyBonus": 3,
                "classSpecific": {
                    "action_surges": 1,
                    "indomitable_uses": 0,
                    "extra_attacks": 1
                }
            },
            {
                "level": 9,
                "proficiencyBonus": 4,
                "classSpecific": {
                    "action_surges": 1,
                    "indomitable_uses": 1,
                    "extra_attacks": 1
                }
            },
            {
                "level": 10,
                "proficiencyBonus": 4,
                "classSpecific": {
                    "action_surges": 1,
                    "indomitable_uses": 1,
                    "extra_attacks": 1
                }
            },
            {
                "level": 10
            },
            {
                "level": 11,
                "proficiencyBonus": 4,
                "classSpecific": {
                    "action_surges": 1,
                    "indomitable_uses": 1,
                    "extra_attacks": 2
                }
            },
            {
                "level": 12,
                "proficiencyBonus": 4,
                "classSpecific": {
                    "action_surges": 1,
                    "indomitable_uses": 1,
                    "extra_attacks": 2
                }
            },
            {
                "level": 13,
                "proficiencyBonus": 5,
                "classSpecific": {
                    "action_surges": 1,
                    "indomitable_uses": 2,
                    "extra_attacks": 2
                }
            },
            {
                "level": 14,
                "proficiencyBonus": 5,
                "classSpecific": {
                    "action_surges": 1,
                    "indomitable_uses": 2,
                    "extra_attacks": 2
                }
            },
            {
                "level": 15,
                "proficiencyBonus": 5,
                "classSpecific": {
                    "action_surges": 1,
                    "indomitable_uses": 2,
                    "extra_attacks": 2
                }
            },
            {
                "level": 15
            },
            {
                "level": 16,
                "proficiencyBonus": 5,
                "classSpecific": {
                    "action_surges": 1,
                    "indomitable_uses": 2,
                    "extra_attacks": 2
                }
            },
            {
                "level": 17,
                "proficiencyBonus": 6,
                "classSpecific": {
                    "action_surges": 2,
                    "indomitable_uses": 3,
                    "extra_attacks": 2
                }
            },
            {
                "level": 18,
                "proficiencyBonus": 6,
                "classSpecific": {
                    "action_surges": 2,
                    "indomitable_uses": 3,
                    "extra_attacks": 2
                }
            },
            {
                "level": 18
            },
            {
                "level": 19,
                "proficiencyBonus": 6,
                "classSpecific": {
                    "action_surges": 2,
                    "indomitable_uses": 3,
                    "extra_attacks": 2
                }
            },
            {
                "level": 20,
                "proficiencyBonus": 6,
                "classSpecific": {
                    "action_surges": 2,
                    "indomitable_uses": 3,
                    "extra_attacks": 3
                }
            }
        ]
    },
    {
        "slug": "monk",
        "name": "Monk",
        "hitDie": 8,
        "savingThrows": [
            "STR",
            "DEX"
        ],
        "proficiencies": [
            "Simple Weapons",
            "Shortswords",
            "Saving Throw: DEX",
            "Saving Throw: STR"
        ],
        "skillChoices": [
            {
                "choose": 2,
                "from": [
                    "Acrobatics",
                    "Athletics",
                    "History",
                    "Insight",
                    "Religion",
                    "Stealth"
                ]
            }
        ],
        "subclass": {
            "name": "Open Hand",
            "description": "Monks of the Way of the Open Hand are the ultimate masters of martial arts combat, whether armed or unarmed. They learn techniques to push and trip their opponents, manipulate ki to heal damage to their bodies, and practice advanced meditation that can protect them from harm."
        },
        "features": [
            {
                "name": "Unarmored Defense",
                "level": 1,
                "description": "Beginning at 1st level, while you are wearing no armor and not wielding a shield, your AC equals 10 + your Dexterity modifier + your Wisdom modifier."
            },
            {
                "name": "Martial Arts",
                "level": 1,
                "description": "At 1st level, your practice of martial arts gives you mastery of combat styles that use unarmed strikes and monk weapons, which are shortswords and any simple melee weapons that don't have the two- handed or heavy property.\nYou gain the following benefits while you are unarmed or wielding only monk weapons and you aren't wearing armor or wielding a shield:\n- You can use Dexterity instead of Strength for the attack and damage rolls of your unarmed strikes and monk weapons.\n- You can roll a d4 in place of the normal damage of your unarmed strike or monk weapon. This die changes as you gain monk levels, as shown in the Martial Arts column of Table: The Monk.\n- When you use the Attack action with an unarmed strike or a monk weapon on your turn, you can make one unarmed strike as a bonus action. For example, if you take the Attack action and attack with a quarterstaff, you can also make an unarmed strike as a bonus action, assuming you haven't already taken a bonus action this turn.\nCertain monasteries use specialized forms of the monk weapons. For example, you might use a club that is two lengths of wood connected by a short chain (called a nunchaku) or a sickle with a shorter, straighter blade (called a kama). Whatever name you use for a monk weapon, you can use the game statistics provided for the weapon."
            },
            {
                "name": "Ki",
                "level": 2,
                "description": "Starting at 2nd level, your training allows you to harness the mystic energy of ki. Your access to this energy is represented by a number of ki points. Your monk level determines the number of points you have, as shown in the Ki Points column of Table: The Monk.\nYou can spend these points to fuel various ki features. You start knowing three such features: Flurry of Blows, Patient Defense, and Step of the Wind. You learn more ki features as you gain levels in this class.\nWhen you spend a ki point, it is unavailable until you finish a short or long rest, at the end of which you draw all of your expended ki back into yourself. You must spend at least 30 minutes of the rest meditating to regain your ki points.\nSome of your ki features require your target to make a saving throw to resist the feature's effects. The saving throw DC is calculated as follows:\nKi save DC = 8 + your proficiency bonus + your Wisdom modifier"
            },
            {
                "name": "Flurry of Blows",
                "level": 2,
                "description": "Immediately after you take the Attack action on your turn, you can spend 1 ki point to make two unarmed strikes as a bonus action."
            },
            {
                "name": "Patient Defense",
                "level": 2,
                "description": "You can spend 1 ki point to take the Dodge action as a bonus action on your turn."
            },
            {
                "name": "Step of the Wind",
                "level": 2,
                "description": "You can spend 1 ki point to take the Disengage or Dash action as a bonus action on your turn, and your jump distance is doubled for the turn."
            },
            {
                "name": "Unarmored Movement",
                "level": 2,
                "description": "Starting at 2nd level, your speed increases by 10 feet while you are not wearing armor or wielding a shield. This bonus increases when you reach certain monk levels, as shown in Table: The Monk.\nAt 9th level, you gain the ability to move along vertical surfaces and across liquids on your turn without falling during the move."
            },
            {
                "name": "Monastic Tradition",
                "level": 3,
                "description": "When you reach 3rd level, you commit yourself to a monastic tradition, such as the Way of the Open Hand. Your tradition grants you features at 3rd level and again at 6th, 11th, and 17th level."
            },
            {
                "name": "Deflect Missiles",
                "level": 3,
                "description": "Starting at 3rd level, you can use your reaction to deflect or catch the missile when you are hit by a ranged weapon attack. When you do so, the damage you take from the attack is reduced by 1d10 + your Dexterity modifier + your monk level.\nIf you reduce the damage to 0, you can catch the missile if it is small enough for you to hold in one hand and you have at least one hand free. If you catch a missile in this way, you can spend 1 ki point to make a ranged attack with the weapon or piece of ammunition you just caught, as part of the same reaction. You make this attack with proficiency, regardless of your weapon proficiencies, and the missile counts as a monk weapon for the attack, which has a normal range of 20 feet and a long range of 60 feet."
            },
            {
                "name": "Open Hand Technique",
                "level": 3,
                "description": "Starting when you choose this tradition at 3rd level, you can manipulate your enemy's ki when you harness your own. Whenever you hit a creature with one of the attacks granted by your Flurry of Blows, you can impose one of the following effects on that target:\n- It must succeed on a Dexterity saving throw or be knocked prone.\n- It must make a Strength saving throw. If it fails, you can push it up to 15 feet away from you.\n- It can't take reactions until the end of your next turn.",
                "subclass": "Open Hand"
            },
            {
                "name": "Ability Score Improvement",
                "level": 4,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Slow Fall",
                "level": 4,
                "description": "Beginning at 4th level, you can use your reaction when you fall to reduce any falling damage you take by an amount equal to five times your monk level."
            },
            {
                "name": "Extra Attack",
                "level": 5,
                "description": "Beginning at 5th level, you can attack twice, instead of once, whenever you take the Attack action on your turn."
            },
            {
                "name": "Stunning Strike",
                "level": 5,
                "description": "Starting at 5th level, you can interfere with the flow of ki in an opponent's body. When you hit another creature with a melee weapon attack, you can spend 1 ki point to attempt a stunning strike. The target must succeed on a Constitution saving throw or be stunned until the end of your next turn."
            },
            {
                "name": "Ki Empowered Strikes",
                "level": 6,
                "description": "Starting at 6th level, your unarmed strikes count as magical for the purpose of overcoming resistance and immunity to nonmagical attacks and damage."
            },
            {
                "name": "Monastic Tradition feature",
                "level": 6,
                "description": "When you reach 3rd level, you commit yourself to a monastic tradition, such as the Way of the Open Hand. Your tradition grants you features at 3rd level and again at 6th, 11th, and 17th level."
            },
            {
                "name": "Wholeness of Body",
                "level": 6,
                "description": "At 6th level, you gain the ability to heal yourself. As an action, you can regain hit points equal to three times your monk level. You must finish a long rest before you can use this feature again.",
                "subclass": "Open Hand"
            },
            {
                "name": "Evasion",
                "level": 7,
                "description": "At 7th level, your instinctive agility lets you dodge out of the way of certain area effects, such as a blue dragon's lightning breath or a fireball spell. When you are subjected to an effect that allows you to make a Dexterity saving throw to take only half damage, you instead take no damage if you succeed on the saving throw, and only half damage if you fail."
            },
            {
                "name": "Stillness of Mind",
                "level": 7,
                "description": "Starting at 7th level, you can use your action to end one effect on yourself that is causing you to be charmed or frightened."
            },
            {
                "name": "Ability Score Improvement",
                "level": 8,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Unarmored Movement",
                "level": 9,
                "description": "Starting at 2nd level, your speed increases by 10 feet while you are not wearing armor or wielding a shield. This bonus increases when you reach certain monk levels, as shown in Table: The Monk.\nAt 9th level, you gain the ability to move along vertical surfaces and across liquids on your turn without falling during the move."
            },
            {
                "name": "Purity of Body",
                "level": 10,
                "description": "At 10th level, your mastery of the ki flowing through you makes you immune to disease and poison."
            },
            {
                "name": "Monastic Tradition feature",
                "level": 11,
                "description": "When you reach 3rd level, you commit yourself to a monastic tradition, such as the Way of the Open Hand. Your tradition grants you features at 3rd level and again at 6th, 11th, and 17th level."
            },
            {
                "name": "Tranquility",
                "level": 11,
                "description": "Beginning at 11th level, you can enter a special meditation that surrounds you with an aura of peace. At the end of a long rest, you gain the effect of a sanctuary spell that lasts until the start of your next long rest (the spell can end early as normal). The saving throw DC for the spell equals 8 + your Wisdom modifier + your proficiency bonus.",
                "subclass": "Open Hand"
            },
            {
                "name": "Ability Score Improvement",
                "level": 12,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Tongue of the Sun and Moon",
                "level": 13,
                "description": "Starting at 13th level, you learn to touch the ki of other minds so that you understand all spoken languages. Moreover, any creature that can understand a language can understand what you say."
            },
            {
                "name": "Diamond Soul",
                "level": 14,
                "description": "Beginning at 14th level, your mastery of ki grants you proficiency in all saving throws.\nAdditionally, whenever you make a saving throw and fail, you can spend 1 ki point to reroll it and take the second result."
            },
            {
                "name": "Timeless Body",
                "level": 15,
                "description": "At 15th level, your ki sustains you so that you suffer none of the frailty of old age, and you can't be aged magically. You can still die of old age, however. In addition, you no longer need food or water."
            },
            {
                "name": "Ability Score Improvement",
                "level": 16,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Monastic Tradition feature",
                "level": 17,
                "description": "When you reach 3rd level, you commit yourself to a monastic tradition, such as the Way of the Open Hand. Your tradition grants you features at 3rd level and again at 6th, 11th, and 17th level."
            },
            {
                "name": "Quivering Palm",
                "level": 17,
                "description": "At 17th level, you gain the ability to set up lethal vibrations in someone's body. When you hit a creature with an unarmed strike, you can spend 3 ki points to start these imperceptible vibrations, which last for a number of days equal to your monk level. The vibrations are harmless unless you use your action to end them. To do so, you and the target must be on the same plane of existence. When you use this action, the creature must make a Constitution saving throw. If it fails, it is reduced to 0 hit points. If it succeeds, it takes 10d10 necrotic damage.\nYou can have only one creature under the effect of this feature at a time. You can choose to end the vibrations harmlessly without using an action.",
                "subclass": "Open Hand"
            },
            {
                "name": "Empty Body",
                "level": 18,
                "description": "Beginning at 18th level, you can use your action to spend 4 ki points to become invisible for 1 minute. During that time, you also have resistance to all damage but force damage.\nAdditionally, you can spend 8 ki points to cast the astral projection spell, without needing material components. When you do so, you can't take any other creatures with you."
            },
            {
                "name": "Ability Score Improvement",
                "level": 19,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Perfect Self",
                "level": 20,
                "description": "At 20th level, when you roll for initiative and have no ki points remaining, you regain 4 ki points."
            }
        ],
        "levels": [
            {
                "level": 1,
                "proficiencyBonus": 2,
                "classSpecific": {
                    "martial_arts": {
                        "dice_count": 1,
                        "dice_value": 4
                    },
                    "ki_points": 0,
                    "unarmored_movement": 0
                }
            },
            {
                "level": 2,
                "proficiencyBonus": 2,
                "classSpecific": {
                    "martial_arts": {
                        "dice_count": 1,
                        "dice_value": 4
                    },
                    "ki_points": 2,
                    "unarmored_movement": 10
                }
            },
            {
                "level": 3,
                "proficiencyBonus": 2,
                "classSpecific": {
                    "martial_arts": {
                        "dice_count": 1,
                        "dice_value": 4
                    },
                    "ki_points": 3,
                    "unarmored_movement": 10
                }
            },
            {
                "level": 3
            },
            {
                "level": 4,
                "proficiencyBonus": 2,
                "classSpecific": {
                    "martial_arts": {
                        "dice_count": 1,
                        "dice_value": 4
                    },
                    "ki_points": 4,
                    "unarmored_movement": 10
                }
            },
            {
                "level": 5,
                "proficiencyBonus": 3,
                "classSpecific": {
                    "martial_arts": {
                        "dice_count": 1,
                        "dice_value": 6
                    },
                    "ki_points": 5,
                    "unarmored_movement": 10
                }
            },
            {
                "level": 6,
                "proficiencyBonus": 3,
                "classSpecific": {
                    "martial_arts": {
                        "dice_count": 1,
                        "dice_value": 6
                    },
                    "ki_points": 6,
                    "unarmored_movement": 15
                }
            },
            {
                "level": 6
            },
            {
                "level": 7,
                "proficiencyBonus": 3,
                "classSpecific": {
                    "martial_arts": {
                        "dice_count": 1,
                        "dice_value": 6
                    },
                    "ki_points": 7,
                    "unarmored_movement": 15
                }
            },
            {
                "level": 8,
                "proficiencyBonus": 3,
                "classSpecific": {
                    "martial_arts": {
                        "dice_count": 1,
                        "dice_value": 6
                    },
                    "ki_points": 8,
                    "unarmored_movement": 15
                }
            },
            {
                "level": 9,
                "proficiencyBonus": 4,
                "classSpecific": {
                    "martial_arts": {
                        "dice_count": 1,
                        "dice_value": 6
                    },
                    "ki_points": 9,
                    "unarmored_movement": 15
                }
            },
            {
                "level": 10,
                "proficiencyBonus": 4,
                "classSpecific": {
                    "martial_arts": {
                        "dice_count": 1,
                        "dice_value": 6
                    },
                    "ki_points": 10,
                    "unarmored_movement": 20
                }
            },
            {
                "level": 11,
                "proficiencyBonus": 4,
                "classSpecific": {
                    "martial_arts": {
                        "dice_count": 1,
                        "dice_value": 8
                    },
                    "ki_points": 11,
                    "unarmored_movement": 20
                }
            },
            {
                "level": 11
            },
            {
                "level": 12,
                "proficiencyBonus": 4,
                "classSpecific": {
                    "martial_arts": {
                        "dice_count": 1,
                        "dice_value": 8
                    },
                    "ki_points": 12,
                    "unarmored_movement": 20
                }
            },
            {
                "level": 13,
                "proficiencyBonus": 5,
                "classSpecific": {
                    "martial_arts": {
                        "dice_count": 1,
                        "dice_value": 8
                    },
                    "ki_points": 13,
                    "unarmored_movement": 20
                }
            },
            {
                "level": 14,
                "proficiencyBonus": 5,
                "classSpecific": {
                    "martial_arts": {
                        "dice_count": 1,
                        "dice_value": 8
                    },
                    "ki_points": 14,
                    "unarmored_movement": 25
                }
            },
            {
                "level": 15,
                "proficiencyBonus": 5,
                "classSpecific": {
                    "martial_arts": {
                        "dice_count": 1,
                        "dice_value": 8
                    },
                    "ki_points": 15,
                    "unarmored_movement": 25
                }
            },
            {
                "level": 16,
                "proficiencyBonus": 5,
                "classSpecific": {
                    "martial_arts": {
                        "dice_count": 1,
                        "dice_value": 8
                    },
                    "ki_points": 16,
                    "unarmored_movement": 25
                }
            },
            {
                "level": 17,
                "proficiencyBonus": 6,
                "classSpecific": {
                    "martial_arts": {
                        "dice_count": 1,
                        "dice_value": 10
                    },
                    "ki_points": 17,
                    "unarmored_movement": 25
                }
            },
            {
                "level": 17
            },
            {
                "level": 18,
                "proficiencyBonus": 6,
                "classSpecific": {
                    "martial_arts": {
                        "dice_count": 1,
                        "dice_value": 10
                    },
                    "ki_points": 18,
                    "unarmored_movement": 30
                }
            },
            {
                "level": 19,
                "proficiencyBonus": 6,
                "classSpecific": {
                    "martial_arts": {
                        "dice_count": 1,
                        "dice_value": 10
                    },
                    "ki_points": 19,
                    "unarmored_movement": 30
                }
            },
            {
                "level": 20,
                "proficiencyBonus": 6,
                "classSpecific": {
                    "martial_arts": {
                        "dice_count": 1,
                        "dice_value": 10
                    },
                    "ki_points": 20,
                    "unarmored_movement": 30
                }
            }
        ]
    },
    {
        "slug": "paladin",
        "name": "Paladin",
        "hitDie": 10,
        "savingThrows": [
            "WIS",
            "CHA"
        ],
        "proficiencies": [
            "All armor",
            "Shields",
            "Simple Weapons",
            "Martial Weapons",
            "Saving Throw: WIS",
            "Saving Throw: CHA"
        ],
        "skillChoices": [
            {
                "choose": 2,
                "from": [
                    "Athletics",
                    "Insight",
                    "Intimidation",
                    "Medicine",
                    "Persuasion",
                    "Religion"
                ]
            }
        ],
        "subclass": {
            "name": "Devotion",
            "description": "The Oath of Devotion binds a paladin to the loftiest ideals of justice, virtue, and order. Sometimes called cavaliers, white knights, or holy warriors, these paladins meet the ideal of the knight in shining armor, acting with honor in pursuit of justice and the greater good. They hold themselves to the highest standards of conduct, and some, for better or worse, hold the rest of the world to the same standards. Many who swear this oath are devoted to gods of law and good and use their gods' tenets as the measure of their devotion. They hold angels--the perfect servants of good--as their ideals, and incorporate images of angelic wings into their helmets or coats of arms."
        },
        "features": [
            {
                "name": "Divine Sense",
                "level": 1,
                "description": "The presence of strong evil registers on your senses like a noxious odor, and powerful good rings like heavenly music in your ears. As an action, you can open your awareness to detect such forces. Until the end of your next turn, you know the location of any celestial, fiend, or undead within 60 feet of you that is not behind total cover. You know the type (celestial, fiend, or undead) of any being whose presence you sense, but not its identity. Within the same radius, you also detect the presence of any place or object that has been consecrated or desecrated, as with the hallow spell.\nYou can use this feature a number of times equal to 1 + your Charisma modifier. When you finish a long rest, you regain all expended uses."
            },
            {
                "name": "Lay on Hands",
                "level": 1,
                "description": "Your blessed touch can heal wounds. You have a pool of healing power that replenishes when you take a long rest. With that pool, you can restore a total number of hit points equal to your paladin level x 5.\nAs an action, you can touch a creature and draw power from the pool to restore a number of hit points to that creature, up to the maximum amount remaining in your pool.\nAlternatively, you can expend 5 hit points from your pool of healing to cure the target of one disease or neutralize one poison affecting it. You can cure multiple diseases and neutralize multiple poisons with a single use of Lay on Hands, expending hit points separately for each one.\nThis feature has no effect on undead and constructs."
            },
            {
                "name": "Fighting Style",
                "level": 2,
                "description": "At 2nd level, you adopt a style of fighting as your specialty. Choose one of the following options. You can't take a Fighting Style option more than once, even if you later get to choose again."
            },
            {
                "name": "Fighting Style: Defense",
                "level": 2,
                "description": "While you are wearing armor, you gain a +1 bonus to AC."
            },
            {
                "name": "Fighting Style: Dueling",
                "level": 2,
                "description": "When you are wielding a melee weapon in one hand and no other weapons, you gain a +2 bonus to damage rolls with that weapon."
            },
            {
                "name": "Fighting Style: Great Weapon Fighting",
                "level": 2,
                "description": "When you roll a 1 or 2 on a damage die for an attack you make with a melee weapon that you are wielding with two hands, you can reroll the die and must use the new roll. The weapon must have the two-handed or versatile property for you to gain this benefit."
            },
            {
                "name": "Fighting Style: Protection",
                "level": 2,
                "description": "When a creature you can see attacks a target other than you that is within 5 feet of you, you can use your reaction to impose disadvantage on the attack roll. You must be wielding a shield."
            },
            {
                "name": "Spellcasting: Paladin",
                "level": 2,
                "description": "By 2nd level, you have learned to draw on divine magic through meditation and prayer to cast spells as a cleric does."
            },
            {
                "name": "Divine Smite",
                "level": 2,
                "description": "Starting at 2nd level, when you hit a creature with a melee weapon attack, you can expend one spell slot to deal radiant damage to the target, in addition to the weapon's damage. The extra damage is 2d8 for a 1st-level spell slot, plus 1d8 for each spell level higher than 1st, to a maximum of 5d8. The damage increases by 1d8 if the target is an undead or a fiend."
            },
            {
                "name": "Divine Health",
                "level": 3,
                "description": "By 3rd level, the divine magic flowing through you makes you immune to disease."
            },
            {
                "name": "Sacred Oath",
                "level": 3,
                "description": "When you reach 3rd level, you swear the oath that binds you as a paladin forever. Up to this time you have been in a preparatory stage, committed to the path but not yet sworn to it. Now you choose an oath, such as the Oath of Devotion.\nYour choice grants you features at 3rd level and again at 7th, 15th, and 20th level. Those features include oath spells and the Channel Divinity feature."
            },
            {
                "name": "Oath Spells",
                "level": 3,
                "description": "Each oath has a list of associated spells. You gain access to these spells at the levels specified in the oath description. Once you gain access to an oath spell, you always have it prepared. Oath spells don't count against the number of spells you can prepare each day.\nIf you gain an oath spell that doesn't appear on the paladin spell list, the spell is nonetheless a paladin spell for you."
            },
            {
                "name": "Channel Divinity",
                "level": 3,
                "description": "Your oath allows you to channel divine energy to fuel magical effects. Each Channel Divinity option provided by your oath explains how to use it.\nWhen you use your Channel Divinity, you choose which option to use. You must then finish a short or long rest to use your Channel Divinity again.\nSome Channel Divinity effects require saving throws. When you use such an effect from this class, the DC equals your paladin spell save DC."
            },
            {
                "name": "Channel Divinity: Sacred Weapon",
                "level": 3,
                "description": "As an action, you can imbue one weapon that you are holding with positive energy, using your Channel Divinity. For 1 minute, you add your Charisma modifier to attack rolls made with that weapon (with a minimum bonus of +1). The weapon also emits bright light in a 20-foot radius and dim light 20 feet beyond that. If the weapon is not already magical, it becomes magical for the duration.\nYou can end this effect on your turn as part of any other action. If you are no longer holding or carrying this weapon, or if you fall unconscious, this effect ends.",
                "subclass": "Devotion"
            },
            {
                "name": "Channel Divinity: Turn the Unholy",
                "level": 3,
                "description": "As an action, you present your holy symbol and speak a prayer censuring fiends and undead, using your Channel Divinity. Each fiend or undead that can see or hear you within 30 feet of you must make a Wisdom saving throw. If the creature fails its saving throw, it is turned for 1 minute or until it takes damage.\nA turned creature must spend its turns trying to move as far away from you as it can, and it can't willingly move to a space within 30 feet of you. It also can't take reactions. For its action, it can use only the Dash action or try to escape from an effect that prevents it from moving. If there's nowhere to move, the creature can use the Dodge action.",
                "subclass": "Devotion"
            },
            {
                "name": "Ability Score Improvement",
                "level": 4,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Extra Attack",
                "level": 5,
                "description": "Beginning at 5th level, you can attack twice, instead of once, whenever you take the Attack action on your turn."
            },
            {
                "name": "Aura of Protection",
                "level": 6,
                "description": "Starting at 6th level, whenever you or a friendly creature within 10 feet of you must make a saving throw, the creature gains a bonus to the saving throw equal to your Charisma modifier (with a minimum bonus of +1). You must be conscious to grant this bonus.\nAt 18th level, the range of this aura increases to 30 feet."
            },
            {
                "name": "Sacred Oath feature",
                "level": 7,
                "description": "When you reach 3rd level, you swear the oath that binds you as a paladin forever. Up to this time you have been in a preparatory stage, committed to the path but not yet sworn to it. Now you choose an oath, such as the Oath of Devotion.\nYour choice grants you features at 3rd level and again at 7th, 15th, and 20th level. Those features include oath spells and the Channel Divinity feature."
            },
            {
                "name": "Aura of Devotion",
                "level": 7,
                "description": "Starting at 7th level, you and friendly creatures within 10 feet of you can't be charmed while you are conscious.\nAt 18th level, the range of this aura increases to 30 feet.",
                "subclass": "Devotion"
            },
            {
                "name": "Ability Score Improvement",
                "level": 8,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Aura of Courage",
                "level": 10,
                "description": "Starting at 10th level, you and friendly creatures within 10 feet of you can't be frightened while you are conscious.\nAt 18th level, the range of this aura increases to 30 feet."
            },
            {
                "name": "Improved Divine Smite",
                "level": 11,
                "description": "By 11th level, you are so suffused with righteous might that all your melee weapon strikes carry divine power with them. Whenever you hit a creature with a melee weapon, the creature takes an extra 1d8 radiant damage. If you also use your Divine Smite with an attack, you add this damage to the extra damage of your Divine Smite."
            },
            {
                "name": "Ability Score Improvement",
                "level": 12,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Cleansing Touch",
                "level": 14,
                "description": "Beginning at 14th level, you can use your action to end one spell on yourself or on one willing creature that you touch.\nYou can use this feature a number of times equal to your Charisma modifier (a minimum of once). You regain expended uses when you finish a long rest."
            },
            {
                "name": "Sacred Oath feature",
                "level": 15,
                "description": "When you reach 3rd level, you swear the oath that binds you as a paladin forever. Up to this time you have been in a preparatory stage, committed to the path but not yet sworn to it. Now you choose an oath, such as the Oath of Devotion.\nYour choice grants you features at 3rd level and again at 7th, 15th, and 20th level. Those features include oath spells and the Channel Divinity feature."
            },
            {
                "name": "Purity of Spirit",
                "level": 15,
                "description": "Beginning at 15th level, you are always under the effects of a protection from evil and good spell.",
                "subclass": "Devotion"
            },
            {
                "name": "Ability Score Improvement",
                "level": 16,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Aura improvements",
                "level": 18,
                "description": "At 18th level, the range of your auras increase to 30 feet."
            },
            {
                "name": "Ability Score Improvement",
                "level": 19,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Sacred Oath feature",
                "level": 20,
                "description": "When you reach 3rd level, you swear the oath that binds you as a paladin forever. Up to this time you have been in a preparatory stage, committed to the path but not yet sworn to it. Now you choose an oath, such as the Oath of Devotion.\nYour choice grants you features at 3rd level and again at 7th, 15th, and 20th level. Those features include oath spells and the Channel Divinity feature."
            },
            {
                "name": "Holy Nimbus",
                "level": 20,
                "description": "At 20th level, as an action, you can emanate an aura of sunlight. For 1 minute, bright light shines from you in a 30-foot radius, and dim light shines 30 feet beyond that.\nWhenever an enemy creature starts its turn in the bright light, the creature takes 10 radiant damage.\nIn addition, for the duration, you have advantage on saving throws against spells cast by fiends or undead.",
                "subclass": "Devotion"
            }
        ],
        "levels": [
            {
                "level": 1,
                "proficiencyBonus": 2,
                "spellcasting": {
                    "slots": {}
                },
                "classSpecific": {
                    "aura_range": 0
                }
            },
            {
                "level": 2,
                "proficiencyBonus": 2,
                "spellcasting": {
                    "slots": {
                        "1": 2
                    }
                },
                "classSpecific": {
                    "aura_range": 0
                }
            },
            {
                "level": 3,
                "proficiencyBonus": 2,
                "spellcasting": {
                    "slots": {
                        "1": 3
                    }
                },
                "classSpecific": {
                    "aura_range": 0
                }
            },
            {
                "level": 3
            },
            {
                "level": 4,
                "proficiencyBonus": 2,
                "spellcasting": {
                    "slots": {
                        "1": 3
                    }
                },
                "classSpecific": {
                    "aura_range": 0
                }
            },
            {
                "level": 5,
                "proficiencyBonus": 3,
                "spellcasting": {
                    "slots": {
                        "1": 4,
                        "2": 2
                    }
                },
                "classSpecific": {
                    "aura_range": 0
                }
            },
            {
                "level": 6,
                "proficiencyBonus": 3,
                "spellcasting": {
                    "slots": {
                        "1": 4,
                        "2": 2
                    }
                },
                "classSpecific": {
                    "aura_range": 10
                }
            },
            {
                "level": 7,
                "proficiencyBonus": 3,
                "spellcasting": {
                    "slots": {
                        "1": 4,
                        "2": 3
                    }
                },
                "classSpecific": {
                    "aura_range": 10
                }
            },
            {
                "level": 7
            },
            {
                "level": 8,
                "proficiencyBonus": 3,
                "spellcasting": {
                    "slots": {
                        "1": 4,
                        "2": 3
                    }
                },
                "classSpecific": {
                    "aura_range": 10
                }
            },
            {
                "level": 9,
                "proficiencyBonus": 4,
                "spellcasting": {
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 2
                    }
                },
                "classSpecific": {
                    "aura_range": 10
                }
            },
            {
                "level": 10,
                "proficiencyBonus": 4,
                "spellcasting": {
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 2
                    }
                },
                "classSpecific": {
                    "aura_range": 10
                }
            },
            {
                "level": 11,
                "proficiencyBonus": 4,
                "spellcasting": {
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3
                    }
                },
                "classSpecific": {
                    "aura_range": 10
                }
            },
            {
                "level": 12,
                "proficiencyBonus": 4,
                "spellcasting": {
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3
                    }
                },
                "classSpecific": {
                    "aura_range": 10
                }
            },
            {
                "level": 13,
                "proficiencyBonus": 5,
                "spellcasting": {
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 1
                    }
                },
                "classSpecific": {
                    "aura_range": 10
                }
            },
            {
                "level": 14,
                "proficiencyBonus": 5,
                "spellcasting": {
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 1
                    }
                },
                "classSpecific": {
                    "aura_range": 10
                }
            },
            {
                "level": 15,
                "proficiencyBonus": 5,
                "spellcasting": {
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 2
                    }
                },
                "classSpecific": {
                    "aura_range": 10
                }
            },
            {
                "level": 15
            },
            {
                "level": 16,
                "proficiencyBonus": 5,
                "spellcasting": {
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 2
                    }
                },
                "classSpecific": {
                    "aura_range": 10
                }
            },
            {
                "level": 17,
                "proficiencyBonus": 6,
                "spellcasting": {
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 1
                    }
                },
                "classSpecific": {
                    "aura_range": 10
                }
            },
            {
                "level": 18,
                "proficiencyBonus": 6,
                "spellcasting": {
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 1
                    }
                },
                "classSpecific": {
                    "aura_range": 30
                }
            },
            {
                "level": 18
            },
            {
                "level": 19,
                "proficiencyBonus": 6,
                "spellcasting": {
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2
                    }
                },
                "classSpecific": {
                    "aura_range": 30
                }
            },
            {
                "level": 20,
                "proficiencyBonus": 6,
                "spellcasting": {
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2
                    }
                },
                "classSpecific": {
                    "aura_range": 30
                }
            },
            {
                "level": 20
            }
        ],
        "spellcastingAbility": "cha"
    },
    {
        "slug": "ranger",
        "name": "Ranger",
        "hitDie": 10,
        "savingThrows": [
            "STR",
            "DEX"
        ],
        "proficiencies": [
            "Light Armor",
            "Medium Armor",
            "Shields",
            "Simple Weapons",
            "Martial Weapons",
            "Saving Throw: DEX",
            "Saving Throw: STR"
        ],
        "skillChoices": [
            {
                "choose": 3,
                "from": [
                    "Animal Handling",
                    "Athletics",
                    "Insight",
                    "Investigation",
                    "Nature",
                    "Perception",
                    "Stealth",
                    "Survival"
                ]
            }
        ],
        "subclass": {
            "name": "Hunter",
            "description": "Emulating the Hunter archetype means accepting your place as a bulwark between civilization and the terrors of the wilderness. As you walk the Hunter's path, you learn specialized techniques for fighting the threats you face, from rampaging ogres and hordes of orcs to towering giants and terrifying dragons."
        },
        "features": [
            {
                "name": "Favored Enemy (1 type)",
                "level": 1,
                "description": "Beginning at 1st level, you have significant experience studying, tracking, hunting, and even talking to a certain type of enemy.\nChoose a type of favored enemy: aberrations, beasts, celestials, constructs, dragons, elementals, fey, fiends, giants, monstrosities, oozes, plants, or undead. Alternatively, you can select two races of humanoid (such as gnolls and orcs) as favored enemies.\nYou have advantage on Wisdom (Survival) checks to track your favored enemies, as well as on Intelligence checks to recall information about them.\nWhen you gain this feature, you also learn one language of your choice that is spoken by your favored enemies, if they speak one at all.\nYou choose one additional favored enemy, as well as an associated language, at 6th and 14th level. As you gain levels, your choices should reflect the types of monsters you have encountered on your adventures."
            },
            {
                "name": "Natural Explorer (1 terrain type)",
                "level": 1,
                "description": "You are particularly familiar with one type of natural environment and are adept at traveling and surviving in such regions. Choose one type of favored terrain: arctic, coast, desert, forest, grassland, mountain, or swamp. When you make an Intelligence or Wisdom check related to your favored terrain, your proficiency bonus is doubled if you are using a skill that you're proficient in.\nWhile traveling for an hour or more in your favored terrain, you gain the following benefits:\n- Difficult terrain doesn't slow your group's travel.\n- Your group can't become lost except by magical means.\n- Even when you are engaged in another activity while traveling (such as foraging, navigating, or tracking), you remain alert to danger.\n- If you are traveling alone, you can move stealthily at a normal pace.\n- When you forage, you find twice as much food as you normally would.\n- While tracking other creatures, you also learn their exact number, their sizes, and how long ago they passed through the area.\nYou choose additional favored terrain types at 6th and 10th level."
            },
            {
                "name": "Fighting Style",
                "level": 2,
                "description": "At 2nd level, you adopt a particular style of fighting as your specialty. Choose one of the following options. You can't take a Fighting Style option more than once, even if you later get to choose again."
            },
            {
                "name": "Fighting Style: Archery",
                "level": 2,
                "description": "You gain a +2 bonus to attack rolls you make with ranged weapons."
            },
            {
                "name": "Fighting Style: Defense",
                "level": 2,
                "description": "While you are wearing armor, you gain a +1 bonus to AC."
            },
            {
                "name": "Fighting Style: Dueling",
                "level": 2,
                "description": "When you are wielding a melee weapon in one hand and no other weapons, you gain a +2 bonus to damage rolls with that weapon."
            },
            {
                "name": "Fighting Style: Two-Weapon Fighting",
                "level": 2,
                "description": "When you engage in two-weapon fighting, you can add your ability modifier to the damage of the second attack."
            },
            {
                "name": "Spellcasting: Ranger",
                "level": 2,
                "description": "By the time you reach 2nd level, you have learned to use the magical essence of nature to cast spells, much as a druid does."
            },
            {
                "name": "Ranger Archetype",
                "level": 3,
                "description": "At 3rd level, you choose an archetype that you strive to emulate, such as the Hunter. Your choice grants you features at 3rd level and again at 7th, 11th, and 15th level."
            },
            {
                "name": "Hunter's Prey",
                "level": 3,
                "description": "At 3rd level, you gain one of the following features of your choice.\nColossus Slayer\nGiant Killer\nHorde Breaker",
                "subclass": "Hunter"
            },
            {
                "name": "Hunter's Prey: Colossus Slayer",
                "level": 3,
                "description": "Your tenacity can wear down the most potent foes. When you hit a creature with a weapon attack, the creature takes an extra 1d8 damage if it's below its hit point maximum. You can deal this extra damage only once per turn.",
                "subclass": "Hunter"
            },
            {
                "name": "Hunter's Prey: Giant Killer",
                "level": 3,
                "description": "When a Large or larger creature within 5 feet of you hits or misses you with an attack, you can use your reaction to attack that creature immediately after its attack, provided that you can see the creature.",
                "subclass": "Hunter"
            },
            {
                "name": "Hunter's Prey: Horde Breaker",
                "level": 3,
                "description": "Once on each of your turns when you make a weapon attack, you can make another attack with the same weapon against a different creature that is within 5 feet of the original target and within range of your weapon.",
                "subclass": "Hunter"
            },
            {
                "name": "Primeval Awareness",
                "level": 3,
                "description": "Beginning at 3rd level, you can use your action and expend one ranger spell slot to focus your awareness on the region around you. For 1 minute per level of the spell slot you expend, you can sense whether the following types of creatures are present within 1 mile of you (or within up to 6 miles if you are in your favored terrain): aberrations, celestials, dragons, elementals, fey, fiends, and undead. This feature doesn't reveal the creatures' location or number."
            },
            {
                "name": "Ability Score Improvement",
                "level": 4,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Extra Attack",
                "level": 5,
                "description": "Beginning at 5th level, you can attack twice, instead of once, whenever you take the Attack action on your turn."
            },
            {
                "name": "Favored Enemy (2 types)",
                "level": 6,
                "description": "Beginning at 1st level, you have significant experience studying, tracking, hunting, and even talking to a certain type of enemy.\nChoose a type of favored enemy: aberrations, beasts, celestials, constructs, dragons, elementals, fey, fiends, giants, monstrosities, oozes, plants, or undead. Alternatively, you can select two races of humanoid (such as gnolls and orcs) as favored enemies.\nYou have advantage on Wisdom (Survival) checks to track your favored enemies, as well as on Intelligence checks to recall information about them.\nWhen you gain this feature, you also learn one language of your choice that is spoken by your favored enemies, if they speak one at all.\nYou choose one additional favored enemy, as well as an associated language, at 6th and 14th level. As you gain levels, your choices should reflect the types of monsters you have encountered on your adventures."
            },
            {
                "name": "Natural Explorer (2 terrain types)",
                "level": 6,
                "description": "You are particularly familiar with one type of natural environment and are adept at traveling and surviving in such regions. Choose one type of favored terrain: arctic, coast, desert, forest, grassland, mountain, or swamp. When you make an Intelligence or Wisdom check related to your favored terrain, your proficiency bonus is doubled if you are using a skill that you're proficient in.\nWhile traveling for an hour or more in your favored terrain, you gain the following benefits:\n- Difficult terrain doesn't slow your group's travel.\n- Your group can't become lost except by magical means.\n- Even when you are engaged in another activity while traveling (such as foraging, navigating, or tracking), you remain alert to danger.\n- If you are traveling alone, you can move stealthily at a normal pace.\n- When you forage, you find twice as much food as you normally would.\n- While tracking other creatures, you also learn their exact number, their sizes, and how long ago they passed through the area.\nYou choose additional favored terrain types at 6th and 10th level."
            },
            {
                "name": "Ranger Archetype feature",
                "level": 7,
                "description": "At 3rd level, you choose an archetype that you strive to emulate, such as the Hunter. Your choice grants you features at 3rd level and again at 7th, 11th, and 15th level."
            },
            {
                "name": "Defensive Tactics",
                "level": 7,
                "description": "At 7th level, you gain one of the following features of your choice.\nEscape the Horde\nMultiattack Defense\nSteel Will",
                "subclass": "Hunter"
            },
            {
                "name": "Defensive Tactics: Escape the Horde",
                "level": 7,
                "description": "Opportunity attacks against you are made with disadvantage.",
                "subclass": "Hunter"
            },
            {
                "name": "Defensive Tactics: Multiattack Defense",
                "level": 7,
                "description": "When a creature hits you with an attack, you gain a +4 bonus to AC against all subsequent attacks made by that creature for the rest of the turn.",
                "subclass": "Hunter"
            },
            {
                "name": "Defensive Tactics: Steel Will",
                "level": 7,
                "description": "You have advantage on saving throws against being frightened.",
                "subclass": "Hunter"
            },
            {
                "name": "Ability Score Improvement",
                "level": 8,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Land's Stride",
                "level": 8,
                "description": "Starting at 8th level, moving through nonmagical difficult terrain costs you no extra movement. You can also pass through nonmagical plants without being slowed by them and without taking damage from them if they have thorns, spines, or a similar hazard.\nIn addition, you have advantage on saving throws against plants that are magically created or manipulated to impede movement, such those created by the entangle spell."
            },
            {
                "name": "Natural Explorer (3 terrain types)",
                "level": 10,
                "description": "You are particularly familiar with one type of natural environment and are adept at traveling and surviving in such regions. Choose one type of favored terrain: arctic, coast, desert, forest, grassland, mountain, or swamp. When you make an Intelligence or Wisdom check related to your favored terrain, your proficiency bonus is doubled if you are using a skill that you're proficient in.\nWhile traveling for an hour or more in your favored terrain, you gain the following benefits:\n- Difficult terrain doesn't slow your group's travel.\n- Your group can't become lost except by magical means.\n- Even when you are engaged in another activity while traveling (such as foraging, navigating, or tracking), you remain alert to danger.\n- If you are traveling alone, you can move stealthily at a normal pace.\n- When you forage, you find twice as much food as you normally would.\n- While tracking other creatures, you also learn their exact number, their sizes, and how long ago they passed through the area.\nYou choose additional favored terrain types at 6th and 10th level."
            },
            {
                "name": "Hide in Plain Sight",
                "level": 10,
                "description": "Starting at 10th level, you can spend 1 minute creating camouflage for yourself. You must have access to fresh mud, dirt, plants, soot, and other naturally occurring materials with which to create your camouflage.\nOnce you are camouflaged in this way, you can try to hide by pressing yourself up against a solid surface, such as a tree or wall, that is at least as tall and wide as you are. You gain a +10 bonus to Dexterity (Stealth) checks as long as you remain there without moving or taking actions. Once you move or take an action or a reaction, you must camouflage yourself again to gain this benefit."
            },
            {
                "name": "Ranger Archetype feature",
                "level": 11,
                "description": "At 3rd level, you choose an archetype that you strive to emulate, such as the Hunter. Your choice grants you features at 3rd level and again at 7th, 11th, and 15th level."
            },
            {
                "name": "Multiattack",
                "level": 11,
                "description": "At 11th level, you gain one of the following features of your choice.\nVolley\nWhirlwind Attack",
                "subclass": "Hunter"
            },
            {
                "name": "Multiattack: Volley",
                "level": 11,
                "description": "You can use your action to make a ranged attack against any number of creatures within 10 feet of a point you can see within your weapon's range. You must have ammunition for each target, as normal, and you make a separate attack roll for each target.",
                "subclass": "Hunter"
            },
            {
                "name": "Multiattack: Whirlwind Attack",
                "level": 11,
                "description": "You can use your action to make a melee attack against any number of creatures within 5 feet of you, with a separate attack roll for each target.",
                "subclass": "Hunter"
            },
            {
                "name": "Ability Score Improvement",
                "level": 12,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Favored Enemy (3 enemies)",
                "level": 14,
                "description": "Beginning at 1st level, you have significant experience studying, tracking, hunting, and even talking to a certain type of enemy.\nChoose a type of favored enemy: aberrations, beasts, celestials, constructs, dragons, elementals, fey, fiends, giants, monstrosities, oozes, plants, or undead. Alternatively, you can select two races of humanoid (such as gnolls and orcs) as favored enemies.\nYou have advantage on Wisdom (Survival) checks to track your favored enemies, as well as on Intelligence checks to recall information about them.\nWhen you gain this feature, you also learn one language of your choice that is spoken by your favored enemies, if they speak one at all.\nYou choose one additional favored enemy, as well as an associated language, at 6th and 14th level. As you gain levels, your choices should reflect the types of monsters you have encountered on your adventures."
            },
            {
                "name": "Vanish",
                "level": 14,
                "description": "Starting at 14th level, you can use the Hide action as a bonus action on your turn. Also, you can't be tracked by nonmagical means, unless you choose to leave a trail."
            },
            {
                "name": "Ranger Archetype feature",
                "level": 15,
                "description": "At 3rd level, you choose an archetype that you strive to emulate, such as the Hunter. Your choice grants you features at 3rd level and again at 7th, 11th, and 15th level."
            },
            {
                "name": "Superior Hunter's Defense",
                "level": 15,
                "description": "At 15th level, you gain one of the following features of your choice.\nEvasion\nStand Against the Tide\nUncanny Dodge",
                "subclass": "Hunter"
            },
            {
                "name": "Superior Hunter's Defense: Evasion",
                "level": 15,
                "description": "When you are subjected to an effect, such as a red dragon's fiery breath or a lightning bolt spell, that allows you to make a Dexterity saving throw to take only half damage, you instead take no damage if you succeed on the saving throw, and only half damage if you fail.",
                "subclass": "Hunter"
            },
            {
                "name": "Superior Hunter's Defense: Stand Against the Tide",
                "level": 15,
                "description": "When a hostile creature misses you with a melee attack, you can use your reaction to force that creature to repeat the same attack against another creature (other than itself) of your choice.",
                "subclass": "Hunter"
            },
            {
                "name": "Superior Hunter's Defense: Uncanny Dodge",
                "level": 15,
                "description": "When an attacker that you can see hits you with an attack, you can use your reaction to halve the attack's damage against you.",
                "subclass": "Hunter"
            },
            {
                "name": "Ability Score Improvement",
                "level": 16,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Feral Senses",
                "level": 18,
                "description": "At 18th level, you gain preternatural senses that help you fight creatures you can't see. When you attack a creature you can't see, your inability to see it doesn't impose disadvantage on your attack rolls against it.\nYou are also aware of the location of any invisible creature within 30 feet of you, provided that the creature isn't hidden from you and you aren't blinded or deafened."
            },
            {
                "name": "Ability Score Improvement",
                "level": 19,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Foe Slayer",
                "level": 20,
                "description": "At 20th level, you become an unparalleled hunter of your enemies. Once on each of your turns, you can add your Wisdom modifier to the attack roll or the damage roll of an attack you make against one of your favored enemies. You can choose to use this feature before or after the roll, but before any effects of the roll are applied."
            }
        ],
        "levels": [
            {
                "level": 1,
                "proficiencyBonus": 2,
                "spellcasting": {
                    "spellsKnown": 0,
                    "slots": {}
                },
                "classSpecific": {
                    "favored_enemies": 1,
                    "favored_terrain": 1
                }
            },
            {
                "level": 2,
                "proficiencyBonus": 2,
                "spellcasting": {
                    "spellsKnown": 2,
                    "slots": {
                        "1": 2
                    }
                },
                "classSpecific": {
                    "favored_enemies": 1,
                    "favored_terrain": 1
                }
            },
            {
                "level": 3,
                "proficiencyBonus": 2,
                "spellcasting": {
                    "spellsKnown": 3,
                    "slots": {
                        "1": 3
                    }
                },
                "classSpecific": {
                    "favored_enemies": 1,
                    "favored_terrain": 1
                }
            },
            {
                "level": 3
            },
            {
                "level": 4,
                "proficiencyBonus": 2,
                "spellcasting": {
                    "spellsKnown": 3,
                    "slots": {
                        "1": 3
                    }
                },
                "classSpecific": {
                    "favored_enemies": 1,
                    "favored_terrain": 1
                }
            },
            {
                "level": 5,
                "proficiencyBonus": 3,
                "spellcasting": {
                    "spellsKnown": 4,
                    "slots": {
                        "1": 4,
                        "2": 2
                    }
                },
                "classSpecific": {
                    "favored_enemies": 1,
                    "favored_terrain": 1
                }
            },
            {
                "level": 6,
                "proficiencyBonus": 3,
                "spellcasting": {
                    "spellsKnown": 4,
                    "slots": {
                        "1": 4,
                        "2": 2
                    }
                },
                "classSpecific": {
                    "favored_enemies": 2,
                    "favored_terrain": 2
                }
            },
            {
                "level": 7,
                "proficiencyBonus": 3,
                "spellcasting": {
                    "spellsKnown": 5,
                    "slots": {
                        "1": 4,
                        "2": 3
                    }
                },
                "classSpecific": {
                    "favored_enemies": 2,
                    "favored_terrain": 2
                }
            },
            {
                "level": 7
            },
            {
                "level": 8,
                "proficiencyBonus": 3,
                "spellcasting": {
                    "spellsKnown": 5,
                    "slots": {
                        "1": 4,
                        "2": 3
                    }
                },
                "classSpecific": {
                    "favored_enemies": 2,
                    "favored_terrain": 2
                }
            },
            {
                "level": 9,
                "proficiencyBonus": 4,
                "spellcasting": {
                    "spellsKnown": 6,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 2
                    }
                },
                "classSpecific": {
                    "favored_enemies": 2,
                    "favored_terrain": 2
                }
            },
            {
                "level": 10,
                "proficiencyBonus": 4,
                "spellcasting": {
                    "spellsKnown": 6,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 2
                    }
                },
                "classSpecific": {
                    "favored_enemies": 2,
                    "favored_terrain": 3
                }
            },
            {
                "level": 11,
                "proficiencyBonus": 4,
                "spellcasting": {
                    "spellsKnown": 7,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3
                    }
                },
                "classSpecific": {
                    "favored_enemies": 2,
                    "favored_terrain": 3
                }
            },
            {
                "level": 11
            },
            {
                "level": 12,
                "proficiencyBonus": 4,
                "spellcasting": {
                    "spellsKnown": 7,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3
                    }
                },
                "classSpecific": {
                    "favored_enemies": 2,
                    "favored_terrain": 3
                }
            },
            {
                "level": 13,
                "proficiencyBonus": 5,
                "spellcasting": {
                    "spellsKnown": 8,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 1
                    }
                },
                "classSpecific": {
                    "favored_enemies": 2,
                    "favored_terrain": 3
                }
            },
            {
                "level": 14,
                "proficiencyBonus": 5,
                "spellcasting": {
                    "spellsKnown": 8,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 1
                    }
                },
                "classSpecific": {
                    "favored_enemies": 3,
                    "favored_terrain": 3
                }
            },
            {
                "level": 15,
                "proficiencyBonus": 5,
                "spellcasting": {
                    "spellsKnown": 9,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 2
                    }
                },
                "classSpecific": {
                    "favored_enemies": 3,
                    "favored_terrain": 3
                }
            },
            {
                "level": 15
            },
            {
                "level": 16,
                "proficiencyBonus": 5,
                "spellcasting": {
                    "spellsKnown": 9,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 2
                    }
                },
                "classSpecific": {
                    "favored_enemies": 3,
                    "favored_terrain": 3
                }
            },
            {
                "level": 17,
                "proficiencyBonus": 6,
                "spellcasting": {
                    "spellsKnown": 10,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 1
                    }
                },
                "classSpecific": {
                    "favored_enemies": 3,
                    "favored_terrain": 3
                }
            },
            {
                "level": 18,
                "proficiencyBonus": 6,
                "spellcasting": {
                    "spellsKnown": 10,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 1
                    }
                },
                "classSpecific": {
                    "favored_enemies": 3,
                    "favored_terrain": 3
                }
            },
            {
                "level": 19,
                "proficiencyBonus": 6,
                "spellcasting": {
                    "spellsKnown": 11,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2
                    }
                },
                "classSpecific": {
                    "favored_enemies": 3,
                    "favored_terrain": 3
                }
            },
            {
                "level": 20,
                "proficiencyBonus": 6,
                "spellcasting": {
                    "spellsKnown": 11,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2
                    }
                },
                "classSpecific": {
                    "favored_enemies": 3,
                    "favored_terrain": 3
                }
            }
        ],
        "spellcastingAbility": "wis"
    },
    {
        "slug": "rogue",
        "name": "Rogue",
        "hitDie": 8,
        "savingThrows": [
            "DEX",
            "INT"
        ],
        "proficiencies": [
            "Light Armor",
            "Simple Weapons",
            "Longswords",
            "Rapiers",
            "Shortswords",
            "Hand crossbows",
            "Thieves' Tools",
            "Saving Throw: DEX",
            "Saving Throw: INT"
        ],
        "skillChoices": [
            {
                "choose": 4,
                "from": [
                    "Acrobatics",
                    "Athletics",
                    "Deception",
                    "Insight",
                    "Intimidation",
                    "Investigation",
                    "Perception",
                    "Performance",
                    "Persuasion",
                    "Sleight of Hand",
                    "Stealth"
                ]
            }
        ],
        "subclass": {
            "name": "Thief",
            "description": "You hone your skills in the larcenous arts. Burglars, bandits, cutpurses, and other criminals typically follow this archetype, but so do rogues who prefer to think of themselves as professional treasure seekers, explorers, delvers, and investigators. In addition to improving your agility and stealth, you learn skills useful for delving into ancient ruins, reading unfamiliar languages, and using magic items you normally couldn't employ."
        },
        "features": [
            {
                "name": "Expertise",
                "level": 1,
                "description": "At 1st level, choose two of your skill proficiencies, or one of your skill proficiencies and your proficiency with thieves' tools. Your proficiency bonus is doubled for any ability check you make that uses either of the chosen proficiencies.\nAt 6th level, you can choose two more of your proficiencies (in skills or with thieves' tools) to gain this benefit"
            },
            {
                "name": "Sneak Attack",
                "level": 1,
                "description": "Beginning at 1st level, you know how to strike subtly and exploit a foe's distraction. Once per turn, you can deal an extra 1d6 damage to one creature you hit with an attack if you have advantage on the attack roll. The attack must use a finesse or a ranged weapon.\nYou don't need advantage on the attack roll if another enemy of the target is within 5 feet of it, that enemy isn't incapacitated, and you don't have disadvantage on the attack roll.\nThe amount of the extra damage increases as you gain levels in this class, as shown in the Sneak Attack column of the Rogue table."
            },
            {
                "name": "Thieves' Cant",
                "level": 1,
                "description": "During your rogue training you learned thieves' cant, a secret mix of dialect, jargon, and code that allows you to hide messages in seemingly normal conversation. Only another creature that knows thieves' cant understands such messages. It takes four times longer to convey such a message than it does to speak the same idea plainly.\nIn addition, you understand a set of secret signs and symbols used to convey short, simple messages, such as whether an area is dangerous or the territory of a thieves' guild, whether loot is nearby, or whether the people in an area are easy marks or will provide a safe house for thieves on the run."
            },
            {
                "name": "Cunning Action",
                "level": 2,
                "description": "Starting at 2nd level, your quick thinking and agility allow you to move and act quickly. You can take a bonus action on each of your turns in combat. This action can be used only to take the Dash, Disengage, or Hide action."
            },
            {
                "name": "Roguish Archetype",
                "level": 3,
                "description": "At 3rd level, you choose an archetype that you emulate in the exercise of your rogue abilities, such as Thief. Additional archetypes are available in the original source material. Your archetype choice grants you features at 3rd level and then again at 9th, 13th, and 17th level."
            },
            {
                "name": "Fast Hands",
                "level": 3,
                "description": "Starting at 3rd level, you can use the bonus action granted by your Cunning Action to make a Dexterity (Sleight of Hand) check, use your thieves' tools to disarm a trap or open a lock, or take the Use an Object action.",
                "subclass": "Thief"
            },
            {
                "name": "Second-Story Work",
                "level": 3,
                "description": "When you choose this archetype at 3rd level, you gain the ability to climb faster than normal; climbing no longer costs you extra movement.\nIn addition, when you make a running jump, the distance you cover increases by a number of feet equal to your Dexterity modifier.",
                "subclass": "Thief"
            },
            {
                "name": "Ability Score Improvement",
                "level": 4,
                "description": "When you reach 4th level, and again at 8th, 10th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Uncanny Dodge",
                "level": 5,
                "description": "Starting at 5th level, when an attacker that you can see hits you with an attack, you can use your reaction to halve the attack's damage against you."
            },
            {
                "name": "Expertise",
                "level": 6,
                "description": "At 1st level, choose two of your skill proficiencies, or one of your skill proficiencies and your proficiency with thieves' tools. Your proficiency bonus is doubled for any ability check you make that uses either of the chosen proficiencies.\nAt 6th level, you can choose two more of your proficiencies (in skills or with thieves' tools) to gain this benefit"
            },
            {
                "name": "Evasion",
                "level": 7,
                "description": "Beginning at 7th level, you can nimbly dodge out of the way of certain area effects, such as a red dragon's fiery breath or an ice storm spell. When you are subjected to an effect that allows you to make a Dexterity saving throw to take only half damage, you instead take no damage if you succeed on the saving throw, and only half damage if you fail."
            },
            {
                "name": "Ability Score Improvement",
                "level": 8,
                "description": "When you reach 4th level, and again at 8th, 10th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Roguish Archetype feature",
                "level": 9,
                "description": "At 3rd level, you choose an archetype that you emulate in the exercise of your rogue abilities, such as Thief. Additional archetypes are available in the original source material. Your archetype choice grants you features at 3rd level and then again at 9th, 13th, and 17th level."
            },
            {
                "name": "Supreme Sneak",
                "level": 9,
                "description": "Starting at 9th level, you have advantage on a Dexterity (Stealth) check if you move no more than half your speed on the same turn.",
                "subclass": "Thief"
            },
            {
                "name": "Ability Score Improvement",
                "level": 10,
                "description": "When you reach 4th level, and again at 8th, 10th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Reliable Talent",
                "level": 11,
                "description": "By 11th level, you have refined your chosen skills until they approach perfection. Whenever you make an ability check that lets you add your proficiency bonus, you can treat a d20 roll of 9 or lower as a 10."
            },
            {
                "name": "Ability Score Improvement",
                "level": 12,
                "description": "When you reach 4th level, and again at 8th, 10th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Roguish Archetype feature",
                "level": 13,
                "description": "At 3rd level, you choose an archetype that you emulate in the exercise of your rogue abilities, such as Thief. Additional archetypes are available in the original source material. Your archetype choice grants you features at 3rd level and then again at 9th, 13th, and 17th level."
            },
            {
                "name": "Use Magic Device",
                "level": 13,
                "description": "By 13th level, you have learned enough about the workings of magic that you can improvise the use of items even when they are not intended for you. You ignore all class, race, and level requirements on the use of magic items.",
                "subclass": "Thief"
            },
            {
                "name": "Blindsense",
                "level": 14,
                "description": "Starting at 14th level, if you are able to hear, you are aware of the location of any hidden or invisible creature within 10 feet of you."
            },
            {
                "name": "Slippery Mind",
                "level": 15,
                "description": "By 15th level, you have acquired greater mental strength. You gain proficiency in Wisdom saving throws."
            },
            {
                "name": "Ability Score Improvement",
                "level": 16,
                "description": "When you reach 4th level, and again at 8th, 10th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Roguish Archetype feature",
                "level": 17,
                "description": "At 3rd level, you choose an archetype that you emulate in the exercise of your rogue abilities, such as Thief. Additional archetypes are available in the original source material. Your archetype choice grants you features at 3rd level and then again at 9th, 13th, and 17th level."
            },
            {
                "name": "Thief's Reflexes",
                "level": 17,
                "description": "When you reach 17th level, you have become adept at laying ambushes and quickly escaping danger. You can take two turns during the first round of any combat. You take your first turn at your normal initiative and your second turn at your initiative minus 10. You can't use this feature when you are surprised.",
                "subclass": "Thief"
            },
            {
                "name": "Elusive",
                "level": 18,
                "description": "Beginning at 18th level, you are so evasive that attackers rarely gain the upper hand against you. No attack roll has advantage against you while you aren't incapacitated."
            },
            {
                "name": "Ability Score Improvement",
                "level": 19,
                "description": "When you reach 4th level, and again at 8th, 10th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Stroke of Luck",
                "level": 20,
                "description": "At 20th level, you have an uncanny knack for succeeding when you need to. If your attack misses a target within range, you can turn the miss into a hit. Alternatively, if you fail an ability check, you can treat the d20 roll as a 20.\nOnce you use this feature, you can't use it again until you finish a short or long rest."
            }
        ],
        "levels": [
            {
                "level": 1,
                "proficiencyBonus": 2,
                "classSpecific": {
                    "sneak_attack": {
                        "dice_count": 1,
                        "dice_value": 6
                    }
                }
            },
            {
                "level": 2,
                "proficiencyBonus": 2,
                "classSpecific": {
                    "sneak_attack": {
                        "dice_count": 1,
                        "dice_value": 6
                    }
                }
            },
            {
                "level": 3,
                "proficiencyBonus": 2,
                "classSpecific": {
                    "sneak_attack": {
                        "dice_count": 2,
                        "dice_value": 6
                    }
                }
            },
            {
                "level": 3
            },
            {
                "level": 4,
                "proficiencyBonus": 2,
                "classSpecific": {
                    "sneak_attack": {
                        "dice_count": 2,
                        "dice_value": 6
                    }
                }
            },
            {
                "level": 5,
                "proficiencyBonus": 3,
                "classSpecific": {
                    "sneak_attack": {
                        "dice_count": 3,
                        "dice_value": 6
                    }
                }
            },
            {
                "level": 6,
                "proficiencyBonus": 3,
                "classSpecific": {
                    "sneak_attack": {
                        "dice_count": 3,
                        "dice_value": 6
                    }
                }
            },
            {
                "level": 7,
                "proficiencyBonus": 3,
                "classSpecific": {
                    "sneak_attack": {
                        "dice_count": 4,
                        "dice_value": 6
                    }
                }
            },
            {
                "level": 8,
                "proficiencyBonus": 3,
                "classSpecific": {
                    "sneak_attack": {
                        "dice_count": 4,
                        "dice_value": 6
                    }
                }
            },
            {
                "level": 9,
                "proficiencyBonus": 4,
                "classSpecific": {
                    "sneak_attack": {
                        "dice_count": 5,
                        "dice_value": 6
                    }
                }
            },
            {
                "level": 9
            },
            {
                "level": 10,
                "proficiencyBonus": 4,
                "classSpecific": {
                    "sneak_attack": {
                        "dice_count": 5,
                        "dice_value": 6
                    }
                }
            },
            {
                "level": 11,
                "proficiencyBonus": 4,
                "classSpecific": {
                    "sneak_attack": {
                        "dice_count": 6,
                        "dice_value": 6
                    }
                }
            },
            {
                "level": 12,
                "proficiencyBonus": 4,
                "classSpecific": {
                    "sneak_attack": {
                        "dice_count": 6,
                        "dice_value": 6
                    }
                }
            },
            {
                "level": 13,
                "proficiencyBonus": 5,
                "classSpecific": {
                    "sneak_attack": {
                        "dice_count": 7,
                        "dice_value": 6
                    }
                }
            },
            {
                "level": 13
            },
            {
                "level": 14,
                "proficiencyBonus": 5,
                "classSpecific": {
                    "sneak_attack": {
                        "dice_count": 7,
                        "dice_value": 6
                    }
                }
            },
            {
                "level": 15,
                "proficiencyBonus": 5,
                "classSpecific": {
                    "sneak_attack": {
                        "dice_count": 8,
                        "dice_value": 6
                    }
                }
            },
            {
                "level": 16,
                "proficiencyBonus": 5,
                "classSpecific": {
                    "sneak_attack": {
                        "dice_count": 8,
                        "dice_value": 6
                    }
                }
            },
            {
                "level": 17,
                "proficiencyBonus": 6,
                "classSpecific": {
                    "sneak_attack": {
                        "dice_count": 9,
                        "dice_value": 6
                    }
                }
            },
            {
                "level": 17
            },
            {
                "level": 18,
                "proficiencyBonus": 6,
                "classSpecific": {
                    "sneak_attack": {
                        "dice_count": 9,
                        "dice_value": 6
                    }
                }
            },
            {
                "level": 19,
                "proficiencyBonus": 6,
                "classSpecific": {
                    "sneak_attack": {
                        "dice_count": 10,
                        "dice_value": 6
                    }
                }
            },
            {
                "level": 20,
                "proficiencyBonus": 6,
                "classSpecific": {
                    "sneak_attack": {
                        "dice_count": 10,
                        "dice_value": 6
                    }
                }
            }
        ]
    },
    {
        "slug": "sorcerer",
        "name": "Sorcerer",
        "hitDie": 6,
        "savingThrows": [
            "CON",
            "CHA"
        ],
        "proficiencies": [
            "Daggers",
            "Darts",
            "Slings",
            "Quarterstaffs",
            "Crossbows, light",
            "Saving Throw: CON",
            "Saving Throw: CHA"
        ],
        "skillChoices": [
            {
                "choose": 2,
                "from": [
                    "Arcana",
                    "Deception",
                    "Insight",
                    "Intimidation",
                    "Persuasion",
                    "Religion"
                ]
            }
        ],
        "subclass": {
            "name": "Draconic",
            "description": "Your innate magic comes from draconic magic that was mingled with your blood or that of your ancestors. Most often, sorcerers with this origin trace their descent back to a mighty sorcerer of ancient times who made a bargain with a dragon or who might even have claimed a dragon parent. Some of these bloodlines are well established in the world, but most are obscure. Any given sorcerer could be the first of a new bloodline, as a result of a pact or some other exceptional circumstance."
        },
        "features": [
            {
                "name": "Spellcasting: Sorcerer",
                "level": 1,
                "description": "An event in your past, or in the life of a parent or ancestor, left an indelible mark on you, infusing you with arcane magic. This font of magic, whatever its origin, fuels your spells."
            },
            {
                "name": "Sorcerous Origin",
                "level": 1,
                "description": "Choose a sorcerous origin, which describes the source of your innate magical power, such as Draconic Bloodline.\nYour choice grants you features when you choose it at 1st level and again at 6th, 14th, and 18th level."
            },
            {
                "name": "Dragon Ancestor",
                "level": 1,
                "description": "At 1st level, you choose one type of dragon as your ancestor. The damage type associated with each dragon is used by features you gain later.\nYou can speak, read, and write Draconic. Additionally, whenever you make a Charisma check when interacting with dragons, your proficiency bonus is doubled if it applies to the check.",
                "subclass": "Draconic"
            },
            {
                "name": "Dragon Ancestor: Black - Acid Damage",
                "level": 1,
                "description": "At 1st level, you choose one type of dragon as your ancestor. The damage type associated with each dragon is used by features you gain later.\nYou can speak, read, and write Draconic. Additionally, whenever you make a Charisma check when interacting with dragons, your proficiency bonus is doubled if it applies to the check.",
                "subclass": "Draconic"
            },
            {
                "name": "Dragon Ancestor: Blue - Lightning Damage",
                "level": 1,
                "description": "At 1st level, you choose one type of dragon as your ancestor. The damage type associated with each dragon is used by features you gain later.\nYou can speak, read, and write Draconic. Additionally, whenever you make a Charisma check when interacting with dragons, your proficiency bonus is doubled if it applies to the check.",
                "subclass": "Draconic"
            },
            {
                "name": "Dragon Ancestor: Brass - Fire Damage",
                "level": 1,
                "description": "At 1st level, you choose one type of dragon as your ancestor. The damage type associated with each dragon is used by features you gain later.\nYou can speak, read, and write Draconic. Additionally, whenever you make a Charisma check when interacting with dragons, your proficiency bonus is doubled if it applies to the check.",
                "subclass": "Draconic"
            },
            {
                "name": "Dragon Ancestor: Bronze - Lightning Damage",
                "level": 1,
                "description": "At 1st level, you choose one type of dragon as your ancestor. The damage type associated with each dragon is used by features you gain later.\nYou can speak, read, and write Draconic. Additionally, whenever you make a Charisma check when interacting with dragons, your proficiency bonus is doubled if it applies to the check.",
                "subclass": "Draconic"
            },
            {
                "name": "Dragon Ancestor: Copper - Acid Damage",
                "level": 1,
                "description": "At 1st level, you choose one type of dragon as your ancestor. The damage type associated with each dragon is used by features you gain later.\nYou can speak, read, and write Draconic. Additionally, whenever you make a Charisma check when interacting with dragons, your proficiency bonus is doubled if it applies to the check.",
                "subclass": "Draconic"
            },
            {
                "name": "Dragon Ancestor: Gold - Fire Damage",
                "level": 1,
                "description": "At 1st level, you choose one type of dragon as your ancestor. The damage type associated with each dragon is used by features you gain later.\nYou can speak, read, and write Draconic. Additionally, whenever you make a Charisma check when interacting with dragons, your proficiency bonus is doubled if it applies to the check.",
                "subclass": "Draconic"
            },
            {
                "name": "Dragon Ancestor: Green - Poison Damage",
                "level": 1,
                "description": "At 1st level, you choose one type of dragon as your ancestor. The damage type associated with each dragon is used by features you gain later.\nYou can speak, read, and write Draconic. Additionally, whenever you make a Charisma check when interacting with dragons, your proficiency bonus is doubled if it applies to the check.",
                "subclass": "Draconic"
            },
            {
                "name": "Dragon Ancestor: Red - Fire Damage",
                "level": 1,
                "description": "At 1st level, you choose one type of dragon as your ancestor. The damage type associated with each dragon is used by features you gain later.\nYou can speak, read, and write Draconic. Additionally, whenever you make a Charisma check when interacting with dragons, your proficiency bonus is doubled if it applies to the check.",
                "subclass": "Draconic"
            },
            {
                "name": "Dragon Ancestor: Silver - Cold Damage",
                "level": 1,
                "description": "At 1st level, you choose one type of dragon as your ancestor. The damage type associated with each dragon is used by features you gain later.\nYou can speak, read, and write Draconic. Additionally, whenever you make a Charisma check when interacting with dragons, your proficiency bonus is doubled if it applies to the check.",
                "subclass": "Draconic"
            },
            {
                "name": "Dragon Ancestor: White - Cold Damage",
                "level": 1,
                "description": "At 1st level, you choose one type of dragon as your ancestor. The damage type associated with each dragon is used by features you gain later.\nYou can speak, read, and write Draconic. Additionally, whenever you make a Charisma check when interacting with dragons, your proficiency bonus is doubled if it applies to the check.",
                "subclass": "Draconic"
            },
            {
                "name": "Draconic Resilience",
                "level": 1,
                "description": "As magic flows through your body, it causes physical traits of your dragon ancestors to emerge. At 1st level, your hit point maximum increases by 1 and increases by 1 again whenever you gain a level in this class.\nAdditionally, parts of your skin are covered by a thin sheen of dragon-like scales. When you aren't wearing armor, your AC equals 13 + your Dexterity modifier.",
                "subclass": "Draconic"
            },
            {
                "name": "Font of Magic",
                "level": 2,
                "description": "At 2nd level, you tap into a deep wellspring of magic within yourself. This wellspring is represented by sorcery points, which allow you to create a variety of magical effects.\nSorcery Points\nYou have 2 sorcery points, and you gain more as you reach higher levels, as shown in the Sorcery Points column of the Sorcerer table. You can never have more sorcery points than shown on the table for your level. You regain all spent sorcery points when you finish a long rest."
            },
            {
                "name": "Flexible Casting: Creating Spell Slots",
                "level": 2,
                "description": "You can transform unexpended sorcery points into one spell slot as a bonus action on your turn. The Creating Spell Slots table shows the cost of creating a spell slot of a given level. You can create spell slots no higher in level than 5th. \nAny spell slot you create with this feature vanishes when you finish a long rest."
            },
            {
                "name": "Flexible Casting: Converting Spell Slot",
                "level": 2,
                "description": "As a bonus action on your turn, you can expend one spell slot and gain a number of sorcery points equal to the slot's level.."
            },
            {
                "name": "Metamagic",
                "level": 3,
                "description": "At 3rd level, you gain the ability to twist your spells to suit your needs. You gain two of the following Metamagic options of your choice. You gain another one at 10th and 17th level.\nYou can use only one Metamagic option on a spell when you cast it, unless otherwise noted."
            },
            {
                "name": "Metamagic: Careful Spell",
                "level": 3,
                "description": "When you cast a spell that forces other creatures to make a saving throw, you can protect some of those creatures from the spell's full force. To do so, you spend 1 sorcery point and choose a number of those creatures up to your Charisma modifier (minimum of one creature). A chosen creature automatically succeeds on its saving throw against the spell."
            },
            {
                "name": "Metamagic: Distant Spell",
                "level": 3,
                "description": "When you cast a spell that has a range of 5 feet or greater, you can spend 1 sorcery point to double the range of the spell.\nWhen you cast a spell that has a range of touch, you can spend 1 sorcery point to make the range of the spell 30 feet."
            },
            {
                "name": "Metamagic: Empowered Spell",
                "level": 3,
                "description": "When you roll damage for a spell, you can spend 1 sorcery point to reroll a number of the damage dice up to your Charisma modifier (minimum of one). You must use the new rolls.\nYou can use Empowered Spell even if you have already used a different Metamagic option during the casting of the spell."
            },
            {
                "name": "Metamagic: Extended Spell",
                "level": 3,
                "description": "When you cast a spell that has a duration of 1 minute or longer, you can spend 1 sorcery point to double its duration, to a maximum duration of 24 hours."
            },
            {
                "name": "Metamagic: Heightened Spell",
                "level": 3,
                "description": "When you cast a spell that forces a creature to make a saving throw to resist its effects, you can spend 3 sorcery points to give one target of the spell disadvantage on its first saving throw made against the spell."
            },
            {
                "name": "Metamagic: Quickened Spell",
                "level": 3,
                "description": "When you cast a spell that has a casting time of 1 action, you can spend 2 sorcery points to change the casting time to 1 bonus action for this casting."
            },
            {
                "name": "Metamagic: Subtle Spell",
                "level": 3,
                "description": "When you cast a spell, you can spend 1 sorcery point to cast it without any somatic or verbal components."
            },
            {
                "name": "Metamagic: Twinned Spell",
                "level": 3,
                "description": "When you cast a spell that targets only one creature and doesn't have a range of self, you can spend a number of sorcery points equal to the spell's level to target a second creature in range with the same spell (1 sorcery point if the spell is a cantrip).\nTo be eligible, a spell must be incapable of targeting more than one creature at the spell's current level. For example, magic missile and scorching ray aren't eligible, but ray of frost is."
            },
            {
                "name": "Ability Score Improvement",
                "level": 4,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Sorcerous Origin feature",
                "level": 6,
                "description": "Choose a sorcerous origin, which describes the source of your innate magical power, such as Draconic Bloodline.\nYour choice grants you features when you choose it at 1st level and again at 6th, 14th, and 18th level."
            },
            {
                "name": "Elemental Affinity",
                "level": 6,
                "description": "Starting at 6th level, when you cast a spell that deals damage of the type associated with your draconic ancestry, you can add your Charisma modifier to one damage roll of that spell. At the same time, you can spend 1 sorcery point to gain resistance to that damage type for 1 hour.",
                "subclass": "Draconic"
            },
            {
                "name": "Ability Score Improvement",
                "level": 8,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Metamagic",
                "level": 10,
                "description": "At 3rd level, you gain the ability to twist your spells to suit your needs. You gain two of the following Metamagic options of your choice. You gain another one at 10th and 17th level.\nYou can use only one Metamagic option on a spell when you cast it, unless otherwise noted."
            },
            {
                "name": "Ability Score Improvement",
                "level": 12,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Sorcerous Origin feature",
                "level": 14,
                "description": "Choose a sorcerous origin, which describes the source of your innate magical power, such as Draconic Bloodline.\nYour choice grants you features when you choose it at 1st level and again at 6th, 14th, and 18th level."
            },
            {
                "name": "Dragon Wings",
                "level": 14,
                "description": "At 14th level, you gain the ability to sprout a pair of dragon wings from your back, gaining a flying speed equal to your current speed. You can create these wings as a bonus action on your turn. They last until you dismiss them as a bonus action on your turn.\nYou can't manifest your wings while wearing armor unless the armor is made to accommodate them, and clothing not made to accommodate your wings might be destroyed when you manifest them.",
                "subclass": "Draconic"
            },
            {
                "name": "Ability Score Improvement",
                "level": 16,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Metamagic",
                "level": 17,
                "description": "At 3rd level, you gain the ability to twist your spells to suit your needs. You gain two of the following Metamagic options of your choice. You gain another one at 10th and 17th level.\nYou can use only one Metamagic option on a spell when you cast it, unless otherwise noted."
            },
            {
                "name": "Sorcerous Origin feature",
                "level": 18,
                "description": "Choose a sorcerous origin, which describes the source of your innate magical power, such as Draconic Bloodline.\nYour choice grants you features when you choose it at 1st level and again at 6th, 14th, and 18th level."
            },
            {
                "name": "Draconic Presence",
                "level": 18,
                "description": "Beginning at 18th level, you can channel the dread presence of your dragon ancestor, causing those around you to become awestruck or frightened. As an action, you can spend 5 sorcery points to draw on this power and exude an aura of awe or fear (your choice) to a distance of 60 feet. For 1 minute or until you lose your concentration (as if you were casting a concentration spell), each hostile creature that starts its turn in this aura must succeed on a Wisdom saving throw or be charmed (if you chose awe) or frightened (if you chose fear) until the aura ends. A creature that succeeds on this saving throw is immune to your aura for 24 hours.",
                "subclass": "Draconic"
            },
            {
                "name": "Ability Score Improvement",
                "level": 19,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Sorcerous Restoration",
                "level": 20,
                "description": "At 20th level, you regain 4 expended sorcery points whenever you finish a short rest."
            }
        ],
        "levels": [
            {
                "level": 1,
                "proficiencyBonus": 2,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "spellsKnown": 2,
                    "slots": {
                        "1": 2
                    }
                },
                "classSpecific": {
                    "sorcery_points": 0,
                    "metamagic_known": 0,
                    "creating_spell_slots": []
                }
            },
            {
                "level": 1
            },
            {
                "level": 2,
                "proficiencyBonus": 2,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "spellsKnown": 3,
                    "slots": {
                        "1": 3
                    }
                },
                "classSpecific": {
                    "sorcery_points": 2,
                    "metamagic_known": 0,
                    "creating_spell_slots": [
                        {
                            "spell_slot_level": 1,
                            "sorcery_point_cost": 2
                        },
                        {
                            "spell_slot_level": 2,
                            "sorcery_point_cost": 3
                        },
                        {
                            "spell_slot_level": 3,
                            "sorcery_point_cost": 5
                        },
                        {
                            "spell_slot_level": 4,
                            "sorcery_point_cost": 6
                        },
                        {
                            "spell_slot_level": 5,
                            "sorcery_point_cost": 7
                        }
                    ]
                }
            },
            {
                "level": 3,
                "proficiencyBonus": 2,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "spellsKnown": 4,
                    "slots": {
                        "1": 4,
                        "2": 2
                    }
                },
                "classSpecific": {
                    "sorcery_points": 3,
                    "metamagic_known": 2,
                    "creating_spell_slots": [
                        {
                            "spell_slot_level": 1,
                            "sorcery_point_cost": 2
                        },
                        {
                            "spell_slot_level": 2,
                            "sorcery_point_cost": 3
                        },
                        {
                            "spell_slot_level": 3,
                            "sorcery_point_cost": 5
                        },
                        {
                            "spell_slot_level": 4,
                            "sorcery_point_cost": 6
                        },
                        {
                            "spell_slot_level": 5,
                            "sorcery_point_cost": 7
                        }
                    ]
                }
            },
            {
                "level": 4,
                "proficiencyBonus": 2,
                "spellcasting": {
                    "cantripsKnown": 5,
                    "spellsKnown": 5,
                    "slots": {
                        "1": 4,
                        "2": 3
                    }
                },
                "classSpecific": {
                    "sorcery_points": 4,
                    "metamagic_known": 2,
                    "creating_spell_slots": [
                        {
                            "spell_slot_level": 1,
                            "sorcery_point_cost": 2
                        },
                        {
                            "spell_slot_level": 2,
                            "sorcery_point_cost": 3
                        },
                        {
                            "spell_slot_level": 3,
                            "sorcery_point_cost": 5
                        },
                        {
                            "spell_slot_level": 4,
                            "sorcery_point_cost": 6
                        },
                        {
                            "spell_slot_level": 5,
                            "sorcery_point_cost": 7
                        }
                    ]
                }
            },
            {
                "level": 5,
                "proficiencyBonus": 3,
                "spellcasting": {
                    "cantripsKnown": 5,
                    "spellsKnown": 6,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 2
                    }
                },
                "classSpecific": {
                    "sorcery_points": 5,
                    "metamagic_known": 2,
                    "creating_spell_slots": [
                        {
                            "spell_slot_level": 1,
                            "sorcery_point_cost": 2
                        },
                        {
                            "spell_slot_level": 2,
                            "sorcery_point_cost": 3
                        },
                        {
                            "spell_slot_level": 3,
                            "sorcery_point_cost": 5
                        },
                        {
                            "spell_slot_level": 4,
                            "sorcery_point_cost": 6
                        },
                        {
                            "spell_slot_level": 5,
                            "sorcery_point_cost": 7
                        }
                    ]
                }
            },
            {
                "level": 6,
                "proficiencyBonus": 3,
                "spellcasting": {
                    "cantripsKnown": 5,
                    "spellsKnown": 7,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3
                    }
                },
                "classSpecific": {
                    "sorcery_points": 6,
                    "metamagic_known": 2,
                    "creating_spell_slots": [
                        {
                            "spell_slot_level": 1,
                            "sorcery_point_cost": 2
                        },
                        {
                            "spell_slot_level": 2,
                            "sorcery_point_cost": 3
                        },
                        {
                            "spell_slot_level": 3,
                            "sorcery_point_cost": 5
                        },
                        {
                            "spell_slot_level": 4,
                            "sorcery_point_cost": 6
                        },
                        {
                            "spell_slot_level": 5,
                            "sorcery_point_cost": 7
                        }
                    ]
                }
            },
            {
                "level": 6
            },
            {
                "level": 7,
                "proficiencyBonus": 3,
                "spellcasting": {
                    "cantripsKnown": 5,
                    "spellsKnown": 8,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 1
                    }
                },
                "classSpecific": {
                    "sorcery_points": 7,
                    "metamagic_known": 2,
                    "creating_spell_slots": [
                        {
                            "spell_slot_level": 1,
                            "sorcery_point_cost": 2
                        },
                        {
                            "spell_slot_level": 2,
                            "sorcery_point_cost": 3
                        },
                        {
                            "spell_slot_level": 3,
                            "sorcery_point_cost": 5
                        },
                        {
                            "spell_slot_level": 4,
                            "sorcery_point_cost": 6
                        },
                        {
                            "spell_slot_level": 5,
                            "sorcery_point_cost": 7
                        }
                    ]
                }
            },
            {
                "level": 8,
                "proficiencyBonus": 3,
                "spellcasting": {
                    "cantripsKnown": 5,
                    "spellsKnown": 9,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 2
                    }
                },
                "classSpecific": {
                    "sorcery_points": 8,
                    "metamagic_known": 2,
                    "creating_spell_slots": [
                        {
                            "spell_slot_level": 1,
                            "sorcery_point_cost": 2
                        },
                        {
                            "spell_slot_level": 2,
                            "sorcery_point_cost": 3
                        },
                        {
                            "spell_slot_level": 3,
                            "sorcery_point_cost": 5
                        },
                        {
                            "spell_slot_level": 4,
                            "sorcery_point_cost": 6
                        },
                        {
                            "spell_slot_level": 5,
                            "sorcery_point_cost": 7
                        }
                    ]
                }
            },
            {
                "level": 9,
                "proficiencyBonus": 4,
                "spellcasting": {
                    "cantripsKnown": 5,
                    "spellsKnown": 10,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 1
                    }
                },
                "classSpecific": {
                    "sorcery_points": 9,
                    "metamagic_known": 2,
                    "creating_spell_slots": [
                        {
                            "spell_slot_level": 1,
                            "sorcery_point_cost": 2
                        },
                        {
                            "spell_slot_level": 2,
                            "sorcery_point_cost": 3
                        },
                        {
                            "spell_slot_level": 3,
                            "sorcery_point_cost": 5
                        },
                        {
                            "spell_slot_level": 4,
                            "sorcery_point_cost": 6
                        },
                        {
                            "spell_slot_level": 5,
                            "sorcery_point_cost": 7
                        }
                    ]
                }
            },
            {
                "level": 10,
                "proficiencyBonus": 4,
                "spellcasting": {
                    "cantripsKnown": 6,
                    "spellsKnown": 11,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2
                    }
                },
                "classSpecific": {
                    "sorcery_points": 10,
                    "metamagic_known": 3,
                    "creating_spell_slots": [
                        {
                            "spell_slot_level": 1,
                            "sorcery_point_cost": 2
                        },
                        {
                            "spell_slot_level": 2,
                            "sorcery_point_cost": 3
                        },
                        {
                            "spell_slot_level": 3,
                            "sorcery_point_cost": 5
                        },
                        {
                            "spell_slot_level": 4,
                            "sorcery_point_cost": 6
                        },
                        {
                            "spell_slot_level": 5,
                            "sorcery_point_cost": 7
                        }
                    ]
                }
            },
            {
                "level": 11,
                "proficiencyBonus": 4,
                "spellcasting": {
                    "cantripsKnown": 6,
                    "spellsKnown": 12,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2,
                        "6": 1
                    }
                },
                "classSpecific": {
                    "sorcery_points": 11,
                    "metamagic_known": 3,
                    "creating_spell_slots": [
                        {
                            "spell_slot_level": 1,
                            "sorcery_point_cost": 2
                        },
                        {
                            "spell_slot_level": 2,
                            "sorcery_point_cost": 3
                        },
                        {
                            "spell_slot_level": 3,
                            "sorcery_point_cost": 5
                        },
                        {
                            "spell_slot_level": 4,
                            "sorcery_point_cost": 6
                        },
                        {
                            "spell_slot_level": 5,
                            "sorcery_point_cost": 7
                        }
                    ]
                }
            },
            {
                "level": 12,
                "proficiencyBonus": 4,
                "spellcasting": {
                    "cantripsKnown": 6,
                    "spellsKnown": 12,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2,
                        "6": 1
                    }
                },
                "classSpecific": {
                    "sorcery_points": 12,
                    "metamagic_known": 3,
                    "creating_spell_slots": [
                        {
                            "spell_slot_level": 1,
                            "sorcery_point_cost": 2
                        },
                        {
                            "spell_slot_level": 2,
                            "sorcery_point_cost": 3
                        },
                        {
                            "spell_slot_level": 3,
                            "sorcery_point_cost": 5
                        },
                        {
                            "spell_slot_level": 4,
                            "sorcery_point_cost": 6
                        },
                        {
                            "spell_slot_level": 5,
                            "sorcery_point_cost": 7
                        }
                    ]
                }
            },
            {
                "level": 13,
                "proficiencyBonus": 5,
                "spellcasting": {
                    "cantripsKnown": 6,
                    "spellsKnown": 13,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2,
                        "6": 1,
                        "7": 1
                    }
                },
                "classSpecific": {
                    "sorcery_points": 13,
                    "metamagic_known": 3,
                    "creating_spell_slots": [
                        {
                            "spell_slot_level": 1,
                            "sorcery_point_cost": 2
                        },
                        {
                            "spell_slot_level": 2,
                            "sorcery_point_cost": 3
                        },
                        {
                            "spell_slot_level": 3,
                            "sorcery_point_cost": 5
                        },
                        {
                            "spell_slot_level": 4,
                            "sorcery_point_cost": 6
                        },
                        {
                            "spell_slot_level": 5,
                            "sorcery_point_cost": 7
                        }
                    ]
                }
            },
            {
                "level": 14,
                "proficiencyBonus": 5,
                "spellcasting": {
                    "cantripsKnown": 6,
                    "spellsKnown": 13,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2,
                        "6": 1,
                        "7": 1
                    }
                },
                "classSpecific": {
                    "sorcery_points": 14,
                    "metamagic_known": 3,
                    "creating_spell_slots": [
                        {
                            "spell_slot_level": 1,
                            "sorcery_point_cost": 2
                        },
                        {
                            "spell_slot_level": 2,
                            "sorcery_point_cost": 3
                        },
                        {
                            "spell_slot_level": 3,
                            "sorcery_point_cost": 5
                        },
                        {
                            "spell_slot_level": 4,
                            "sorcery_point_cost": 6
                        },
                        {
                            "spell_slot_level": 5,
                            "sorcery_point_cost": 7
                        }
                    ]
                }
            },
            {
                "level": 14
            },
            {
                "level": 15,
                "proficiencyBonus": 5,
                "spellcasting": {
                    "cantripsKnown": 6,
                    "spellsKnown": 14,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2,
                        "6": 1,
                        "7": 1,
                        "8": 1
                    }
                },
                "classSpecific": {
                    "sorcery_points": 15,
                    "metamagic_known": 3,
                    "creating_spell_slots": [
                        {
                            "spell_slot_level": 1,
                            "sorcery_point_cost": 2
                        },
                        {
                            "spell_slot_level": 2,
                            "sorcery_point_cost": 3
                        },
                        {
                            "spell_slot_level": 3,
                            "sorcery_point_cost": 5
                        },
                        {
                            "spell_slot_level": 4,
                            "sorcery_point_cost": 6
                        },
                        {
                            "spell_slot_level": 5,
                            "sorcery_point_cost": 7
                        }
                    ]
                }
            },
            {
                "level": 16,
                "proficiencyBonus": 5,
                "spellcasting": {
                    "cantripsKnown": 6,
                    "spellsKnown": 14,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2,
                        "6": 1,
                        "7": 1,
                        "8": 1
                    }
                },
                "classSpecific": {
                    "sorcery_points": 16,
                    "metamagic_known": 4,
                    "creating_spell_slots": [
                        {
                            "spell_slot_level": 1,
                            "sorcery_point_cost": 2
                        },
                        {
                            "spell_slot_level": 2,
                            "sorcery_point_cost": 3
                        },
                        {
                            "spell_slot_level": 3,
                            "sorcery_point_cost": 5
                        },
                        {
                            "spell_slot_level": 4,
                            "sorcery_point_cost": 6
                        },
                        {
                            "spell_slot_level": 5,
                            "sorcery_point_cost": 7
                        }
                    ]
                }
            },
            {
                "level": 17,
                "proficiencyBonus": 6,
                "spellcasting": {
                    "cantripsKnown": 6,
                    "spellsKnown": 15,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2,
                        "6": 1,
                        "7": 1,
                        "8": 1,
                        "9": 1
                    }
                },
                "classSpecific": {
                    "sorcery_points": 17,
                    "metamagic_known": 4,
                    "creating_spell_slots": [
                        {
                            "spell_slot_level": 1,
                            "sorcery_point_cost": 2
                        },
                        {
                            "spell_slot_level": 2,
                            "sorcery_point_cost": 3
                        },
                        {
                            "spell_slot_level": 3,
                            "sorcery_point_cost": 5
                        },
                        {
                            "spell_slot_level": 4,
                            "sorcery_point_cost": 6
                        },
                        {
                            "spell_slot_level": 5,
                            "sorcery_point_cost": 7
                        }
                    ]
                }
            },
            {
                "level": 18,
                "proficiencyBonus": 6,
                "spellcasting": {
                    "cantripsKnown": 6,
                    "spellsKnown": 15,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 3,
                        "6": 1,
                        "7": 1,
                        "8": 1,
                        "9": 1
                    }
                },
                "classSpecific": {
                    "sorcery_points": 18,
                    "metamagic_known": 4,
                    "creating_spell_slots": [
                        {
                            "spell_slot_level": 1,
                            "sorcery_point_cost": 2
                        },
                        {
                            "spell_slot_level": 2,
                            "sorcery_point_cost": 3
                        },
                        {
                            "spell_slot_level": 3,
                            "sorcery_point_cost": 5
                        },
                        {
                            "spell_slot_level": 4,
                            "sorcery_point_cost": 6
                        },
                        {
                            "spell_slot_level": 5,
                            "sorcery_point_cost": 7
                        }
                    ]
                }
            },
            {
                "level": 18
            },
            {
                "level": 19,
                "proficiencyBonus": 6,
                "spellcasting": {
                    "cantripsKnown": 6,
                    "spellsKnown": 15,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 3,
                        "6": 2,
                        "7": 1,
                        "8": 1,
                        "9": 1
                    }
                },
                "classSpecific": {
                    "sorcery_points": 19,
                    "metamagic_known": 4,
                    "creating_spell_slots": [
                        {
                            "spell_slot_level": 1,
                            "sorcery_point_cost": 2
                        },
                        {
                            "spell_slot_level": 2,
                            "sorcery_point_cost": 3
                        },
                        {
                            "spell_slot_level": 3,
                            "sorcery_point_cost": 5
                        },
                        {
                            "spell_slot_level": 4,
                            "sorcery_point_cost": 6
                        },
                        {
                            "spell_slot_level": 5,
                            "sorcery_point_cost": 7
                        }
                    ]
                }
            },
            {
                "level": 20,
                "proficiencyBonus": 6,
                "spellcasting": {
                    "cantripsKnown": 6,
                    "spellsKnown": 15,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 3,
                        "6": 2,
                        "7": 2,
                        "8": 1,
                        "9": 1
                    }
                },
                "classSpecific": {
                    "sorcery_points": 20,
                    "metamagic_known": 4,
                    "creating_spell_slots": [
                        {
                            "spell_slot_level": 1,
                            "sorcery_point_cost": 2
                        },
                        {
                            "spell_slot_level": 2,
                            "sorcery_point_cost": 3
                        },
                        {
                            "spell_slot_level": 3,
                            "sorcery_point_cost": 5
                        },
                        {
                            "spell_slot_level": 4,
                            "sorcery_point_cost": 6
                        },
                        {
                            "spell_slot_level": 5,
                            "sorcery_point_cost": 7
                        }
                    ]
                }
            }
        ],
        "spellcastingAbility": "cha"
    },
    {
        "slug": "warlock",
        "name": "Warlock",
        "hitDie": 8,
        "savingThrows": [
            "WIS",
            "CHA"
        ],
        "proficiencies": [
            "Light Armor",
            "Simple Weapons",
            "Saving Throw: WIS",
            "Saving Throw: CHA"
        ],
        "skillChoices": [
            {
                "choose": 2,
                "from": [
                    "Arcana",
                    "Deception",
                    "History",
                    "Intimidation",
                    "Investigation",
                    "Nature",
                    "Religion"
                ]
            }
        ],
        "subclass": {
            "name": "Fiend",
            "description": "You have made a pact with a fiend from the lower planes of existence, a being whose aims are evil, even if you strive against those aims. Such beings desire the corruption or destruction of all things, ultimately including you. Fiends powerful enough to forge a pact include demon lords such as Demogorgon, Orcus, Fraz'Urb-luu, and Baphomet; archdevils such as Asmodeus, Dispater, Mephistopheles, and Belial; pit fiends and balors that are especially mighty; and ultroloths and other lords of the yugoloths."
        },
        "features": [
            {
                "name": "Otherworldly Patron",
                "level": 1,
                "description": "At 1st level, you have struck a bargain with an otherworldly being of your choice, such as the Fiend. Your choice grants you features at 1st level and again at 6th, 10th, and 14th level."
            },
            {
                "name": "Dark One's Blessing",
                "level": 1,
                "description": "Starting at 1st level, when you reduce a hostile creature to 0 hit points, you gain temporary hit points equal to your Charisma modifier + your warlock level (minimum of 1).",
                "subclass": "Fiend"
            },
            {
                "name": "Pact Magic",
                "level": 1,
                "description": "Your arcane research and the magic bestowed on you by your patron have given you facility with spells."
            },
            {
                "name": "Eldritch Invocations",
                "level": 2,
                "description": "In your study of occult lore, you have unearthed eldritch invocations, fragments of forbidden knowledge that imbue you with an abiding magical ability.\nAt 2nd level, you gain two eldritch invocations of your choice. Your invocation options are detailed at the end of the class description. When you gain certain warlock levels, you gain additional invocations of your choice, as shown in the Invocations Known column of the Warlock table.\nAdditionally, when you gain a level in this class, you can choose one of the invocations you know and replace it with another invocation that you could learn at that level."
            },
            {
                "name": "Eldritch Invocation: Agonizing Blast",
                "level": 2,
                "description": "When you cast eldritch blast, add your Charisma modifier to the damage it deals on a hit."
            },
            {
                "name": "Eldritch Invocation: Armor of Shadows",
                "level": 2,
                "description": "You can cast mage armor on yourself at will, without expending a spell slot or material components."
            },
            {
                "name": "Eldritch Invocation: Beast Speech",
                "level": 2,
                "description": "You can cast speak with animals at will, without expending a spell slot."
            },
            {
                "name": "Eldritch Invocation: Beguiling Influence",
                "level": 2,
                "description": "You gain proficiency in the Deception and Persuasion skills."
            },
            {
                "name": "Eldritch Invocation: Book of Ancient Secrets",
                "level": 2,
                "description": "You can now inscribe magical rituals in your Book of Shadows. Choose two 1st-level spells that have the ritual tag from any class's spell list (the two needn't be from the same list). The spells appear in the book and don't count against the number of spells you know. With your Book of Shadows in hand, you can cast the chosen spells as rituals. You can't cast the spells except as rituals, unless you've learned them by some other means. You can also cast a warlock spell you know as a ritual if it has the ritual tag.\nOn your adventures, you can add other ritual spells to your Book of Shadows. When you find such a spell, you can add it to the book if the spell's level is equal to or less than half your warlock level (rounded up) and if you can spare the time to transcribe the spell. For each level of the spell, the transcription process takes 2 hours and costs 50 gp for the rare inks needed to inscribe it."
            },
            {
                "name": "Eldritch Invocation: Devil's Sight",
                "level": 2,
                "description": "You can see normally in darkness, both magical and nonmagical, to a distance of 120 feet."
            },
            {
                "name": "Eldritch Invocation: Eldritch Sight",
                "level": 2,
                "description": "You can cast detect magic at will, without expending a spell slot."
            },
            {
                "name": "Eldritch Invocation: Eldritch Spear",
                "level": 2,
                "description": "When you cast eldritch blast, its range is 300 feet."
            },
            {
                "name": "Eldritch Invocation: Eyes of the Rune Keeper",
                "level": 2,
                "description": "You can read all writing."
            },
            {
                "name": "Eldritch Invocation: Fiendish Vigor",
                "level": 2,
                "description": "You can cast false life on yourself at will as a 1st-level spell, without expending a spell slot or material components."
            },
            {
                "name": "Eldritch Invocation: Gaze of Two Minds",
                "level": 2,
                "description": "You can use your action to touch a willing humanoid and perceive through its senses until the end of your next turn. As long as the creature is on the same plane of existence as you, you can use your action on subsequent turns to maintain this connection, extending the duration until the end of your next turn. While perceiving through the other creature's senses, you benefit from any special senses possessed by that creature, and you are blinded and deafened to your own surroundings."
            },
            {
                "name": "Eldritch Invocation: Mask of Many Faces",
                "level": 2,
                "description": "You can cast disguise self at will, without expending a spell slot."
            },
            {
                "name": "Eldritch Invocation: Misty Visions",
                "level": 2,
                "description": "You can cast silent image at will, without expending a spell slot or material components."
            },
            {
                "name": "Eldritch Invocation: Repelling Blast",
                "level": 2,
                "description": "When you hit a creature with eldritch blast, you can push the creature up to 10 feet away from you in a straight line."
            },
            {
                "name": "Eldritch Invocation: Thief of Five Fates",
                "level": 2,
                "description": "You can cast bane once using a warlock spell slot. You can't do so again until you finish a long rest."
            },
            {
                "name": "Eldritch Invocation: Voice of the Chain Master",
                "level": 2,
                "description": "You can communicate telepathically with your familiar and perceive through your familiar's senses as long as you are on the same plane of existence.\nAdditionally, while perceiving through your familiar's senses, you can also speak through your familiar in your own voice, even if your familiar is normally incapable of speech."
            },
            {
                "name": "Pact Boon",
                "level": 3,
                "description": "At 3rd level, your otherworldly patron bestows a gift upon you for your loyal service. You gain one of the following features of your choice."
            },
            {
                "name": "Pact of the Chain",
                "level": 3,
                "description": "You learn the find familiar spell and can cast it as a ritual. The spell doesn't count against your number of spells known.\nWhen you cast the spell, you can choose one of the normal forms for your familiar or one of the following special forms: imp, pseudodragon, quasit, or sprite.\nAdditionally, when you take the Attack action, you can forgo one of your own attacks to allow your familiar to make one attack of its own with its reaction.\nYour familiar is more cunning than a typical familiar. Its default form can be a reflection of your patron, with imps and quasits tied to the Fiend."
            },
            {
                "name": "Pact of the Blade",
                "level": 3,
                "description": "You can use your action to create a pact weapon in your empty hand. You can choose the form that this melee weapon takes each time you create it. You are proficient with it while you wield it. This weapon counts as magical for the purpose of overcoming resistance and immunity to nonmagical attacks and damage.\nYour pact weapon disappears if it is more than 5 feet away from you for 1 minute or more. It also disappears if you use this feature again, if you dismiss the weapon (no action required), or if you die.\nYou can transform one magic weapon into your pact weapon by performing a special ritual while you hold the weapon. You perform the ritual over the course of 1 hour, which can be done during a short rest. You can then dismiss the weapon, shunting it into an extradimensional space, and it appears whenever you create your pact weapon thereafter. You can't affect an artifact or a sentient weapon in this way. The weapon ceases being your pact weapon if you die, if you perform the 1-hour ritual on a different weapon, or if you use a 1-hour ritual to break your bond to it. The weapon appears at your feet if it is in the extradimensional space when the bond breaks.\nIf you serve the Fiend, your weapon could be an axe made of black metal and adorned with decorative flames."
            },
            {
                "name": "Pact of the Tome",
                "level": 3,
                "description": "Your patron gives you a grimoire called a Book of Shadows. When you gain this feature, choose three cantrips from any class's spell list (the three needn't be from the same list). While the book is on your person, you can cast those cantrips at will. They don't count against your number of cantrips known. If they don't appear on the warlock spell list, they are nonetheless warlock spells for you.\nIf you lose your Book of Shadows, you can perform a 1-hour ceremony to receive a replacement from your patron. This ceremony can be performed during a short or long rest, and it destroys the previous book. The book turns to ash when you die.\nYour Book of Shadows could be a weighty tome bound in demon hide studded with iron, holding spells of conjuration and a wealth of forbidden lore about the sinister regions of the cosmos, a gift of the Fiend."
            },
            {
                "name": "Ability Score Improvement",
                "level": 4,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Eldritch Invocation: Mire the Mind",
                "level": 5,
                "description": "You can cast slow once using a warlock spell slot. You can't do so again until you finish a long rest."
            },
            {
                "name": "Eldritch Invocation: One with Shadows",
                "level": 5,
                "description": "When you are in an area of dim light or darkness, you can use your action to become invisible until you move or take an action or a reaction."
            },
            {
                "name": "Eldritch Invocation: Sign of Ill Omen",
                "level": 5,
                "description": "You can cast bestow curse once using a warlock spell slot. You can't do so again until you finish a long rest."
            },
            {
                "name": "Eldritch Invocation: Thirsting Blade",
                "level": 5,
                "description": "You can attack with your pact weapon twice, instead of once, whenever you take the Attack action on your turn."
            },
            {
                "name": "Otherworldly Patron feature",
                "level": 6,
                "description": "At 1st level, you have struck a bargain with an otherworldly being of your choice, such as the Fiend. Your choice grants you features at 1st level and again at 6th, 10th, and 14th level."
            },
            {
                "name": "Dark One's Own Luck",
                "level": 6,
                "description": "Starting at 6th level, you can call on your patron to alter fate in your favor. When you make an ability check or a saving throw, you can use this feature to add a d10 to your roll. You can do so after seeing the initial roll but before any of the roll's effects occur.\nOnce you use this feature, you can't use it again until you finish a short or long rest.",
                "subclass": "Fiend"
            },
            {
                "name": "Eldritch Invocation: Bewitching Whispers",
                "level": 7,
                "description": "You can cast compulsion once using a warlock spell slot. You can't do so again until you finish a long rest."
            },
            {
                "name": "Eldritch Invocation: Dreadful Word",
                "level": 7,
                "description": "You can cast confusion once using a warlock spell slot. You can't do so again until you finish a long rest."
            },
            {
                "name": "Eldritch Invocation: Sculptor of Flesh",
                "level": 7,
                "description": "You can cast polymorph once using a warlock spell slot. You can't do so again until you finish a long rest."
            },
            {
                "name": "Ability Score Improvement",
                "level": 8,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Eldritch Invocation: Ascendant Step",
                "level": 9,
                "description": "You can cast levitate on yourself at will, without expending a spell slot or material components."
            },
            {
                "name": "Eldritch Invocation: Minions of Chaos",
                "level": 9,
                "description": "You can cast conjure elemental once using a warlock spell slot. You can't do so again until you finish a long rest."
            },
            {
                "name": "Eldritch Invocation: Otherworldly Leap",
                "level": 9,
                "description": "You can cast jump on yourself at will, without expending a spell slot or material components."
            },
            {
                "name": "Eldritch Invocation: Whispers of the Grave",
                "level": 9,
                "description": "You can cast speak with dead at will, without expending a spell slot."
            },
            {
                "name": "Otherworldly Patron feature",
                "level": 10,
                "description": "At 1st level, you have struck a bargain with an otherworldly being of your choice, such as the Fiend. Your choice grants you features at 1st level and again at 6th, 10th, and 14th level."
            },
            {
                "name": "Fiendish Resilience",
                "level": 10,
                "description": "Starting at 10th level, you can choose one damage type when you finish a short or long rest. You gain resistance to that damage type until you choose a different one with this feature. Damage from magical weapons or silver weapons ignores this resistance.",
                "subclass": "Fiend"
            },
            {
                "name": "Mystic Arcanum (6th level)",
                "level": 11,
                "description": "At 11th level, your patron bestows upon you a magical secret called an arcanum. Choose one 6th- level spell from the warlock spell list as this arcanum.\nYou can cast your arcanum spell once without expending a spell slot. You must finish a long rest before you can do so again.\nAt higher levels, you gain more warlock spells of your choice that can be cast in this way: one 7th- level spell at 13th level, one 8th-level spell at 15th level, and one 9th-level spell at 17th level. You regain all uses of your Mystic Arcanum when you finish a long rest."
            },
            {
                "name": "Eldritch Invocation: Lifedrinker",
                "level": 12,
                "description": "When you hit a creature with your pact weapon, the creature takes extra necrotic damage equal to your Charisma modifier (minimum 1)."
            },
            {
                "name": "Ability Score Improvement",
                "level": 12,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Mystic Arcanum (7th level)",
                "level": 13,
                "description": "At 11th level, your patron bestows upon you a magical secret called an arcanum. Choose one 6th- level spell from the warlock spell list as this arcanum.\nYou can cast your arcanum spell once without expending a spell slot. You must finish a long rest before you can do so again.\nAt higher levels, you gain more warlock spells of your choice that can be cast in this way: one 7th- level spell at 13th level, one 8th-level spell at 15th level, and one 9th-level spell at 17th level. You regain all uses of your Mystic Arcanum when you finish a long rest."
            },
            {
                "name": "Otherworldly Patron feature",
                "level": 14,
                "description": "At 1st level, you have struck a bargain with an otherworldly being of your choice, such as the Fiend. Your choice grants you features at 1st level and again at 6th, 10th, and 14th level."
            },
            {
                "name": "Hurl Through Hell",
                "level": 14,
                "description": "Starting at 14th level, when you hit a creature with an attack, you can use this feature to instantly transport the target through the lower planes. The creature disappears and hurtles through a nightmare landscape.\nAt the end of your next turn, the target returns to the space it previously occupied, or the nearest unoccupied space. If the target is not a fiend, it takes 10d10 psychic damage as it reels from its horrific experience.\nOnce you use this feature, you can't use it again until you finish a long rest.",
                "subclass": "Fiend"
            },
            {
                "name": "Eldritch Invocation: Chains of Carceri",
                "level": 15,
                "description": "You can cast hold monster at will--targeting a celestial, fiend, or elemental--without expending a spell slot or material components. You must finish a long rest before you can use this invocation on the same creature again."
            },
            {
                "name": "Eldritch Invocation: Master of Myriad Forms",
                "level": 15,
                "description": "You can cast alter self at will, without expending a spell slot."
            },
            {
                "name": "Eldritch Invocation: Visions of Distant Realms",
                "level": 15,
                "description": "You can cast arcane eye at will, without expending a spell slot."
            },
            {
                "name": "Eldritch Invocation: Witch Sight",
                "level": 15,
                "description": "You can see the true form of any shapechanger or creature concealed by illusion or transmutation magic while the creature is within 30 feet of you and within line of sight."
            },
            {
                "name": "Mystic Arcanum (8th level)",
                "level": 15,
                "description": "At 11th level, your patron bestows upon you a magical secret called an arcanum. Choose one 6th- level spell from the warlock spell list as this arcanum.\nYou can cast your arcanum spell once without expending a spell slot. You must finish a long rest before you can do so again.\nAt higher levels, you gain more warlock spells of your choice that can be cast in this way: one 7th- level spell at 13th level, one 8th-level spell at 15th level, and one 9th-level spell at 17th level. You regain all uses of your Mystic Arcanum when you finish a long rest."
            },
            {
                "name": "Ability Score Improvement",
                "level": 16,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Mystic Arcanum (9th level)",
                "level": 17,
                "description": "At 11th level, your patron bestows upon you a magical secret called an arcanum. Choose one 6th- level spell from the warlock spell list as this arcanum.\nYou can cast your arcanum spell once without expending a spell slot. You must finish a long rest before you can do so again.\nAt higher levels, you gain more warlock spells of your choice that can be cast in this way: one 7th- level spell at 13th level, one 8th-level spell at 15th level, and one 9th-level spell at 17th level. You regain all uses of your Mystic Arcanum when you finish a long rest."
            },
            {
                "name": "Ability Score Improvement",
                "level": 19,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Eldritch Master",
                "level": 20,
                "description": "At 20th level, you can draw on your inner reserve of mystical power while entreating your patron to regain expended spell slots. You can spend 1 minute entreating your patron for aid to regain all your expended spell slots from your Pact Magic feature.\nOnce you regain spell slots with this feature, you must finish a long rest before you can do so again."
            }
        ],
        "levels": [
            {
                "level": 1,
                "proficiencyBonus": 2,
                "spellcasting": {
                    "cantripsKnown": 2,
                    "spellsKnown": 2,
                    "slots": {
                        "1": 1
                    }
                },
                "classSpecific": {
                    "invocations_known": 0,
                    "mystic_arcanum_level_6": 0,
                    "mystic_arcanum_level_7": 0,
                    "mystic_arcanum_level_8": 0,
                    "mystic_arcanum_level_9": 0
                }
            },
            {
                "level": 1
            },
            {
                "level": 2,
                "proficiencyBonus": 2,
                "spellcasting": {
                    "cantripsKnown": 2,
                    "spellsKnown": 3,
                    "slots": {
                        "1": 2
                    }
                },
                "classSpecific": {
                    "invocations_known": 2,
                    "mystic_arcanum_level_6": 0,
                    "mystic_arcanum_level_7": 0,
                    "mystic_arcanum_level_8": 0,
                    "mystic_arcanum_level_9": 0
                }
            },
            {
                "level": 3,
                "proficiencyBonus": 2,
                "spellcasting": {
                    "cantripsKnown": 2,
                    "spellsKnown": 4,
                    "slots": {
                        "2": 2
                    }
                },
                "classSpecific": {
                    "invocations_known": 2,
                    "mystic_arcanum_level_6": 0,
                    "mystic_arcanum_level_7": 0,
                    "mystic_arcanum_level_8": 0,
                    "mystic_arcanum_level_9": 0
                }
            },
            {
                "level": 4,
                "proficiencyBonus": 2,
                "spellcasting": {
                    "cantripsKnown": 3,
                    "spellsKnown": 5,
                    "slots": {
                        "2": 2
                    }
                },
                "classSpecific": {
                    "invocations_known": 3,
                    "mystic_arcanum_level_6": 0,
                    "mystic_arcanum_level_7": 0,
                    "mystic_arcanum_level_8": 0,
                    "mystic_arcanum_level_9": 0
                }
            },
            {
                "level": 5,
                "proficiencyBonus": 3,
                "spellcasting": {
                    "cantripsKnown": 3,
                    "spellsKnown": 6,
                    "slots": {
                        "3": 2
                    }
                },
                "classSpecific": {
                    "invocations_known": 3,
                    "mystic_arcanum_level_6": 0,
                    "mystic_arcanum_level_7": 0,
                    "mystic_arcanum_level_8": 0,
                    "mystic_arcanum_level_9": 0
                }
            },
            {
                "level": 6,
                "proficiencyBonus": 3,
                "spellcasting": {
                    "cantripsKnown": 3,
                    "spellsKnown": 7,
                    "slots": {
                        "3": 2
                    }
                },
                "classSpecific": {
                    "invocations_known": 4,
                    "mystic_arcanum_level_6": 0,
                    "mystic_arcanum_level_7": 0,
                    "mystic_arcanum_level_8": 0,
                    "mystic_arcanum_level_9": 0
                }
            },
            {
                "level": 6
            },
            {
                "level": 7,
                "proficiencyBonus": 3,
                "spellcasting": {
                    "cantripsKnown": 3,
                    "spellsKnown": 8,
                    "slots": {
                        "4": 2
                    }
                },
                "classSpecific": {
                    "invocations_known": 4,
                    "mystic_arcanum_level_6": 0,
                    "mystic_arcanum_level_7": 0,
                    "mystic_arcanum_level_8": 0,
                    "mystic_arcanum_level_9": 0
                }
            },
            {
                "level": 8,
                "proficiencyBonus": 3,
                "spellcasting": {
                    "cantripsKnown": 3,
                    "spellsKnown": 9,
                    "slots": {
                        "4": 2
                    }
                },
                "classSpecific": {
                    "invocations_known": 4,
                    "mystic_arcanum_level_6": 0,
                    "mystic_arcanum_level_7": 0,
                    "mystic_arcanum_level_8": 0,
                    "mystic_arcanum_level_9": 0
                }
            },
            {
                "level": 9,
                "proficiencyBonus": 4,
                "spellcasting": {
                    "cantripsKnown": 3,
                    "spellsKnown": 10,
                    "slots": {
                        "5": 2
                    }
                },
                "classSpecific": {
                    "invocations_known": 5,
                    "mystic_arcanum_level_6": 0,
                    "mystic_arcanum_level_7": 0,
                    "mystic_arcanum_level_8": 0,
                    "mystic_arcanum_level_9": 0
                }
            },
            {
                "level": 10,
                "proficiencyBonus": 4,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "spellsKnown": 10,
                    "slots": {
                        "5": 2
                    }
                },
                "classSpecific": {
                    "invocations_known": 5,
                    "mystic_arcanum_level_6": 0,
                    "mystic_arcanum_level_7": 0,
                    "mystic_arcanum_level_8": 0,
                    "mystic_arcanum_level_9": 0
                }
            },
            {
                "level": 10
            },
            {
                "level": 11,
                "proficiencyBonus": 4,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "spellsKnown": 11,
                    "slots": {
                        "5": 3
                    }
                },
                "classSpecific": {
                    "invocations_known": 5,
                    "mystic_arcanum_level_6": 1,
                    "mystic_arcanum_level_7": 0,
                    "mystic_arcanum_level_8": 0,
                    "mystic_arcanum_level_9": 0
                }
            },
            {
                "level": 12,
                "proficiencyBonus": 4,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "spellsKnown": 11,
                    "slots": {
                        "5": 3
                    }
                },
                "classSpecific": {
                    "invocations_known": 6,
                    "mystic_arcanum_level_6": 1,
                    "mystic_arcanum_level_7": 0,
                    "mystic_arcanum_level_8": 0,
                    "mystic_arcanum_level_9": 0
                }
            },
            {
                "level": 13,
                "proficiencyBonus": 5,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "spellsKnown": 12,
                    "slots": {
                        "5": 3
                    }
                },
                "classSpecific": {
                    "invocations_known": 6,
                    "mystic_arcanum_level_6": 1,
                    "mystic_arcanum_level_7": 1,
                    "mystic_arcanum_level_8": 0,
                    "mystic_arcanum_level_9": 0
                }
            },
            {
                "level": 14,
                "proficiencyBonus": 5,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "spellsKnown": 12,
                    "slots": {
                        "5": 3
                    }
                },
                "classSpecific": {
                    "invocations_known": 6,
                    "mystic_arcanum_level_6": 1,
                    "mystic_arcanum_level_7": 1,
                    "mystic_arcanum_level_8": 0,
                    "mystic_arcanum_level_9": 0
                }
            },
            {
                "level": 14
            },
            {
                "level": 15,
                "proficiencyBonus": 5,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "spellsKnown": 13,
                    "slots": {
                        "5": 3
                    }
                },
                "classSpecific": {
                    "invocations_known": 7,
                    "mystic_arcanum_level_6": 1,
                    "mystic_arcanum_level_7": 1,
                    "mystic_arcanum_level_8": 1,
                    "mystic_arcanum_level_9": 0
                }
            },
            {
                "level": 16,
                "proficiencyBonus": 5,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "spellsKnown": 13,
                    "slots": {
                        "5": 3
                    }
                },
                "classSpecific": {
                    "invocations_known": 7,
                    "mystic_arcanum_level_6": 1,
                    "mystic_arcanum_level_7": 1,
                    "mystic_arcanum_level_8": 1,
                    "mystic_arcanum_level_9": 0
                }
            },
            {
                "level": 17,
                "proficiencyBonus": 6,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "spellsKnown": 14,
                    "slots": {
                        "5": 4
                    }
                },
                "classSpecific": {
                    "invocations_known": 7,
                    "mystic_arcanum_level_6": 1,
                    "mystic_arcanum_level_7": 1,
                    "mystic_arcanum_level_8": 1,
                    "mystic_arcanum_level_9": 1
                }
            },
            {
                "level": 18,
                "proficiencyBonus": 6,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "spellsKnown": 14,
                    "slots": {
                        "5": 4
                    }
                },
                "classSpecific": {
                    "invocations_known": 8,
                    "mystic_arcanum_level_6": 1,
                    "mystic_arcanum_level_7": 1,
                    "mystic_arcanum_level_8": 1,
                    "mystic_arcanum_level_9": 1
                }
            },
            {
                "level": 19,
                "proficiencyBonus": 6,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "spellsKnown": 15,
                    "slots": {
                        "5": 4
                    }
                },
                "classSpecific": {
                    "invocations_known": 8,
                    "mystic_arcanum_level_6": 1,
                    "mystic_arcanum_level_7": 1,
                    "mystic_arcanum_level_8": 1,
                    "mystic_arcanum_level_9": 1
                }
            },
            {
                "level": 20,
                "proficiencyBonus": 6,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "spellsKnown": 15,
                    "slots": {
                        "5": 4
                    }
                },
                "classSpecific": {
                    "invocations_known": 8,
                    "mystic_arcanum_level_6": 1,
                    "mystic_arcanum_level_7": 1,
                    "mystic_arcanum_level_8": 1,
                    "mystic_arcanum_level_9": 1
                }
            }
        ],
        "spellcastingAbility": "cha"
    },
    {
        "slug": "wizard",
        "name": "Wizard",
        "hitDie": 6,
        "savingThrows": [
            "INT",
            "WIS"
        ],
        "proficiencies": [
            "Daggers",
            "Darts",
            "Slings",
            "Quarterstaffs",
            "Crossbows, light",
            "Saving Throw: INT",
            "Saving Throw: WIS"
        ],
        "skillChoices": [
            {
                "choose": 2,
                "from": [
                    "Arcana",
                    "History",
                    "Insight",
                    "Investigation",
                    "Medicine",
                    "Religion"
                ]
            }
        ],
        "subclass": {
            "name": "Evocation",
            "description": "You focus your study on magic that creates powerful elemental effects such as bitter cold, searing flame, rolling thunder, crackling lightning, and burning acid. Some evokers find employment in military forces, serving as artillery to blast enemy armies from afar. Others use their spectacular power to protect the weak, while some seek their own gain as bandits, adventurers, or aspiring tyrants."
        },
        "features": [
            {
                "name": "Spellcasting: Wizard",
                "level": 1,
                "description": "As a student of arcane magic, you have a spellbook containing spells that show the first glimmerings of your true power."
            },
            {
                "name": "Arcane Recovery",
                "level": 1,
                "description": "You have learned to regain some of your magical energy by studying your spellbook. Once per day when you finish a short rest, you can choose expended spell slots to recover. The spell slots can have a combined level that is equal to or less than half your wizard level (rounded up), and none of the slots can be 6th level or higher.\nFor example, if you're a 4th-level wizard, you can recover up to two levels worth of spell slots. You can recover either a 2nd-level spell slot or two 1st-level spell slots."
            },
            {
                "name": "Arcane Tradition",
                "level": 2,
                "description": "When you reach 2nd level, you choose an arcane tradition, shaping your practice of magic through one of eight schools, such as Evocation.\nYour choice grants you features at 2nd level and again at 6th, 10th, and 14th level."
            },
            {
                "name": "Evocation Savant",
                "level": 2,
                "description": "Beginning when you select this school at 2nd level, the gold and time you must spend to copy an evocation spell into your spellbook is halved.",
                "subclass": "Evocation"
            },
            {
                "name": "Sculpt Spells",
                "level": 2,
                "description": "Beginning at 2nd level, you can create pockets of relative safety within the effects of your evocation spells. When you cast an evocation spell that affects other creatures that you can see, you can choose a number of them equal to 1 + the spell's level. The chosen creatures automatically succeed on their saving throws against the spell, and they take no damage if they would normally take half damage on a successful save.",
                "subclass": "Evocation"
            },
            {
                "name": "Ability Score Improvement",
                "level": 4,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Arcane Tradition feature",
                "level": 6,
                "description": "When you reach 2nd level, you choose an arcane tradition, shaping your practice of magic through one of eight schools, such as Evocation.\nYour choice grants you features at 2nd level and again at 6th, 10th, and 14th level."
            },
            {
                "name": "Potent Cantrip",
                "level": 6,
                "description": "Starting at 6th level, your damaging cantrips affect even creatures that avoid the brunt of the effect. When a creature succeeds on a saving throw against your cantrip, the creature takes half the cantrip's damage (if any) but suffers no additional effect from the cantrip.",
                "subclass": "Evocation"
            },
            {
                "name": "Ability Score Improvement",
                "level": 8,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Arcane Tradition feature",
                "level": 10,
                "description": "When you reach 2nd level, you choose an arcane tradition, shaping your practice of magic through one of eight schools, such as Evocation.\nYour choice grants you features at 2nd level and again at 6th, 10th, and 14th level."
            },
            {
                "name": "Empowered Evocation",
                "level": 10,
                "description": "Beginning at 10th level, you can add your Intelligence modifier to one damage roll of any wizard evocation spell you cast.",
                "subclass": "Evocation"
            },
            {
                "name": "Ability Score Improvement",
                "level": 12,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Arcane Tradition feature",
                "level": 14,
                "description": "When you reach 2nd level, you choose an arcane tradition, shaping your practice of magic through one of eight schools, such as Evocation.\nYour choice grants you features at 2nd level and again at 6th, 10th, and 14th level."
            },
            {
                "name": "Overchannel",
                "level": 14,
                "description": "Starting at 14th level, you can increase the power of your simpler spells. When you cast a wizard spell of 1st through 5th level that deals damage, you can deal maximum damage with that spell.\nThe first time you do so, you suffer no adverse effect. If you use this feature again before you finish a long rest, you take 2d12 necrotic damage for each level of the spell, immediately after you cast it. Each time you use this feature again before finishing a long rest, the necrotic damage per spell level increases by 1d12. This damage ignores resistance and immunity.",
                "subclass": "Evocation"
            },
            {
                "name": "Ability Score Improvement",
                "level": 16,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Spell Mastery",
                "level": 18,
                "description": "At 18th level, you have achieved such mastery over certain spells that you can cast them at will. Choose a 1st-level wizard spell and a 2nd-level wizard spell that are in your spellbook. You can cast those spells at their lowest level without expending a spell slot when you have them prepared. If you want to cast either spell at a higher level, you must expend a spell slot as normal.\nBy spending 8 hours in study, you can exchange one or both of the spells you chose for different spells of the same levels."
            },
            {
                "name": "Ability Score Improvement",
                "level": 19,
                "description": "When you reach 4th level, and again at 8th, 12th, 16th, and 19th level, you can increase one ability score of your choice by 2, or you can increase two ability scores of your choice by 1. As normal, you can't increase an ability score above 20 using this feature."
            },
            {
                "name": "Signature Spell",
                "level": 20,
                "description": "When you reach 20th level, you gain mastery over two powerful spells and can cast them with little effort. Choose two 3rd-level wizard spells in your spellbook as your signature spells. You always have these spells prepared, they don't count against the number of spells you have prepared, and you can cast each of them once at 3rd level without expending a spell slot. When you do so, you can't do so again until you finish a short or long rest.\nIf you want to cast either spell at a higher level, you must expend a spell slot as normal."
            }
        ],
        "levels": [
            {
                "level": 1,
                "proficiencyBonus": 2,
                "spellcasting": {
                    "cantripsKnown": 3,
                    "slots": {
                        "1": 2
                    }
                },
                "classSpecific": {
                    "arcane_recovery_levels": 1
                }
            },
            {
                "level": 2,
                "proficiencyBonus": 2,
                "spellcasting": {
                    "cantripsKnown": 3,
                    "slots": {
                        "1": 3
                    }
                },
                "classSpecific": {
                    "arcane_recovery_levels": 1
                }
            },
            {
                "level": 2
            },
            {
                "level": 3,
                "proficiencyBonus": 2,
                "spellcasting": {
                    "cantripsKnown": 3,
                    "slots": {
                        "1": 4,
                        "2": 2
                    }
                },
                "classSpecific": {
                    "arcane_recovery_levels": 2
                }
            },
            {
                "level": 4,
                "proficiencyBonus": 2,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "slots": {
                        "1": 4,
                        "2": 3
                    }
                },
                "classSpecific": {
                    "arcane_recovery_levels": 2
                }
            },
            {
                "level": 5,
                "proficiencyBonus": 3,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 2
                    }
                },
                "classSpecific": {
                    "arcane_recovery_levels": 3
                }
            },
            {
                "level": 6,
                "proficiencyBonus": 3,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3
                    }
                },
                "classSpecific": {
                    "arcane_recovery_levels": 3
                }
            },
            {
                "level": 6
            },
            {
                "level": 7,
                "proficiencyBonus": 3,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 1
                    }
                },
                "classSpecific": {
                    "arcane_recovery_levels": 4
                }
            },
            {
                "level": 8,
                "proficiencyBonus": 3,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 2
                    }
                },
                "classSpecific": {
                    "arcane_recovery_levels": 4
                }
            },
            {
                "level": 9,
                "proficiencyBonus": 4,
                "spellcasting": {
                    "cantripsKnown": 4,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 1
                    }
                },
                "classSpecific": {
                    "arcane_recovery_levels": 5
                }
            },
            {
                "level": 10,
                "proficiencyBonus": 4,
                "spellcasting": {
                    "cantripsKnown": 5,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2
                    }
                },
                "classSpecific": {
                    "arcane_recovery_levels": 5
                }
            },
            {
                "level": 10
            },
            {
                "level": 11,
                "proficiencyBonus": 4,
                "spellcasting": {
                    "cantripsKnown": 5,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2,
                        "6": 1
                    }
                },
                "classSpecific": {
                    "arcane_recovery_levels": 6
                }
            },
            {
                "level": 12,
                "proficiencyBonus": 4,
                "spellcasting": {
                    "cantripsKnown": 5,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2,
                        "6": 1
                    }
                },
                "classSpecific": {
                    "arcane_recovery_levels": 6
                }
            },
            {
                "level": 13,
                "proficiencyBonus": 5,
                "spellcasting": {
                    "cantripsKnown": 5,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2,
                        "6": 1,
                        "7": 1
                    }
                },
                "classSpecific": {
                    "arcane_recovery_levels": 7
                }
            },
            {
                "level": 14,
                "proficiencyBonus": 5,
                "spellcasting": {
                    "cantripsKnown": 5,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2,
                        "6": 1,
                        "7": 1
                    }
                },
                "classSpecific": {
                    "arcane_recovery_levels": 7
                }
            },
            {
                "level": 14
            },
            {
                "level": 15,
                "proficiencyBonus": 5,
                "spellcasting": {
                    "cantripsKnown": 5,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2,
                        "6": 1,
                        "7": 1,
                        "8": 1
                    }
                },
                "classSpecific": {
                    "arcane_recovery_levels": 8
                }
            },
            {
                "level": 16,
                "proficiencyBonus": 5,
                "spellcasting": {
                    "cantripsKnown": 5,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2,
                        "6": 1,
                        "7": 1,
                        "8": 1
                    }
                },
                "classSpecific": {
                    "arcane_recovery_levels": 8
                }
            },
            {
                "level": 17,
                "proficiencyBonus": 6,
                "spellcasting": {
                    "cantripsKnown": 5,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 2,
                        "6": 1,
                        "7": 1,
                        "8": 1,
                        "9": 1
                    }
                },
                "classSpecific": {
                    "arcane_recovery_levels": 9
                }
            },
            {
                "level": 18,
                "proficiencyBonus": 6,
                "spellcasting": {
                    "cantripsKnown": 5,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 3,
                        "6": 1,
                        "7": 1,
                        "8": 1,
                        "9": 1
                    }
                },
                "classSpecific": {
                    "arcane_recovery_levels": 9
                }
            },
            {
                "level": 19,
                "proficiencyBonus": 6,
                "spellcasting": {
                    "cantripsKnown": 5,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 3,
                        "6": 2,
                        "7": 1,
                        "8": 1,
                        "9": 1
                    }
                },
                "classSpecific": {
                    "arcane_recovery_levels": 10
                }
            },
            {
                "level": 20,
                "proficiencyBonus": 6,
                "spellcasting": {
                    "cantripsKnown": 5,
                    "slots": {
                        "1": 4,
                        "2": 3,
                        "3": 3,
                        "4": 3,
                        "5": 3,
                        "6": 2,
                        "7": 2,
                        "8": 1,
                        "9": 1
                    }
                },
                "classSpecific": {
                    "arcane_recovery_levels": 10
                }
            }
        ],
        "spellcastingAbility": "int"
    }
];
